import React, { useState, useRef, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import { IoRocketOutline, IoLayersOutline, IoChevronUp, IoChevronDown, IoCloudUploadOutline, IoArrowBack, IoCheckmarkCircle, IoWarning, IoDocumentText, IoStatsChart, IoClipboardOutline, IoFolderOpenOutline, IoGridOutline, IoBarChartOutline, IoClose, IoSearch, IoSaveOutline, IoHomeOutline, IoPricetagOutline, IoAttachOutline, IoCloseCircleOutline, IoTimeOutline } from "react-icons/io5";
import { HiOutlineDocumentText } from "react-icons/hi";
import { FiEdit2, FiAlertTriangle, FiClock, FiXCircle, FiCheckCircle, FiRefreshCw } from "react-icons/fi";
import { BsRobot } from "react-icons/bs";
import {createEmptySurveyQuestion, saveSurveyDraft, getSurveyById, deploySurveyTemplate, checkSurveyStatus, submitSurvey, uploadSurveyFile, deleteSurveyFile, getSurveyFiles, getEvidence, deleteEvidence, getAllAuditTemplates, getAllAudits, getAllSurveys, getAllSurveysTemplate, editAudit, createAudit, getAuditById, deleteAudit, getFindingsBySurvey, getActionsBySurvey, getAllSurveyFindings, getAllSurveyActions } from "../../store/actions/surveyActions";
import { getAllRisks_Report, createActionFromFinding, updateFinding, editAction } from "../../store/actions/riskActions";
import { getSOAControls, updateSOAControl } from "../../store/actions/soaActions";
import { addFindingsSurveyAIBatch, deleteFinding } from "../../store/actions/riskActions"
import LOADER from "../../assets/images/loader.svg";
import { RiTableFill, RiTableLine, RiGridFill, RiGridLine } from "react-icons/ri";
import { Clock, Calendar, CheckCircle2, AlertTriangle, MoreVertical, MessageSquare, CalendarDays, UserCircle2, CirclePoundSterling, KanbanSquare } from "lucide-react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from "../../components/ui/dialog";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../components/ui/select";
import { getUsers } from "../../store/actions/adminActions";
import Popup from 'reactjs-popup';
import {
    Users,
    BarChart2,
    Eye,
    Download
} from "lucide-react";
import SurveyCharts from "../../components/Audit/SurveyCharts"
import callOpenAIAPI, { callOpenAIAPISurveyFindings } from "../../utils/openAI"
import FindingOverlay from '../../components/Control/FindingOverlay';
import ActionOverlay from "../../components/Action/ActionOverlay";
import { ColumnsBlock } from "../../components/Report/Editor";
import { GanttChart } from "lucide-react";
import QuestionOverlay from "../../components/Surveys/QuestionOverlay"
import KanBanComponent from "../../components/Gantt/KanBan";
import { useTranslation } from "react-i18next";



const getAnswerDisplay = (answer) => {
    if (answer === "Evet") return { text: "Evet", color: "text-green-600", bgColor: "bg-green-100" };
    if (answer === "Hayir") return { text: "Hayır", color: "text-red-600", bgColor: "bg-red-100" };
    return { text: "Cevaplanmadı", color: "text-gray-500", bgColor: "bg-gray-100" };
};

// ISO 27001:2022 SOA Controls (93 controls)
const initialSOAControls = [
    // Organizasyonel Kontroller (5.1 - 5.37)
    { id: '1', controlId: '5.1', controlName: 'Bilgi Güvenliği Politikaları', category: 'Organizasyonel', description: 'Bilgi güvenliği için bir dizi politika tanımlanmalı, yönetim tarafından onaylanmalı, yayınlanmalı, ilgili personel ve ilgili taraflara iletilmeli ve onaylanmalı ve planlı aralıklarla ve önemli değişiklikler meydana geldiğinde gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-001', 'RISK-003'] },
    { id: '2', controlId: '5.2', controlName: 'Bilgi Güvenliği Rol ve Sorumlulukları', category: 'Organizasyonel', description: 'Bilgi güvenliği rol ve sorumlulukları, kuruluş ihtiyaçlarına göre tanımlanmalı ve tahsis edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-001'] },
    { id: '3', controlId: '5.3', controlName: 'Görev Ayrımı', category: 'Organizasyonel', description: 'Çelişen görevler ve sorumluluk alanları, kuruluşun varlıklarının yetkisiz veya kasıtsız değiştirilmesi veya kötüye kullanılması fırsatlarını azaltmak için ayrılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-012'] },
    { id: '4', controlId: '5.4', controlName: 'Yönetim Sorumlulukları', category: 'Organizasyonel', description: 'Yönetim, tüm personelin kuruluşun belirlenen bilgi güvenliği politikası, konuya özel politikaları ve prosedürleri doğrultusunda bilgi güvenliğini uygulamasını talep etmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '5', controlId: '5.5', controlName: 'Yetkililerle İletişim', category: 'Organizasyonel', description: 'Kuruluş, ilgili yetkililerle iletişimi kurmalı ve sürdürmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '6', controlId: '5.6', controlName: 'Özel İlgi Gruplarıyla İletişim', category: 'Organizasyonel', description: 'Kuruluş, özel ilgi grupları veya diğer uzman güvenlik forumları ve profesyonel derneklerle iletişimi kurmalı ve sürdürmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '7', controlId: '5.7', controlName: 'Tehdit İstihbaratı', category: 'Organizasyonel', description: 'Bilgi güvenliği tehditlerine ilişkin bilgiler toplanmalı ve tehdit istihbaratı üretmek için analiz edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-007', 'RISK-009', 'RISK-021'] },
    { id: '8', controlId: '5.8', controlName: 'Proje Yönetiminde Bilgi Güvenliği', category: 'Organizasyonel', description: 'Bilgi güvenliği, proje yönetimine entegre edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '9', controlId: '5.9', controlName: 'Bilgi ve Diğer İlişkili Varlıkların Envanteri', category: 'Organizasyonel', description: 'Sahipleri de dahil olmak üzere bilgi ve diğer ilişkili varlıkların bir envanteri geliştirilmeli ve sürdürülmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002', 'RISK-004'] },
    { id: '10', controlId: '5.10', controlName: 'Bilgi ve Diğer İlişkili Varlıkların Kabul Edilebilir Kullanımı', category: 'Organizasyonel', description: 'Bilgi ve diğer ilişkili varlıkların kabul edilebilir kullanımına ilişkin kurallar ve işleme prosedürleri tanımlanmalı, belgelendirilmeli ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-011'] },
    { id: '11', controlId: '5.11', controlName: 'Varlıkların İadesi', category: 'Organizasyonel', description: 'Personel ve uygun diğer ilgili taraflar, istihdam, sözleşme veya anlaşmalarının değişmesi veya sona ermesi üzerine ellerinde bulunan kuruluşa ait tüm varlıkları iade etmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '12', controlId: '5.12', controlName: 'Bilginin Sınıflandırılması', category: 'Organizasyonel', description: 'Bilgi, gizlilik, bütünlük, kullanılabilirlik ve ilgili taraf gereksinimlerine dayalı olarak kuruluşun bilgi güvenliği ihtiyaçlarına göre sınıflandırılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002', 'RISK-006'] },
    { id: '13', controlId: '5.13', controlName: 'Bilginin Etiketlenmesi', category: 'Organizasyonel', description: 'Kuruluş tarafından benimsenen bilgi sınıflandırma şemasına uygun olarak bilgi etiketleme için uygun bir prosedür seti geliştirilmeli ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-002'] },
    { id: '14', controlId: '5.14', controlName: 'Bilgi Transferi', category: 'Organizasyonel', description: 'Kuruluş içindeki ve kuruluş ile diğer taraflar arasındaki tüm aktarım tesisi türleri için bilgi aktarım kuralları, prosedürleri veya anlaşmaları yürürlükte olmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-008', 'RISK-013'] },
    { id: '15', controlId: '5.15', controlName: 'Erişim Kontrolü', category: 'Organizasyonel', description: 'Bilgiye ve diğer ilişkili varlıklara fiziksel ve mantıksal erişimi kontrol etmek için kurallar, iş ve bilgi güvenliği gereksinimlerine dayalı olarak oluşturulmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-010', 'RISK-012'] },
    { id: '16', controlId: '5.16', controlName: 'Kimlik Yönetimi', category: 'Organizasyonel', description: 'Kimliklerin tam yaşam döngüsü yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010'] },
    { id: '17', controlId: '5.17', controlName: 'Kimlik Doğrulama Bilgileri', category: 'Organizasyonel', description: 'Kimlik doğrulama bilgilerinin tahsisi ve yönetimi, personele kimlik doğrulama bilgilerinin uygun şekilde işlenmesi konusunda tavsiyelerde bulunmayı da içeren bir yönetim süreci tarafından kontrol edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010', 'RISK-015'] },
    { id: '18', controlId: '5.18', controlName: 'Erişim Hakları', category: 'Organizasyonel', description: 'Bilgiye ve diğer ilişkili varlıklara erişim hakları, kuruluşun erişim kontrolüne ilişkin konuya özel politikası ve kurallarına uygun olarak sağlanmalı, gözden geçirilmeli, değiştirilmeli ve kaldırılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-010'] },
    { id: '19', controlId: '5.19', controlName: 'Tedarikçi İlişkilerinde Bilgi Güvenliği', category: 'Organizasyonel', description: 'Tedarikçinin ürün veya hizmetlerinin kullanımıyla ilişkili bilgi güvenliği risklerini yönetmek için süreçler ve prosedürler tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016', 'RISK-017'] },
    { id: '20', controlId: '5.20', controlName: 'Tedarikçi Anlaşmalarında Bilgi Güvenliğinin Ele Alınması', category: 'Organizasyonel', description: 'İlgili bilgi güvenliği gereksinimleri, tedarikçi ilişkisinin türüne göre her tedarikçi ile kurulmalı ve üzerinde anlaşılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016'] },
    { id: '21', controlId: '5.21', controlName: 'BİT Tedarik Zincirinde Bilgi Güvenliğinin Yönetimi', category: 'Organizasyonel', description: 'BİT ürün ve hizmet tedarik zinciri ile ilişkili bilgi güvenliği risklerini yönetmek için süreçler ve prosedürler tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-016', 'RISK-022'] },
    { id: '22', controlId: '5.22', controlName: 'Tedarikçi Hizmetlerinin İzlenmesi, Gözden Geçirilmesi ve Değişiklik Yönetimi', category: 'Organizasyonel', description: 'Kuruluş, tedarikçi bilgi güvenliği uygulamalarını ve hizmet sunumunu düzenli olarak izlemeli, gözden geçirmeli, değerlendirmeli ve değişiklikleri yönetmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '23', controlId: '5.23', controlName: 'Bulut Hizmetlerinin Kullanımı için Bilgi Güvenliği', category: 'Organizasyonel', description: 'Bulut hizmetlerinin edinimi, kullanımı, yönetimi ve çıkışı için süreçler, kuruluşun bilgi güvenliği gereksinimlerine uygun olarak oluşturulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-014', 'RISK-016'] },
    { id: '24', controlId: '5.24', controlName: 'Bilgi Güvenliği Olay Yönetimi Planlama ve Hazırlık', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olay yönetimi süreçlerini, rollerini ve sorumluluklarını tanımlayarak, oluşturarak ve ileterek bilgi güvenliği olaylarını yönetmeye hazırlanmalı ve planlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019', 'RISK-020'] },
    { id: '25', controlId: '5.25', controlName: 'Bilgi Güvenliği Olaylarının Değerlendirilmesi ve Kararı', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olaylarını değerlendirmeli ve bunların bilgi güvenliği olayları olarak kategorize edilip edilmeyeceğine karar vermelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019'] },
    { id: '26', controlId: '5.26', controlName: 'Bilgi Güvenliği Olaylarına Müdahale', category: 'Organizasyonel', description: 'Bilgi güvenliği olaylarına, belgelenmiş prosedürlere uygun olarak müdahale edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-019', 'RISK-020'] },
    { id: '27', controlId: '5.27', controlName: 'Bilgi Güvenliği Olaylarından Öğrenme', category: 'Organizasyonel', description: 'Bilgi güvenliği olaylarından elde edilen bilgiler, bilgi güvenliği kontrollerini güçlendirmek ve iyileştirmek için kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '28', controlId: '5.28', controlName: 'Kanıt Toplama', category: 'Organizasyonel', description: 'Kuruluş, bilgi güvenliği olaylarıyla ilgili kanıtların tanımlanması, toplanması, edinilmesi ve korunması için prosedürler oluşturmalı ve uygulamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '29', controlId: '5.29', controlName: 'Kesinti Sırasında Bilgi Güvenliği', category: 'Organizasyonel', description: 'Kuruluş, kesinti sırasında bilgi güvenliğini uygun bir seviyede nasıl sürdüreceğini planlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '30', controlId: '5.30', controlName: 'İş Sürekliliği için BİT Hazırlığı', category: 'Organizasyonel', description: 'BİT hazırlığı, iş sürekliliği hedefleri ve BİT sürekliliği gereksinimlerine dayalı olarak planlanmalı, uygulanmalı, sürdürülmeli ve test edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '31', controlId: '5.31', controlName: 'Yasal, Kanuni, Düzenleyici ve Sözleşmesel Gereksinimler', category: 'Organizasyonel', description: 'Bilgi güvenliği ile ilgili yasal, kanuni, düzenleyici ve sözleşmesel gereksinimler ve kuruluşun bu gereksinimleri karşılama yaklaşımı tanımlanmalı, belgelendirilmeli ve güncel tutulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '32', controlId: '5.32', controlName: 'Fikri Mülkiyet Hakları', category: 'Organizasyonel', description: 'Kuruluş, fikri mülkiyet haklarını korumak için uygun prosedürler uygulamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '33', controlId: '5.33', controlName: 'Kayıtların Korunması', category: 'Organizasyonel', description: 'Kayıtlar, kayıp, imha, tahrifat, yetkisiz erişim ve yetkisiz yayınlanmaya karşı korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '34', controlId: '5.34', controlName: 'Gizlilik ve KKB\'nin Korunması', category: 'Organizasyonel', description: 'Kuruluş, geçerli yasa ve yönetmelikler ile sözleşmesel gereksinimlere göre gizliliğin korunması ve KKB\'nin korunmasına ilişkin gereksinimleri tanımlamalı ve karşılamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '35', controlId: '5.35', controlName: 'Bilgi Güvenliğinin Bağımsız İncelemesi', category: 'Organizasyonel', description: 'Kuruluşun bilgi güvenliğini yönetme yaklaşımı ve uygulaması planlı aralıklarla veya önemli değişiklikler meydana geldiğinde bağımsız olarak gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '36', controlId: '5.36', controlName: 'Bilgi Güvenliği için Politika, Kural ve Standartlara Uygunluk', category: 'Organizasyonel', description: 'Kuruluşun bilgi güvenliği politikasına, konuya özel politikalarına, kurallarına ve standartlarına uygunluk düzenli olarak gözden geçirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '37', controlId: '5.37', controlName: 'Belgelenmiş İşletim Prosedürleri', category: 'Organizasyonel', description: 'Bilgi işlem tesisleri için işletim prosedürleri belgelendirilmeli ve bunlara ihtiyaç duyan personele sunulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // İnsan Kontrolleri (6.1 - 6.8)
    { id: '38', controlId: '6.1', controlName: 'Tarama', category: 'İnsan', description: 'Personel olacak tüm adaylar üzerinde, kuruluşa katılmadan önce ve sürekli olarak, geçerli yasalar, yönetmelikler ve etik dikkate alınarak arka plan doğrulama kontrolleri yapılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '39', controlId: '6.2', controlName: 'İstihdam Hüküm ve Koşulları', category: 'İnsan', description: 'İstihdam sözleşme anlaşmaları, personelin ve kuruluşun bilgi güvenliği sorumluluklarını belirtmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '40', controlId: '6.3', controlName: 'Bilgi Güvenliği Farkındalığı, Eğitimi ve Öğretimi', category: 'İnsan', description: 'Kuruluşun personeli ve ilgili ilgili taraflar, iş fonksiyonları için uygun olduğu şekilde, kuruluşun bilgi güvenliği politikası hakkında uygun bilgi güvenliği farkındalığı, eğitimi ve öğretimi almalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '41', controlId: '6.4', controlName: 'Disiplin Süreci', category: 'İnsan', description: 'Bilgi güvenliği politikası ihlali yapan personel ve diğer ilgili taraflara karşı önlem almak için disiplin süreci resmileştirilmeli ve iletilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '42', controlId: '6.5', controlName: 'İstihdamın Sona Ermesi veya Değişikliği Sonrası Sorumluluklar', category: 'İnsan', description: 'İstihdamın sona ermesi veya değişikliği sonrasında geçerli kalan bilgi güvenliği sorumlulukları ve görevleri tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '43', controlId: '6.6', controlName: 'Gizlilik veya Açıklamama Anlaşmaları', category: 'İnsan', description: 'Kuruluşun bilginin korunması ihtiyaçlarını yansıtan gizlilik veya açıklamama anlaşmaları tanımlanmalı ve belgelendirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '44', controlId: '6.7', controlName: 'Uzaktan Çalışma', category: 'İnsan', description: 'Personel uzaktan çalışırken, kuruluşun tesisleri dışında erişilen, işlenen veya depolanan bilgileri korumak için güvenlik önlemleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '45', controlId: '6.8', controlName: 'Bilgi Güvenliği Olaylarının Raporlanması', category: 'İnsan', description: 'Kuruluş, personelin gözlemlenen veya şüphelenilen bilgi güvenliği olaylarını uygun kanallar aracılığıyla zamanında raporlaması için bir mekanizma sağlamalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // Fiziksel Kontroller (7.1 - 7.14)
    { id: '46', controlId: '7.1', controlName: 'Fiziksel Güvenlik Çevreleri', category: 'Fiziksel', description: 'Bilgi ve diğer ilişkili varlıkları içeren alanları korumak için güvenlik çevreleri tanımlanmalı ve kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '47', controlId: '7.2', controlName: 'Fiziksel Giriş', category: 'Fiziksel', description: 'Güvenli alanlar, uygun giriş kontrolleri ve erişim noktaları ile korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '48', controlId: '7.3', controlName: 'Ofis, Oda ve Tesislerin Güvenliğinin Sağlanması', category: 'Fiziksel', description: 'Ofisler, odalar ve tesisler için fiziksel güvenlik tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '49', controlId: '7.4', controlName: 'Fiziksel Güvenlik İzleme', category: 'Fiziksel', description: 'Tesisler, yetkisiz fiziksel erişim için sürekli olarak izlenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '50', controlId: '7.5', controlName: 'Fiziksel ve Çevresel Tehditlere Karşı Koruma', category: 'Fiziksel', description: 'Doğal afetler ve diğer kasıtlı veya kasıtsız fiziksel tehditler gibi fiziksel ve çevresel tehditlere karşı altyapı koruması tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '51', controlId: '7.6', controlName: 'Güvenli Alanlarda Çalışma', category: 'Fiziksel', description: 'Güvenli alanlarda çalışma için güvenlik önlemleri tasarlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '52', controlId: '7.7', controlName: 'Temiz Masa ve Temiz Ekran', category: 'Fiziksel', description: 'Kağıtlar ve çıkarılabilir depolama ortamları için temiz masa kuralları ve bilgi işlem tesisleri için temiz ekran kuralları tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '53', controlId: '7.8', controlName: 'Ekipman Yerleştirme ve Koruma', category: 'Fiziksel', description: 'Ekipman güvenli bir şekilde yerleştirilmeli ve korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '54', controlId: '7.9', controlName: 'Tesis Dışı Varlıkların Güvenliği', category: 'Fiziksel', description: 'Tesis dışı varlıklar korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '55', controlId: '7.10', controlName: 'Depolama Ortamı', category: 'Fiziksel', description: 'Depolama ortamı, kuruluşun sınıflandırma şeması ve işleme gereksinimlerine uygun olarak yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '56', controlId: '7.11', controlName: 'Destekleyici Hizmetler', category: 'Fiziksel', description: 'Bilgi işlem tesisleri, güç kesintilerinden ve destekleyici hizmetlerdeki arızalardan kaynaklanan diğer kesintilerden korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '57', controlId: '7.12', controlName: 'Kablolama Güvenliği', category: 'Fiziksel', description: 'Güç, veri veya bilgi hizmetlerini destekleyen kablolar dinleme, müdahale veya hasardan korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '58', controlId: '7.13', controlName: 'Ekipman Bakımı', category: 'Fiziksel', description: 'Ekipman, bilginin kullanılabilirliğini, bütünlüğünü ve gizliliğini sağlamak için doğru şekilde bakımı yapılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '59', controlId: '7.14', controlName: 'Ekipmanın Güvenli İmhası veya Yeniden Kullanımı', category: 'Fiziksel', description: 'Depolama ortamı içeren ekipman öğeleri, imha veya yeniden kullanımdan önce doğrulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    // Teknolojik Kontroller (8.1 - 8.34)
    { id: '60', controlId: '8.1', controlName: 'Kullanıcı Uç Nokta Cihazları', category: 'Teknolojik', description: 'Kullanıcı uç nokta cihazlarında depolanan, işlenen veya bunlar aracılığıyla erişilebilen bilgiler korunmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '61', controlId: '8.2', controlName: 'Ayrıcalıklı Erişim Hakları', category: 'Teknolojik', description: 'Ayrıcalıklı erişim haklarının tahsisi ve kullanımı kısıtlanmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-012'] },
    { id: '62', controlId: '8.3', controlName: 'Bilgi Erişim Kısıtlaması', category: 'Teknolojik', description: 'Bilgiye ve diğer ilişkili varlıklara erişim, oluşturulan erişim kontrolüne ilişkin konuya özel politikaya uygun olarak kısıtlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-005', 'RISK-006'] },
    { id: '63', controlId: '8.4', controlName: 'Kaynak Koduna Erişim', category: 'Teknolojik', description: 'Kaynak kod, geliştirme araçları ve yazılım kütüphanelerine okuma ve yazma erişimi uygun şekilde yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-023'] },
    { id: '64', controlId: '8.5', controlName: 'Güvenli Kimlik Doğrulama', category: 'Teknolojik', description: 'Güvenli kimlik doğrulama teknolojileri ve prosedürleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-010', 'RISK-015'] },
    { id: '65', controlId: '8.6', controlName: 'Kapasite Yönetimi', category: 'Teknolojik', description: 'Kaynakların kullanımı, mevcut ve beklenen kapasite gereksinimlerine uygun olarak izlenmeli ve ayarlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '66', controlId: '8.7', controlName: 'Kötü Amaçlı Yazılımlara Karşı Koruma', category: 'Teknolojik', description: 'Kötü amaçlı yazılımlara karşı koruma uygulanmalı ve uygun kullanıcı farkındalığı ile desteklenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-007', 'RISK-009'] },
    { id: '67', controlId: '8.8', controlName: 'Teknik Zafiyetlerin Yönetimi', category: 'Teknolojik', description: 'Kullanımdaki bilgi sistemlerinin teknik zafiyetleri hakkında bilgi elde edilmeli ve uygun önlemler alınmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-021', 'RISK-024'] },
    { id: '68', controlId: '8.9', controlName: 'Konfigürasyon Yönetimi', category: 'Teknolojik', description: 'Donanım, yazılım, hizmetler ve ağların güvenlik konfigürasyonları oluşturulmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-024'] },
    { id: '69', controlId: '8.10', controlName: 'Bilgi Silme', category: 'Teknolojik', description: 'Bilgi sistemlerinde depolanan bilgiler, artık gerekli olmadığında silinmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '70', controlId: '8.11', controlName: 'Veri Maskeleme', category: 'Teknolojik', description: 'Veri maskeleme, kuruluşun erişim kontrolüne ilişkin konuya özel politikasına uygun olarak kullanılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '71', controlId: '8.12', controlName: 'Veri Sızıntısı Önleme', category: 'Teknolojik', description: 'Hassas bilgileri işleyen sistemlere veri sızıntısı önleme önlemleri uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-008', 'RISK-013'] },
    { id: '72', controlId: '8.13', controlName: 'Bilgi Yedekleme', category: 'Teknolojik', description: 'Bilgi, yazılım ve sistemlerin yedek kopyaları sürdürülmeli ve düzenli olarak test edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: ['RISK-020', 'RISK-025'] },
    { id: '73', controlId: '8.14', controlName: 'Bilgi İşlem Tesislerinin Yedekliliği', category: 'Teknolojik', description: 'Bilgi işlem tesisleri, kullanılabilirlik gereksinimlerini karşılamaya yeterli yedeklilik ile uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '74', controlId: '8.15', controlName: 'Günlük Kaydı', category: 'Teknolojik', description: 'Aktiviteleri, istisnaları, hataları ve diğer ilgili olayları kaydeden günlükler üretilmeli ve analiz edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '75', controlId: '8.16', controlName: 'İzleme Faaliyetleri', category: 'Teknolojik', description: 'Ağlar, sistemler ve uygulamalar anormal davranışlar için izlenmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '76', controlId: '8.17', controlName: 'Saat Senkronizasyonu', category: 'Teknolojik', description: 'Kuruluş tarafından kullanılan bilgi işlem sistemlerinin saatleri, onaylanmış zaman kaynaklarıyla senkronize edilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '77', controlId: '8.18', controlName: 'Ayrıcalıklı Yardımcı Programların Kullanımı', category: 'Teknolojik', description: 'Sistem ve uygulama kontrollerini geçersiz kılabilen yardımcı programların kullanımı kısıtlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '78', controlId: '8.19', controlName: 'İşletim Sistemlerine Yazılım Kurulumu', category: 'Teknolojik', description: 'İşletim sistemlerine yazılım kurulumunu güvenli bir şekilde yönetmek için prosedürler uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '79', controlId: '8.20', controlName: 'Ağlar Güvenliği', category: 'Teknolojik', description: 'Ağlar ve ağ cihazları, sistemlerdeki ve uygulamalardaki bilgileri korumak için güvenli hale getirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '80', controlId: '8.21', controlName: 'Ağ Hizmetlerinin Güvenliği', category: 'Teknolojik', description: 'Ağ hizmetlerinin güvenlik mekanizmaları, hizmet seviyeleri ve gereksinimleri tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '81', controlId: '8.22', controlName: 'Ağların Ayrılması', category: 'Teknolojik', description: 'Bilgi hizmeti grupları, kullanıcılar ve bilgi sistemleri, kuruluşun ağlarında ayrılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '82', controlId: '8.23', controlName: 'Web Filtreleme', category: 'Teknolojik', description: 'Kötü amaçlı içeriğe maruz kalmayı azaltmak için harici web sitelerine erişim yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '83', controlId: '8.24', controlName: 'Kriptografinin Kullanımı', category: 'Teknolojik', description: 'Kriptografik anahtar yönetimi de dahil olmak üzere kriptografinin etkili kullanımına ilişkin kurallar tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '84', controlId: '8.25', controlName: 'Güvenli Geliştirme Yaşam Döngüsü', category: 'Teknolojik', description: 'Yazılım ve sistemlerin güvenli geliştirilmesi için kurallar oluşturulmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '85', controlId: '8.26', controlName: 'Uygulama Güvenliği Gereksinimleri', category: 'Teknolojik', description: 'Uygulama geliştirirken veya edinirken bilgi güvenliği gereksinimleri tanımlanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '86', controlId: '8.27', controlName: 'Güvenli Sistem Mimarisi ve Mühendislik İlkeleri', category: 'Teknolojik', description: 'Güvenli sistem mühendisliği için ilkeler oluşturulmalı ve belgelendirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '87', controlId: '8.28', controlName: 'Güvenli Kodlama', category: 'Teknolojik', description: 'Güvenli kodlama ilkeleri yazılım geliştirmeye uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '88', controlId: '8.29', controlName: 'Geliştirme ve Kabul Aşamasında Güvenlik Testi', category: 'Teknolojik', description: 'Güvenlik test süreçleri, geliştirme yaşam döngüsünde tanımlanmalı ve uygulanmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '89', controlId: '8.30', controlName: 'Dış Kaynaklı Geliştirme', category: 'Teknolojik', description: 'Kuruluş, dış kaynaklı sistem geliştirmeyle ilgili faaliyetleri yönlendirmeli ve izlemelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '90', controlId: '8.31', controlName: 'Geliştirme, Test ve Üretim Ortamlarının Ayrılması', category: 'Teknolojik', description: 'Geliştirme, test ve üretim ortamları ayrılmalı ve güvenli hale getirilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '91', controlId: '8.32', controlName: 'Değişiklik Yönetimi', category: 'Teknolojik', description: 'Bilgi işlem tesislerinde ve bilgi sistemlerinde yapılan değişiklikler, değişiklik yönetimi prosedürlerine tabi olmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '92', controlId: '8.33', controlName: 'Test Bilgisi', category: 'Teknolojik', description: 'Test bilgisi uygun şekilde seçilmeli, korunmalı ve yönetilmelidir.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
    { id: '93', controlId: '8.34', controlName: 'Denetim Testi Sırasında Bilgi Sistemlerinin Korunması', category: 'Teknolojik', description: 'İşletim sistemlerinin değerlendirmesini içeren denetim testleri planlanmalı ve üzerinde anlaşılmalıdır.', applicable: true, justification: '', implementationStatus: 'not-set', riskIds: [] },
];

// Category badge color helper
const getCategoryBadgeClass = (category) => {
    switch (category) {
        case 'Organizasyonel': return 'bg-blue-100 text-blue-700 border-blue-200';
        case 'İnsan': return 'bg-purple-100 text-purple-700 border-purple-200';
        case 'Fiziksel': return 'bg-orange-100 text-orange-700 border-orange-200';
        case 'Teknolojik': return 'bg-green-100 text-green-700 border-green-200';
        default: return 'bg-gray-100 text-gray-700 border-gray-200';
    }
};

// Implementation status options
const implementationStatusOptions = [
    { value: 'not-set', label: 'Belirlenmedi', color: 'bg-gray-100 text-gray-600' },
    { value: 'implemented', label: 'Uygulandı', color: 'bg-green-100 text-green-700' },
    { value: 'partial', label: 'Kısmen Uygulandı', color: 'bg-yellow-100 text-yellow-700' },
    { value: 'planned', label: 'Planlandı', color: 'bg-blue-100 text-blue-700' },
    { value: 'not-implemented', label: 'Uygulanmadı', color: 'bg-red-100 text-red-700' },
];

const getImplementationStatusDisplay = (status) => {
    const option = implementationStatusOptions.find(o => o.value === status);
    return option || implementationStatusOptions[0];
};

 const TrashIcon = ({ className = "w-4 h-4" }) => (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M3 6h18" />
            <path d="M8 6V4h8v2" />
            <path d="M19 6l-1 14H6L5 6" />
            <path d="M10 11v6" />
            <path d="M14 11v6" />
        </svg>
    );

function FileUploadSection({ questionId, files, onFilesChange, onFileUpload, onFileRemove, survey_id }) {
    const [isDragging, setIsDragging] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [activeUploadTab, setActiveUploadTab] = useState('manuel'); // 'manuel' or 'raboya'

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = async (e) => {
        e.preventDefault();
        setIsDragging(false);
        const droppedFiles = Array.from(e.dataTransfer.files);
        await uploadFiles(droppedFiles);
    };

    const handleFileSelect = async (e) => {
        const selectedFiles = Array.from(e.target.files);
        await uploadFiles(selectedFiles);
        e.target.value = ''; // Reset input
    };

    const uploadFiles = async (filesToUpload) => {
        setUploading(true);
        try {
            for (const file of filesToUpload) {
                const result = await onFileUpload(file, questionId, survey_id);
                if (result.success) {
                    // Add the uploaded file info to state
                    const uploadedFile = {
                        name: result.fileName || file.name,
                        size: file.size,
                        url: result.file,
                        uploaded: true
                    };
                    onFilesChange(questionId, [...(files || []), uploadedFile]);
                }
            }
        } catch (error) {
            console.error("Error uploading files:", error);
        } finally {
            setUploading(false);
        }
    };

    const removeFile = async (index) => {
        const file = files[index];
        if (file.id && onFileRemove) {
            try {
                await onFileRemove(file.id);
            } catch (error) {
                console.error("Error removing file:", error);
            }
        }
        const newFiles = [...files];
        newFiles.splice(index, 1);
        onFilesChange(questionId, newFiles);
    };

    const handleRaboyaAsk = () => {
        // Dummy function - does nothing for now
        ////////console.log("Raboya'ya Sor clicked - feature coming soon");
    };

    return (
        <div className="mt-4 bg-gray-50 rounded-lg p-4 border border-gray-200">
            <div className="flex items-center gap-2 mb-2">
                <HiOutlineDocumentText className="text-gray-600" size={20} />
                <span className="font-medium text-gray-800">Kanıt Toplama</span>
            </div>
            <p className="text-sm text-gray-500 mb-3">Manuel yükleme veya AI destekli otomatik kanıt toplama</p>

            {/* Tabs - Manuel Yükleme and Raboya Sor */}
            <div className="flex items-center gap-4 mb-4 border-b border-gray-200">
                <button
                    onClick={() => setActiveUploadTab('manuel')}
                    className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${activeUploadTab === 'manuel'
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'
                        }`}
                >
                    <IoCloudUploadOutline size={18} />
                    Manuel Yükleme
                </button>
                <button
                    onClick={() => setActiveUploadTab('raboya')}
                    className={`flex items-center gap-2 px-3 py-2 font-medium text-sm transition-colors ${activeUploadTab === 'raboya'
                        ? 'text-blue-600 border-b-2 border-blue-600'
                        : 'text-gray-500 hover:text-gray-700 border-b-2 border-transparent'
                        }`}
                >
                    <BsRobot size={18} />
                    Raboya Sor
                </button>
            </div>

            {/* Manuel Yükleme Tab Content */}
            {activeUploadTab === 'manuel' && (
                <>
                    {/* Upload Area */}
                    <div
                        className={`border-2 border-dashed rounded-lg p-8 text-center transition-colors ${isDragging ? "border-blue-400 bg-blue-50" : "border-gray-300 bg-white"
                            } ${uploading ? "opacity-50 pointer-events-none" : ""}`}
                        onDragOver={handleDragOver}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >
                        <div className="flex flex-col items-center">
                            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
                                <IoCloudUploadOutline size={32} className="text-gray-400" />
                            </div>
                            {uploading ? (
                                <p className="text-gray-700 mb-3">Yükleniyor...</p>
                            ) : (
                                <p className="text-gray-700 mb-3">Dosyaları buraya sürükleyin veya</p>
                            )}
                            <label className={`cursor-pointer ${uploading ? "pointer-events-none" : ""}`}>
                                <span className="bg-blue-600 text-white px-6 py-2 rounded-lg font-medium hover:bg-blue-700 transition-colors inline-flex items-center gap-2">
                                    <IoCloudUploadOutline size={18} />
                                    {uploading ? "Yükleniyor..." : "Dosya Seç"}
                                </span>
                                <input
                                    type="file"
                                    multiple
                                    className="hidden"
                                    onChange={handleFileSelect}
                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg,.gif,.zip"
                                    disabled={uploading}
                                />
                            </label>
                            <p className="text-sm text-gray-500 mt-3">PDF, Word, Excel, Resim, ZIP dosyaları desteklenir</p>
                        </div>
                    </div>

                    {/* Uploaded Files List */}
                    {files && files.length > 0 && (
                        <div className="mt-4 space-y-2">
                            {files.map((file, index) => (
                                <div key={index} className="flex items-center justify-between bg-white border border-gray-200 rounded-lg px-3 py-2">
                                    <div className="flex items-center gap-2">
                                        <HiOutlineDocumentText className="text-gray-500" size={18} />
                                        <span className="text-sm text-gray-700">{file.name}</span>
                                        {file.size && <span className="text-xs text-gray-400">({(file.size / 1024).toFixed(1)} KB)</span>}
                                        {file.uploaded && <span className="text-xs text-green-600">✓ Yüklendi</span>}
                                    </div>
                                    <button
                                        onClick={() => removeFile(index)}
                                        className="text-red-500 hover:text-red-700 text-sm"
                                    >
                                        Kaldır
                                    </button>
                                </div>
                            ))}
                        </div>
                    )}
                </>
            )}

            {/* Raboya Sor Tab Content */}
            {activeUploadTab === 'raboya' && (
                <div className="bg-white rounded-lg p-6 border border-gray-200">
                    <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-blue-50 rounded-xl flex items-center justify-center flex-shrink-0">
                            <BsRobot size={28} className="text-blue-600" />
                        </div>
                        <div className="flex-1">
                            <h4 className="text-lg font-semibold text-gray-900 mb-2">Raboya ile Kanıt Toplama</h4>
                            <p className="text-gray-600 text-sm leading-relaxed mb-4">
                                Raboya AI asistanı, bağlı GRC araçlarınızdan (örn: Compliance Manager, Risk Register) bu kontrole uygun kanıtları otomatik olarak bulup toplayacak.
                            </p>
                            <button
                                onClick={handleRaboyaAsk}
                                className="inline-flex items-center gap-2 bg-blue-600 text-white px-5 py-2.5 rounded-lg font-medium hover:bg-blue-700 transition-colors"
                            >
                                <BsRobot size={18} />
                                Raboya'ya Sor
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

function QuestionItem({
    question,
    answer,
    onAnswerChange,
    files,
    onFilesChange,
    onFileUpload,
    onFileRemove,
    survey_id,
    openQuestionFN,
}) {
    //////console.log(question)
    return (
        <div className="py-4 border-b border-gray-100 last:border-b-0">
            <div className="flex items-start justify-between gap-3 mb-2">
                <label className="block text-gray-800">
                    {question.text} <span className="text-red-500">*</span>
                </label>

                <button
                    type="button"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();

                        const id = question.question_id ?? question.id; // supports both shapes
                        if (!id) return;

                        openQuestionFN(id); // ✅ calls backend action
                    }}
                    className="shrink-0 px-3 py-1.5 rounded-md text-sm font-medium bg-blue-600 hover:bg-blue-700 text-white"
                >
                    Open
                </button>
            </div>

            <div className="relative">
                <select
                    value={answer || ""}
                    onChange={(e) => onAnswerChange(question.question_id, e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg appearance-none bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                >
                    <option value="">Seçiniz</option>
                    <option value="evet">Evet</option>
                    <option value="hayir">Hayır</option>
                </select>
                <IoChevronDown
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"
                    size={20}
                />
            </div>

            {/* Show file upload only when Evet is selected */}
            {answer === "evet" && (
                <FileUploadSection
                    questionId={question.id}
                    files={files}
                    onFilesChange={onFilesChange}
                    onFileUpload={onFileUpload}
                    onFileRemove={onFileRemove}
                    survey_id={survey_id}
                />
            )}
        </div>
    );
}

function QuestionRow({ question, answer, openQuestionFN, isCustomFramework, onDelete }) {
  const qid = question.question_id ?? question.id;

  const owners = Array.isArray(question.owners) && question.owners.length > 0
    ? question.owners
    : question.owner_name || question.owner_user_id
      ? [{
          first_name: question.first_name || "",
          last_name: question.last_name || "",
          owner_name: question.owner_name || `${question.first_name || ""} ${question.last_name || ""}`.trim(),
          avatar: question.avatar || "",
        }]
      : [];

  const statusRaw = question.question_review_status || "Pending";
  const statusLabel = statusRaw === "Accepted" ? "Pass" : statusRaw === "Rejected" ? "Fail" : "Pending";

  const statusCls =
    statusRaw === "Accepted"
      ? "bg-emerald-100 text-emerald-700"
      : statusRaw === "Rejected"
        ? "bg-red-100 text-red-700"
        : "bg-gray-100 text-gray-700";

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => qid && openQuestionFN(qid)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") qid && openQuestionFN(qid);
      }}
      className="grid grid-cols-[2fr_0.8fr_110px_130px] items-center gap-3 px-4 py-3 bg-white border-b border-gray-100 hover:bg-gray-50 cursor-pointer"
    >
      {/* Question */}
      <div className="text-sm font-medium text-gray-900 line-clamp-2">
        {question.text}
      </div>

      {/* Answer preview */}
      <div className="text-sm text-gray-700 line-clamp-2">
        {question.answer ? question.answer : <span className="text-gray-400">—</span>}
      </div>

      {/* Owners */}
      <div className="flex items-center">
        {owners.length > 0 ? (
          <div className="flex -space-x-2">
            {owners.slice(0, 4).map((o, i) => {
              const name = o.owner_name || o.label || `${o.first_name || ""} ${o.last_name || ""}`.trim();
              return (
                <div key={i} style={{ zIndex: owners.length - i }}>
                  <Avatar name={name} src={o.avatar || ""} size={28} />
                </div>
              );
            })}
            {owners.length > 4 && (
              <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-200 text-gray-600 text-xs font-medium"
                style={{ width: 28, height: 28 }}
                title={`${owners.length - 4} more`}
              >
                +{owners.length - 4}
              </div>
            )}
          </div>
        ) : (
          <span className="text-gray-400 text-xs">—</span>
        )}
      </div>

      {/* Status pill + delete */}
      <div className="flex items-center justify-between gap-2">
        <span className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${statusCls}`}>
          {statusLabel}
        </span>

        {isCustomFramework && qid && typeof onDelete === "function" && (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation(); // ✅ don’t open the question modal
              onDelete(qid);
            }}
            className="h-9 w-9 inline-flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:text-red-600 hover:border-red-200 hover:bg-red-50"
            title="Delete question"
            aria-label="Delete question"
          >
            <TrashIcon />
          </button>
        )}
      </div>
    </div>
  );
}



const getAuditStatus = ({ start_date, end_date, progress }) => {
    const toDate = (v) => {
        if (!v) return null;
        // supports "YYYY-MM-DD"
        const d = new Date(`${v}T00:00:00`);
        return Number.isNaN(d.getTime()) ? null : d;
    };

    const today = new Date();
    const t = new Date(today.getFullYear(), today.getMonth(), today.getDate()); // midnight local

    const start = toDate(start_date);
    const end = toDate(end_date);

    const p = Number(progress ?? 0);
    if (p >= 100) return "complete";

    if (start && start > t) return "planned";

    if (end && t > end) return "overdue";

    if (start && (!end || t <= end)) return "in_progress";

    return "planned";
};

const statusMeta = (status, t) => {
    switch (status) {
        case "complete":
            return { label: t("auditPlanning.badges.completed"), pill: "bg-emerald-50 text-emerald-700 border-emerald-200" };
        case "planned":
            return { label: t("auditPlanning.badges.planned"), pill: "bg-slate-50 text-slate-700 border-slate-200" };
        case "overdue":
            return { label: t("auditPlanning.badges.overdue"), pill: "bg-red-50 text-red-700 border-red-200" };
        case "in_progress":
        default:
            return { label: t("auditPlanning.badges.inProgress"), pill: "bg-blue-50 text-blue-700 border-blue-200" };
    }
};

const CreateAuditDialog = ({
    open,
    onOpenChange,
    departments = [],
    complianceStandards = [],
    surveys = [],
    onSubmit,
    users,
    createAuditFN,
    getAllSurveysFN,
    getAllAuditsFN,
    auditTemplates
}) => {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const [form, setForm] = React.useState({
        title: "",
        description: "",
        department_id: "",
        compliance_id: "",
        survey_id: "",
        progress: 0,
        audit_template_id: "",
        start_date: "",
        end_date: "",
        audit_type: "internal",      // enum: internal/external/compliance/follow_up
        audit_scope: "",
        audit_objectives: "",
        auditors: [],
    });

    const reset = () => {
        setForm({
            title: "",
            description: "",
            department_id: "",
            compliance_id: "",
            survey_id: "",
            progress: 0,
            start_date: "",
            end_date: "",
        });
    };

    const computedStatus = React.useMemo(() => {
        return getAuditStatus({
            start_date: form.start_date,
            end_date: form.end_date,
            progress: form.progress, // if you still keep it in state/db; otherwise remove and status will be date-only
        });
    }, [form.start_date, form.end_date, form.progress]);

    const { label: statusLabel, pill: statusPill } = statusMeta(computedStatus, t);


    const handleClose = (nextOpen) => {
        // nextOpen is boolean from shadcn Dialog
        if (!nextOpen) {
            onOpenChange(false);
            reset();
        } else {
            onOpenChange(true);
        }
    };

    const handleSubmit = async () => {
        try {
            if (!form.title.trim()) return;
            if (!form.department_id && !form.compliance_id) return;
            if (!form.audit_template_id) return;

            setIsSubmitting(true);

            const payload = {
                title: form.title.trim(),
                description: form.description?.trim() || null,
                department_id: Number(form.department_id),
                //survey_id: Number(form.survey_id),
                compliance_id: Number(form.compliance_id),
                audit_template_id: Number(form.audit_template_id),
                audit_type: form.audit_type || "internal",
                audit_scope: form.audit_scope?.trim() || null,
                audit_objectives: form.audit_objectives?.trim() || null,

                auditors: Array.isArray(form.auditors)
                    ? form.auditors.map((id) => Number(id))
                    : null,

                start_date: form.start_date || null,
                end_date: form.end_date || null,
            };
            //////console.log("payload ", payload)

            await createAuditFN(payload);
            await getAllSurveysFN()
            await getAllAuditsFN()
            onOpenChange(false);
            reset();
        } finally {
            setIsSubmitting(false);
        }
    };



    return (
        <Dialog open={open} onOpenChange={handleClose}>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{t("auditPlanning.modal.addTitle")}</DialogTitle>
                </DialogHeader>

                <div className="space-y-6">
                    {/* Basic Information */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.basicInformation")}</h3>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2 col-span-2">
                                <Label htmlFor="auditTitle">
                                    {t("auditPlanning.modal.auditTitle")} <span className="text-red-500">*</span>
                                </Label>
                                <Input
                                    id="auditTitle"
                                    placeholder={t("auditPlanning.modal.auditTitlePlaceholder")}
                                    value={form.title}
                                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="auditDesc">{t("auditPlanning.modal.description")}</Label>
                            <Textarea
                                id="auditDesc"
                                placeholder={t("auditPlanning.modal.descriptionPlaceholder")}
                                value={form.description}
                                onChange={(e) => setForm({ ...form, description: e.target.value })}
                                rows={4}
                            />
                        </div>
                    </div>

                    {/* Scope */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.scope")}</h3>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <Label>
                                    {t("auditPlanning.modal.department")} <span className="text-red-500">*</span>
                                </Label>
                                <Select
                                    value={
                                        form.department_id
                                            ? `dep:${form.department_id}`
                                            : form.compliance_id
                                                ? `comp:${form.compliance_id}`
                                                : undefined
                                    }
                                    onValueChange={(value) => {
                                        if (value.startsWith("dep:")) {
                                            const id = Number(value.replace("dep:", ""));
                                            setForm({
                                                ...form,
                                                department_id: id,
                                                compliance_id: null,
                                            });
                                        }

                                        if (value.startsWith("comp:")) {
                                            const id = Number(value.replace("comp:", ""));
                                            setForm({
                                                ...form,
                                                compliance_id: id,
                                                department_id: null,
                                            });
                                        }
                                    }}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.departmentPlaceholder")} />
                                    </SelectTrigger>

                                    <SelectContent>

                                        {/* ===== Departments ===== */}
                                        <div className="px-2 py-1 text-xs font-semibold text-gray-400">
                                            Departments
                                        </div>

                                        {departments.map((d) => {
                                            const deptName =
                                                d.name || d.title || d.department_name || `Dept ${d.department_id}`;
                                            const label = d.company_name
                                                ? `${deptName} • ${d.company_name}`
                                                : deptName;

                                            return (
                                                <SelectItem
                                                    key={`dep-${d.department_id}`}
                                                    value={`dep:${d.department_id}`}
                                                    textValue={label}
                                                >
                                                    <div className="flex flex-col">
                                                        <span className="text-sm text-gray-900">{deptName}</span>
                                                        {d.company_name && (
                                                            <span className="text-xs text-gray-400">
                                                                {d.company_name}
                                                            </span>
                                                        )}
                                                    </div>
                                                </SelectItem>
                                            );
                                        })}

                                        {/* ===== Compliance Standards ===== */}
                                        <div className="px-2 py-1 mt-2 text-xs font-semibold text-gray-400">
                                            {t("auditPlanning.modal.complianceStandardsGroup")}
                                        </div>

                                        {complianceStandards.map((c) => (
                                            <SelectItem
                                                key={`comp-${c.compliance_id}`}
                                                value={`comp:${c.compliance_id}`}
                                                textValue={`${c.name} ${c.company_name || ""}`}
                                            >
                                                <div className="flex items-center justify-between gap-3">
                                                    <div className="flex flex-col">
                                                        <span className="text-sm text-gray-900 flex items-center gap-2">
                                                            {c.name}
                                                            <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-indigo-50 text-indigo-600">
                                                            {t("auditPlanning.modal.complianceBadge")}
                                                            </span>
                                                        </span>

                                                        {c.company_name && (
                                                            <span className="text-xs text-gray-400">
                                                                {c.company_name}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </SelectItem>
                                        ))}


                                    </SelectContent>
                                </Select>


                            </div>

                            <div className="space-y-2">
                                <Label>
                                    {t("auditPlanning.modal.auditTemplate")} <span className="text-red-500">*</span>
                                </Label>

                                <Select
                                    value={form.audit_template_id ? String(form.audit_template_id) : ""}
                                    onValueChange={(value) =>
                                        setForm({ ...form, audit_template_id: value })
                                    }
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.auditTemplatePlaceholder")} />
                                    </SelectTrigger>

                                    <SelectContent>
                                        {auditTemplates
                                            ?.filter((t) => Number(t.unlocked) === 1) // optional: only show unlocked
                                            .map((t) => {
                                                const label = `AT-${t.audit_template_id} • ${t.name || "Template"} • ${t.survey_template_name || "Survey Template"}`;

                                                return (
                                                    <SelectItem
                                                        key={t.audit_template_id}
                                                        value={String(t.audit_template_id)} // ✅ stored value
                                                        textValue={label}
                                                    >
                                                        {label}
                                                    </SelectItem>
                                                );
                                            })}
                                    </SelectContent>
                                </Select>
                            </div>

                        </div>

                        {/* Audit Type + Auditors */}
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.auditType")}</Label>
                                <Select
                                    value={form.audit_type || "internal"}
                                    onValueChange={(value) => setForm({ ...form, audit_type: value })}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.auditTypePlaceholder")} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="internal">{t("auditPlanning.modal.typeInternal")}</SelectItem>
                                        <SelectItem value="external">{t("auditPlanning.modal.typeExternal")}</SelectItem>
                                        <SelectItem value="compliance">{t("auditPlanning.modal.typeCompliance")}</SelectItem>
                                        <SelectItem value="follow_up">{t("auditPlanning.modal.typeFollowUp")}</SelectItem>
                                    </SelectContent>
                                </Select>
                            </div>

                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.auditors")}</Label>

                                {/* You already have this UI pattern - we’ll wrap it + dropdown */}
                                <AuditorsPicker
                                    users={users}
                                    value={form.auditors}
                                    onChange={(nextIds) => setForm({ ...form, auditors: nextIds })}
                                />
                            </div>
                        </div>

                        {/* Audit Scope + Objectives */}
                        <div className="space-y-2">
                            <Label htmlFor="auditScope">{t("auditPlanning.modal.auditScope")}</Label>
                            <Textarea
                                id="auditScope"
                                placeholder={t("auditPlanning.modal.auditScopePlaceholder")}
                                value={form.audit_scope || ""}
                                onChange={(e) => setForm({ ...form, audit_scope: e.target.value })}
                                rows={3}
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="auditObjectives">{t("auditPlanning.modal.auditObjectives")}</Label>
                            <Textarea
                                id="auditObjectives"
                                placeholder={t("auditPlanning.modal.auditObjectivesPlaceholder")}
                                value={form.audit_objectives || ""}
                                onChange={(e) => setForm({ ...form, audit_objectives: e.target.value })}
                                rows={3}
                            />
                        </div>
                    </div>

                    {/* Timeline */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.timeline")}</h3>

                        <div className="grid grid-cols-3 gap-4">
                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.status")}</Label>
                                <div className="h-9 flex items-center">
                                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs border ${statusPill}`}>
                                        {statusLabel}
                                    </span>
                                </div>
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="auditStart">{t("auditPlanning.modal.startDate")}</Label>
                                <Input
                                    id="auditStart"
                                    type="date"
                                    value={form.start_date}
                                    onChange={(e) => setForm({ ...form, start_date: e.target.value })}
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="auditEnd">{t("auditPlanning.modal.endDate")}</Label>
                                <Input
                                    id="auditEnd"
                                    type="date"
                                    value={form.end_date}
                                    onChange={(e) => setForm({ ...form, end_date: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={() => handleClose(false)} disabled={isSubmitting}>
                        {t("auditPlanning.buttons.cancel")}
                    </Button>
                    <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {t("auditPlanning.buttons.createAuditSubmit")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>

    );
};




const EditAuditDialog = ({
    open,
    onOpenChange,
    departments = [],
    surveys = [],
    completedSurveys = [],
    onSubmit,
    users,
    complianceStandards,
    createAuditFN,
    getAllAuditsFN,
    setEdit,
    id,
    getAuditByIdFN,
    editAuditFN,
    auditTemplates
}) => {
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState(false);

    const [form, setForm] = React.useState({
        title: "",
        description: "",
        department_id: "",
        survey_id: "",
        progress: 0,
        start_date: "",
        end_date: "",
        audit_type: "internal",      // enum: internal/external/compliance/follow_up
        audit_scope: "",
        audit_objectives: "",
        auditors: [],
        compliance_id: "",
        assigned_survey: "",
    });

    const reset = () => {
        setForm({
            title: "",
            description: "",
            department_id: "",
            compliance_id: "",
            survey_id: "",
            progress: 0,
            start_date: "",
            end_date: "",
        });
    };

    const computedStatus = React.useMemo(() => {
        return getAuditStatus({
            start_date: form.start_date,
            end_date: form.end_date,
            progress: form.progress, // if you still keep it in state/db; otherwise remove and status will be date-only
        });
    }, [form.start_date, form.end_date, form.progress]);

    const { label: statusLabel, pill: statusPill } = statusMeta(computedStatus, t);


    const handleClose = async (save) => {

        if (save === false) {

        } else {

            const payload = {
                title: form.title.trim(),
                description: form.description?.trim() || null,
                department_id: Number(form.department_id),
                survey_id: Number(form.survey_id),

                assigned_survey: form.assigned_survey ? Number(form.assigned_survey) : null,

                audit_type: form.audit_type || "internal",
                audit_scope: form.audit_scope?.trim() || null,
                audit_objectives: form.audit_objectives?.trim() || null,

                auditors: Array.isArray(form.auditors) ? form.auditors.map(Number) : null,

                start_date: form.start_date || null,
                end_date: form.end_date || null,
            };

            ////////console.log("payload ", payload)
            await editAuditFN(id.audit_id, payload);


            await getAllAuditsFN();
        }
        setEdit(null)
    };

    useEffect(() => {
        if (!id) return;

        const loadAudit = async () => {
            try {
                const audit = await getAuditByIdFN(id.audit_id);
                ////console.log("audit", audit);

                const entityId = Number(audit?.department_id) || null;

                const isDepartment = !!departments?.some(
                    (d) => Number(d.department_id) === entityId
                );

                const isCompliance = !!complianceStandards?.some(
                    (c) => Number(c.compliance_id) === entityId
                );

                setForm((prev) => ({
                    ...prev,
                    ...audit,
                    start_date: toDateInput(audit.start_date),
                    end_date: toDateInput(audit.end_date),

                    // ✅ decode overloaded column into correct field
                    department_id: isDepartment ? entityId : null,
                    compliance_id: !isDepartment && isCompliance ? entityId : null,
                }));
            } catch (err) {
                console.error("Failed to load audit", err);
            }
        };


        loadAudit();
    }, [id, getAuditByIdFN]);


    const handleSubmit = async () => {
        const payload = {
            title: form.title.trim(),
            description: form.description?.trim() || null,
            department_id: Number(form.department_id),
            survey_id: Number(form.survey_id),

            assigned_survey: form.assigned_survey ? Number(form.assigned_survey) : null,

            audit_type: form.audit_type || "internal",
            audit_scope: form.audit_scope?.trim() || null,
            audit_objectives: form.audit_objectives?.trim() || null,

            auditors: Array.isArray(form.auditors) ? form.auditors.map(Number) : null,

            start_date: form.start_date || null,
            end_date: form.end_date || null,
        };

        ////////console.log("payload ", payload)
        await editAuditFN(id.audit_id, payload);


        await getAllAuditsFN();
        handleClose(false);
    };


    const toDateInput = (v) => {
        if (!v) return "";
        // if already "YYYY-MM-DD"
        if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
        // ISO string or Date -> take first 10 chars
        return String(v).slice(0, 10);
    };

    const formatSubmittedDate = (v) => {
        if (!v) return "";
        const d = new Date(v);
        return d.toLocaleDateString(undefined, {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };


    return (
        <Dialog open={open} onOpenChange={() => handleClose(true)}>
            <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                    <DialogTitle>{t("auditPlanning.modal.editTitle")}</DialogTitle>
                </DialogHeader>

                <div className="space-y-6">
                    {/* Basic Information */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.basicInformation")}</h3>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2 col-span-2">
                                <Label htmlFor="auditTitle">
                                    {t("auditPlanning.modal.auditTitle")} <span className="text-red-500">*</span>
                                </Label>
                                <Input
                                    id="auditTitle"
                                    placeholder={t("auditPlanning.modal.auditTitlePlaceholder")}
                                    value={form.title}
                                    onChange={(e) => setForm({ ...form, title: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="auditDesc">{t("auditPlanning.modal.description")}</Label>
                            <Textarea
                                id="auditDesc"
                                placeholder={t("auditPlanning.modal.descriptionPlaceholder")}
                                value={form.description}
                                onChange={(e) => setForm({ ...form, description: e.target.value })}
                                rows={4}
                            />
                        </div>
                    </div>

                    {/* Scope */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.scope")}</h3>

                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <Label>
                                    {t("auditPlanning.modal.department")} <span className="text-red-500">*</span>
                                </Label>
                                <Select
                                    value={
                                        form.department_id
                                            ? `dep:${form.department_id}`
                                            : form.compliance_id
                                                ? `comp:${form.compliance_id}`
                                                : undefined
                                    }
                                    onValueChange={(value) => {
                                        if (value.startsWith("dep:")) {
                                            const id = Number(value.replace("dep:", ""));
                                            setForm({
                                                ...form,
                                                department_id: id,
                                                compliance_id: null,
                                            });
                                        }

                                        if (value.startsWith("comp:")) {
                                            const id = Number(value.replace("comp:", ""));
                                            setForm({
                                                ...form,
                                                compliance_id: id,
                                                department_id: null,
                                            });
                                        }
                                    }}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.departmentPlaceholder")} />
                                    </SelectTrigger>

                                    <SelectContent>

                                        {/* ===== Departments ===== */}
                                        {departments.map((d) => {
                                            const deptName =
                                                d.name || d.title || d.department_name || `Dept ${d.department_id}`;

                                            return (
                                                <SelectItem
                                                    key={`dep-${d.department_id}`}
                                                    value={`dep:${d.department_id}`}
                                                    textValue={`${deptName} ${d.company_name || ""}`}
                                                >
                                                    <div className="flex flex-col">
                                                        <span className="text-sm text-gray-900">{deptName}</span>
                                                        {d.company_name && (
                                                            <span className="text-xs text-gray-400">
                                                                {d.company_name}
                                                            </span>
                                                        )}
                                                    </div>
                                                </SelectItem>
                                            );
                                        })}

                                        {/* ===== Compliance Standards ===== */}
                                        {complianceStandards.map((c) => (
                                            <SelectItem
                                                key={`comp-${c.compliance_id}`}
                                                value={`comp:${c.compliance_id}`}
                                                textValue={`${c.name} ${c.company_name || ""}`}
                                            >
                                                <div className="flex flex-col">
                                                    <span className="text-sm text-gray-900 flex items-center gap-2">
                                                        {c.name}
                                                        <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-indigo-50 text-indigo-600">
                                                            {t("auditPlanning.modal.complianceBadge")}
                                                        </span>
                                                    </span>

                                                    {c.company_name && (
                                                        <span className="text-xs text-gray-400">
                                                            {c.company_name}
                                                        </span>
                                                    )}
                                                </div>
                                            </SelectItem>
                                        ))}

                                    </SelectContent>
                                </Select>

                            </div>

                            <div className="space-y-2">
                                <Label>
                                    {t("auditPlanning.modal.auditTemplate")} <span className="text-red-500">*</span>
                                </Label>

                                <Select
                                    value={form.audit_template_id ? String(form.audit_template_id) : ""}
                                    onValueChange={(value) => setForm({ ...form, audit_template_id: value })}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.auditTemplatePlaceholder")} />
                                    </SelectTrigger>

                                    <SelectContent>
                                        {auditTemplates?.map((t) => {
                                            const label = `AT-${t.audit_template_id} • ${t.name || "Template"} • ${t.survey_template_name || "Survey Template"}`;

                                            return (
                                                <SelectItem
                                                    key={t.audit_template_id}
                                                    value={String(t.audit_template_id)} // ✅ stored value (ID)
                                                    textValue={label}
                                                >
                                                    {label}
                                                </SelectItem>
                                            );
                                        })}
                                    </SelectContent>
                                </Select>
                            </div>

                        </div>

                        {/* Audit Type + Auditors */}
                        <div className="grid grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.auditType")}</Label>
                                <Select
                                    value={form.audit_type || "internal"}
                                    onValueChange={(value) => setForm({ ...form, audit_type: value })}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={t("auditPlanning.modal.auditTypePlaceholder")} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value="internal">{t("auditPlanning.modal.typeInternal")}</SelectItem>
                                        <SelectItem value="external">{t("auditPlanning.modal.typeExternal")}</SelectItem>
                                        <SelectItem value="compliance">{t("auditPlanning.modal.typeCompliance")}</SelectItem>
                                        <SelectItem value="follow_up">{t("auditPlanning.modal.typeFollowUp")}</SelectItem>
                                    </SelectContent>
                                </Select>
                            </div>

                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.auditors")}</Label>

                                {/* You already have this UI pattern - we’ll wrap it + dropdown */}
                                <AuditorsPicker
                                    users={users}
                                    value={form.auditors}
                                    onChange={(nextIds) => setForm({ ...form, auditors: nextIds })}
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <Label>{t("auditPlanning.modal.assignedSurvey")}</Label>

                            <Select
                                value={form.assigned_survey ?? ""}
                                onValueChange={(value) => {
                                    ////////console.log("Select onValueChange →", value, typeof value);

                                    setForm((prev) => {
                                        ////////console.log("BEFORE setForm.assigned_survey →", prev.assigned_survey, typeof prev.assigned_survey);

                                        const next = { ...prev, assigned_survey: value };

                                        ////////console.log("AFTER setForm.assigned_survey →", next.assigned_survey, typeof next.assigned_survey);

                                        return next;
                                    });
                                }}
                            >

                                <SelectTrigger>
                                    <SelectValue placeholder={t("auditPlanning.modal.assignedSurveyPlaceholder")} />
                                </SelectTrigger>

                                <SelectContent>
                                    {/* optional clear */}
                                    <SelectItem value="" textValue={t("auditPlanning.modal.none")}>
                                        <span className="text-sm text-gray-500">{t("auditPlanning.modal.none")}</span>
                                    </SelectItem>

                                    {surveys.map((s) => {
                                        const label = `SUR-${s.survey_id} • ${s.organization_name || "Organization"} • ${s.filler_name || "User"} • ${formatSubmittedDate(s.submitted_at)}`;
                                        return (
                                            <SelectItem
                                                key={s.survey_id}
                                                value={String(s.survey_id)}  // ✅ stored ID
                                                textValue={label}            // ✅ shown label
                                            >
                                                {label}
                                            </SelectItem>
                                        );
                                    })}
                                </SelectContent>
                            </Select>
                        </div>

                        {/* Audit Scope + Objectives */}
                        <div className="space-y-2">
                            <Label htmlFor="auditScope">{t("auditPlanning.modal.auditScope")}</Label>
                            <Textarea
                                id="auditScope"
                                placeholder={t("auditPlanning.modal.auditScopePlaceholder")}
                                value={form.audit_scope || ""}
                                onChange={(e) => setForm({ ...form, audit_scope: e.target.value })}
                                rows={3}
                            />
                        </div>

                        <div className="space-y-2">
                            <Label htmlFor="auditObjectives">{t("auditPlanning.modal.auditObjectives")}</Label>
                            <Textarea
                                id="auditObjectives"
                                placeholder={t("auditPlanning.modal.auditObjectivesPlaceholder")}
                                value={form.audit_objectives || ""}
                                onChange={(e) => setForm({ ...form, audit_objectives: e.target.value })}
                                rows={3}
                            />
                        </div>
                    </div>

                    {/* Timeline */}
                    <div className="space-y-4">
                        <h3 className="text-sm font-semibold">{t("auditPlanning.modal.timeline")}</h3>

                        <div className="grid grid-cols-3 gap-4">
                            <div className="space-y-2">
                                <Label>{t("auditPlanning.modal.status")}</Label>
                                <div className="h-9 flex items-center">
                                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs border ${statusPill}`}>
                                        {statusLabel}
                                    </span>
                                </div>
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="auditStart">{t("auditPlanning.modal.startDate")}</Label>
                                <Input
                                    id="auditStart"
                                    type="date"
                                    value={form.start_date}
                                    onChange={(e) => setForm({ ...form, start_date: e.target.value })}
                                />
                            </div>

                            <div className="space-y-2">
                                <Label htmlFor="auditEnd">{t("auditPlanning.modal.endDate")}</Label>
                                <Input
                                    id="auditEnd"
                                    type="date"
                                    value={form.end_date}
                                    onChange={(e) => setForm({ ...form, end_date: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={() => handleClose(false)} disabled={isSubmitting}>
                        {t("auditPlanning.buttons.cancel")}
                    </Button>
                    <Button onClick={handleSubmit} disabled={isSubmitting}>
                        {t("auditPlanning.buttons.editAuditSubmit")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>

    );
};




function Audit(props) {
    const { t } = useTranslation();
    const {createEmptySurveyQuestionFN,  complianceStandarts, audit_templates, getAllAuditTemplatesFN, editActionFN, updateFindingFN, createActionFromFindingFN, resultFindings, getFindingsBySurveyFN, getActionsBySurveyFN, getAllSurveyFindingsFN, getAllSurveyActionsFN, addFindingsSurveyAIBatchFN, deleteFindingFN, saveSurveyDraftFN, getSurveyByIdFN, deploySurveyTemplateFN, templatesRaw, editAuditFN, completedSurveys, getAuditByIdFN, deleteAuditFN, createAuditFN, getUsersFN, users, getAllSurveysFN, getAllSurveysTemplateFN, departments, audits, token, getAllAuditsFN, checkSurveyStatusFN, submitSurveyFN, uploadSurveyFileFN, deleteSurveyFileFN, getSurveyFilesFN, getEvidenceFN, deleteEvidenceFN, getAllRisksFN, allRisks, getSOAControlsFN, updateSOAControlFN } = props;

    // Ref for scroll container
    const scrollContainerRef = useRef(null);

    // Loading state
    const [loading, setLoading] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // Already submitted state
    const [alreadySubmitted, setAlreadySubmitted] = useState(false);
    const [submittedSurvey, setSubmittedSurvey] = useState(null);

    // Current view: 'survey' or 'review' or 'success'
    const [currentView, setCurrentView] = useState('survey');

    // Active tab: 'survey' or 'files'
    const [activeTab, setActiveTab] = useState('audits');
    const [mainTab, setMainTab] = useState('audits');
    const [auditSidebarOpen, setAuditSidebarOpen] = useState(true);





    const [templateQuery, setTemplateQuery] = useState("");


    // Validation error state
    const [validationError, setValidationError] = useState(null);

    // Organization info
    const [orgName, setOrgName] = useState("");
    const [fillerName, setFillerName] = useState("");

    // Answers state - keyed by question id
    const [answers, setAnswers] = useState({});

    // Files state - keyed by question id
    const [files, setFiles] = useState({});

    // SOA state
    const [soaControls, setSoaControls] = useState([]);
    const [soaLoading, setSoaLoading] = useState(true);
    const [soaSearch, setSoaSearch] = useState('');
    const [soaApplicabilityFilter, setSoaApplicabilityFilter] = useState('all');
    const [soaStatusFilter, setSoaStatusFilter] = useState('all');
    const [soaEditModal, setSoaEditModal] = useState(null);
    const [soaEditData, setSoaEditData] = useState(null);
    const [soaSaving, setSoaSaving] = useState(false);
    const [newRiskId, setNewRiskId] = useState('');
    const [statusFilter, setStatusFilter] = useState("all");
    const [typeFilter, setTypeFilter] = useState("all");

    const [selectedTemplateId, setSelectedTemplateId] = useState(null);
    const [selectedSurvey, setselectedSurvey] = useState(null);
    const [selectedAuditName, setSelectedAuditName] = useState(null);
    const [selectedAuditDeptId, setSelectedAuditDeptId] = useState(null);
    const [selectedAuditCompId, setSelectedAuditCompId] = useState(null);
    const [surveyActions, setSurveyActions] = useState(null);
    const [auditEvidenceList, setAuditEvidenceList] = useState([]);
    const [allSurveyFindings, setAllSurveyFindings] = useState(null);
    const [allSurveyActions, setAllSurveyActions] = useState(null);
    const [allFindingsQuery, setAllFindingsQuery] = useState('');
    const [allFindingsStatus, setAllFindingsStatus] = useState('All');
    const [allFindingsPage, setAllFindingsPage] = useState(1);
    const ALL_FINDINGS_PAGE_SIZE = 6;
    const [aaActionsQuery, setAaActionsQuery] = useState('');
    const [aaActionsStatus, setAaActionsStatus] = useState('All');
    const [aaActionsPage, setAaActionsPage] = useState(1);
    const [aaView, setAaView] = useState('table');
    const ALL_ACTIONS_PAGE_SIZE = 6;
    const [selectedReportSurvey, setSelectedReportSurvey] = useState(null);
    const [reportSurveyData, setReportSurveyData] = useState(null);
    const [reportLoading, setReportLoading] = useState(false);
    const [filePreview, setFilePreview] = useState(null); // { url, name }
    const [questions, setQuestions] = useState(null);
    const [findingId, setFindingID] = useState(null);
    const [isFindingOpen, setIsFindingOpen] = useState(false);


    const [isActionOpen, setIsActionOpen] = useState(false);
    const [action_id, setActionId] = useState(null);


    const closeAction = async (data) => {
        await updateControlServerData(data);

        setIsActionOpen(false);
    };

    const updateControlServerData = async (data) => {
        // adjust dates if you really need +1 day

        ////////console.log("action_id ", action_id)
        const updatedData = { ...data };
        if (updatedData.StartDate) {
            const d = new Date(updatedData.StartDate);
            d.setDate(d.getDate());
            updatedData.StartDate = d.toISOString().split("T")[0];
        }
        if (updatedData.EndDate) {
            const d = new Date(updatedData.EndDate);
            d.setDate(d.getDate());
            updatedData.EndDate = d.toISOString().split("T")[0];
        }


        try {
            // IMPORTANT: await the thunk
            ////////console.log("save it ", updatedData)
            const saved = await editActionFN(null, action_id, updatedData);
            return saved; // bubble up if you want
        } finally {

        }
    };


    const priorityChip = (p) => {
        if (!p || p === "—") {
            return <span className="inline-flex items-center text-[11px] px-2 py-0.5 rounded border border-gray-200 bg-gray-50 text-gray-600">—</span>;
        }
        const map = {
            Critical: "bg-red-100 text-red-700 border-red-200",
            High: "bg-orange-100 text-orange-700 border-orange-200",
            Medium: "bg-yellow-100 text-yellow-800 border-yellow-200",
            Low: "bg-green-100 text-green-700 border-green-200",
        };
        const cls = map[p] || "bg-gray-100 text-gray-700 border-gray-200";
        return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{p}</span>;
    };

    const statusChip = (s) => {
        const map = {
            Open: "bg-blue-100 text-blue-700 border-blue-200",
            "In Progress": "bg-purple-100 text-purple-700 border-purple-200",
            Resolved: "bg-emerald-100 text-emerald-700 border-emerald-200",
            Closed: "bg-gray-200 text-gray-700 border-gray-300",
        };
        const cls = map[s] || "bg-gray-100 text-gray-700 border-gray-200";
        return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{s}</span>;
    };

    const handleViewAction = async (finding) => {
        //////console.log("View ", finding)

        setActionId(finding.action_id)
        setIsActionOpen(true)

    };

    const handleViewFinding = (finding) => {
        //////console.log("view ,", finding)
        setFindingID(finding.finding_id);
        setIsFindingOpen(true)
    }

    const handleCreateAction = async (finding) => {
        if (!finding) return;

        await createActionFromFindingFN(finding)

        //////console.log("Getting comp findings for ", selectedSurvey)

        getFindingsBySurveyFN(selectedSurvey)


        // getDepartmentsFindingsFN(activeDepartmentId);

    };

    const closeFinding = async (data, finding_id) => {
        if (!finding_id)
            return
        setIsFindingOpen(false)
        setFindingID(null)
        await updateFindingFN(data, finding_id)
        if (selectedSurvey) getFindingsBySurveyFN(selectedSurvey)
    }

    // Check survey status, load files, and fetch risks on mount
    useEffect(() => {
        const checkStatusAndLoadFiles = async () => {
            try {
                // const result = await checkSurveyStatusFN();
                // if (result.hasSubmitted) {
                //     setAlreadySubmitted(true);
                //     setSubmittedSurvey(result.survey);
                //     // Populate answers from the submitted survey
                //     if (result.survey.answers) {
                //         setAnswers(result.survey.answers);
                //     }
                //     // Populate organization and filler name
                //     if (result.survey.organizationName) {
                //         setOrgName(result.survey.organizationName);
                //     }
                //     if (result.survey.fillerName) {
                //         setFillerName(result.survey.fillerName);
                //     }
                // }
                ////console.log("Gertitng FIles for ", selectedSurvey)
                // Fetch existing files for this user
                const existingFiles = await getSurveyFilesFN(selectedSurvey);
                if (existingFiles && existingFiles.length >= 0) {
                    // Group files by question_id
                    const filesGrouped = {};
                    existingFiles.forEach(file => {
                        const questionId = file.survey_question_id;
                        if (questionId) {
                            if (!filesGrouped[questionId]) {
                                filesGrouped[questionId] = [];
                            }
                            filesGrouped[questionId].push({
                                id: file.id,
                                name: file.name,
                                size: file.size,
                                url: file.s3_path,
                                uploaded: true
                            });
                        }
                    });
                    setFiles(filesGrouped);
                }
            } catch (error) {
                console.error("Error checking survey status:", error);
            } finally {
                setLoading(false);
            }
        };
        checkStatusAndLoadFiles();

        // Fetch all risks for SOA assignment
        getAllRisksFN();
    }, [checkSurveyStatusFN, getSurveyFilesFN, getAllRisksFN, selectedSurvey]);


    const loadSurvey = async () => {
        try {
            const result = await getSurveyByIdFN(selectedSurvey);
            ////console.log("result ", result);

            if (!result) return;

            if (result.answers) {
                setAnswers(result.answers);
            }

            if (result.organization_name) {
                setOrgName(result.organization_name);
            }

            if (result.template_id) {
                setSelectedTemplateId(result.template_id);
            }

            if (result.questions) {
                setQuestions(result.questions);
            }

            const fullName = [result.first_name, result.last_name]
                .filter(Boolean)
                .join(" ");

            setFillerName(fullName || "—");

            if (result.status !== "submitted") {
                setSubmittedSurvey(null);
                setAlreadySubmitted(false);
                setCurrentView("survey");
            } else {
                setAlreadySubmitted(true);
                setCurrentView("success");
                getFindingsBySurveyFN(selectedSurvey);
            }

        } catch (error) {
            console.error("Error loading survey:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (selectedSurvey) {
            loadSurvey();
            getEvidenceFN({ survey_id: selectedSurvey })
                .then(data => setAuditEvidenceList(Array.isArray(data) ? data : []))
                .catch(() => setAuditEvidenceList([]));
        } else {
            setAuditEvidenceList([]);
        }
    }, [selectedSurvey]);

    useEffect(() => {
        if (activeTab === 'files' && selectedSurvey) {
            getEvidenceFN({ survey_id: selectedSurvey })
                .then(data => setAuditEvidenceList(Array.isArray(data) ? data : []))
                .catch(() => {});
        }
        if (activeTab === 'actions' && selectedSurvey) {
            setSurveyActions(null);
            getActionsBySurveyFN(selectedSurvey)
                .then(data => setSurveyActions(Array.isArray(data) ? data : []))
                .catch(() => setSurveyActions([]));
        }
    }, [activeTab, selectedSurvey]);

    useEffect(() => {
        if (mainTab === 'findings') {
            setAllSurveyFindings(null);
            getAllSurveyFindingsFN().then(setAllSurveyFindings).catch(() => setAllSurveyFindings([]));
        }
        if (mainTab === 'actions') {
            setAllSurveyActions(null);
            getAllSurveyActionsFN().then(setAllSurveyActions).catch(() => setAllSurveyActions([]));
        }
        if (mainTab === 'reports') {
            setSelectedReportSurvey(null);
            setReportSurveyData(null);
        }
    }, [mainTab]);

    const loadReport = async (survey) => {
        setSelectedReportSurvey(survey);
        setReportSurveyData(null);
        setReportLoading(true);
        try {
            const result = await getSurveyByIdFN(survey.survey_id);
            setReportSurveyData(result || {});
        } catch {
            setReportSurveyData({});
        } finally {
            setReportLoading(false);
        }
    };

    // Fetch SOA controls from database
    useEffect(() => {
        const fetchSOAControls = async () => {
            try {
                setSoaLoading(true);
                const controls = await getSOAControlsFN();
                if (controls && controls.length > 0) {
                    // Transform to match the expected format
                    const transformedControls = controls.map(c => ({
                        id: c.soa_id.toString(),
                        soaId: c.soa_id,
                        controlId: c.control_id,
                        controlName: c.control_name,
                        category: c.category,
                        description: c.description,
                        applicable: c.applicable,
                        justification: c.justification || '',
                        implementationStatus: c.implementation_status || 'not-set',
                        riskIds: c.risks ? c.risks.map(r => `RISK-${String(r.id).padStart(3, '0')}`) : []
                    }));
                    setSoaControls(transformedControls);
                } else {
                    // Fallback to initial controls if database is empty
                    setSoaControls(initialSOAControls);
                }
            } catch (error) {
                console.error("Error fetching SOA controls:", error);
                // Fallback to initial controls on error
                setSoaControls(initialSOAControls);
            } finally {
                setSoaLoading(false);
            }
        };
        fetchSOAControls();
    }, [getSOAControlsFN]);




    const isCustomFramework = Number(selectedTemplateId) === 2;

    // local draft clauses/questions for framework=3
    const [draftClauses, setDraftClauses] = useState([]);

    const getActiveClauses = () => {
    const base = Array.isArray(allClauses) ? allClauses : [];
    const drafts = Array.isArray(draftClauses) ? draftClauses : [];

    const draftByClause = new Map();
    drafts.forEach((dc) => {
        const clauseKey = String(dc?.clause ?? dc?._tmpClauseId ?? "");
        if (!clauseKey) return;
        draftByClause.set(clauseKey, dc);
    });

    const merged = base.map((c) => {
        const key = String(c?.clause ?? "");
        const dc = draftByClause.get(key);
        if (!dc) return c;

        return {
            ...c,
            title: dc.title ?? c.title,
            questions: [...(c.questions || []), ...(dc.questions || [])],
        };
    });

    const baseClauseSet = new Set(base.map((c) => String(c?.clause ?? "")));
    const draftOnly = drafts.filter((dc) => {
        const key = String(dc?.clause ?? dc?._tmpClauseId ?? "");
        return key && !baseClauseSet.has(key);
    });

    return [...merged, ...draftOnly].sort((a, b) =>
        String(a.clause).localeCompare(String(b.clause), "en", { numeric: true })
    );
};

    const addClause = () => {
        const nextIndex = (draftClauses?.length || 0) + 1;

        const newClause = {
            // use a temp key until backend gives real ids
            _tmpClauseId: `tmp_clause_${Date.now()}_${Math.random().toString(16).slice(2)}`,
            clause: String(nextIndex), // you can change this later
            title: "",
            questions: [],
        };

        setDraftClauses((prev) => [...(prev || []), newClause]);
    };

   const updateClauseTitle = (clauseObj, title) => {
    const clauseKey = String(clauseObj?.clause ?? clauseObj?._tmpClauseId ?? "");

    setDraftClauses((prev) => {
        const arr = Array.isArray(prev) ? [...prev] : [];

        const idx = arr.findIndex(
            (c) => String(c?.clause ?? c?._tmpClauseId ?? "") === clauseKey
        );

        if (idx >= 0) {
            arr[idx] = {
                ...arr[idx],
                title,
            };
        } else {
            arr.push({
                clause: clauseObj?.clause,
                title,
                questions: [],
            });
        }

        return arr;
    });
};
    const deleteClause = (clauseKey) => {
        setDraftClauses((prev) => (prev || []).filter((c) => c._tmpClauseId !== clauseKey));
    };

    const [deletedQuestionIds, setDeletedQuestionIds] = useState([]);
    const deletedSet = useMemo(() => new Set(deletedQuestionIds), [deletedQuestionIds]);
    const requestDeleteQuestion = (questionId) => {
  const id = Number(questionId);
  if (!Number.isInteger(id) || id <= 0) return;

  setDeletedQuestionIds((prev) => (prev.includes(id) ? prev : [...prev, id]));

  // also remove from UI immediately by filtering local `questions`
  // (assuming `questions` is state and you can set it)
  setQuestions((prev) => (Array.isArray(prev) ? prev.filter((q) => Number(q.question_id) !== id) : prev));
};

    const deleteDraftQuestion = (clauseKey, tmpQuestionId) => {
        setDraftClauses((prev) => {
            const arr = Array.isArray(prev) ? prev : [];

            return arr.map((c) => {
                if (!sameClause(c, clauseKey) && String(c?.clause ?? "") !== String(clauseKey)) {
                    return c;
                }

                const qs = Array.isArray(c.questions) ? c.questions : [];
                return {
                    ...c,
                    questions: qs.filter((q) => q?._tmpQuestionId !== tmpQuestionId),
                };
            });
        });
    };

    const clauseKeyOf = (c) => String(c?._tmpClauseId ?? c?.clause ?? "");
    const sameClause = (c, clauseKey) => clauseKeyOf(c) === String(clauseKey);

    // const addQuestionToClause = (clauseKey) => {

    //     const newQuestion = {
    //         _tmpQuestionId: `tmp_q_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    //         question_id: null,
    //         question_type: "yes_no",
    //         required: 0,
    //         status: "active",
    //         question_text: "",
    //         owner_user_id: null,
    //     };

    //     setDraftClauses((prev) => {
    //         const arr = Array.isArray(prev) ? [...prev] : [];

    //         // For existing clauses we treat clauseKey as the clause code ("4")
    //         const keyStr = String(clauseKey);

    //         // Find an existing draft clause or overlay for this clause code
    //         const idx = arr.findIndex((c) => String(c?.clause ?? c?._tmpClauseId ?? "") === keyStr);

    //         if (idx >= 0) {
    //             const target = arr[idx];
    //             arr[idx] = { ...target, questions: [...(target.questions || []), newQuestion] };
    //             return arr;
    //         }

    //         // No draft overlay exists yet → create an OVERLAY (not a real new draft clause)
    //         // IMPORTANT: do NOT copy title from existing clause, or you’ll save "Clause 4" and create bad clause labels.
    //         return [
    //             ...arr,
    //             {
    //                 _tmpClauseId: `tmp_clause_${Date.now()}_${Math.random().toString(16).slice(2)}`,
    //                 _isOverlay: true, // ✅ mark overlay so UI doesn't treat it as new clause
    //                 clause: keyStr,   // ✅ must match existing clause code for merge
    //                 title: "",        // ✅ overlays should not set title
    //                 questions: [newQuestion],
    //             },
    //         ];
    //     });
    // };

    const addQuestionToClause = async (clauseKey) => {
        try {
            //console.log("clauseKey ", clauseKey);

            const payload = {
                template_id: selectedTemplateId,
                clause: String(clauseKey.title),
                survey_id: selectedSurvey,
            };

            const result = await createEmptySurveyQuestionFN(payload);
            const newQuestion = result?.question;
            if (!newQuestion?.question_id) return;

            const filteredClauses = (draftClauses || []).filter(
                (c) => c._tmpClauseId !== clauseKey._tmpClauseId
            );
            setDraftClauses(filteredClauses);
            handleSaveDraft(filteredClauses);

            setselectedQuestion(newQuestion.question_id);

        } catch (err) {
            console.error("Failed to create question", err);
        }
    };

    const updateDraftQuestion = (clauseKey, tmpQuestionId, patch) => {
        setDraftClauses((prev) => {
            const arr = Array.isArray(prev) ? prev : [];

            const newArr = arr.map((c) => {
                if (!sameClause(c, clauseKey) && String(c?.clause ?? "") !== String(clauseKey)) {
                    return c;
                }

                const qs = Array.isArray(c.questions) ? c.questions : [];
                return {
                    ...c,
                    questions: qs.map((q) =>
                        q?._tmpQuestionId === tmpQuestionId ? { ...q, ...patch } : q
                    ),
                };
            });

            handleSaveDraft(newArr);
            return newArr;
        });
    };

   

    const [auditQuery, setAuditQuery] = useState("");
    const [findingsSearch, setFindingsSearch] = useState("");
    const [sfStatus, setSfStatus] = useState('All');
    const [sfPage, setSfPage] = useState(1);
    const SF_PAGE_SIZE = 6;
    const [saQuery, setSaQuery] = useState('');
    const [saStatus, setSaStatus] = useState('All');
    const [saPage, setSaPage] = useState(1);
    const [saView, setSaView] = useState('table');
    const [evidenceSearch, setEvidenceSearch] = useState("");
    const [evidenceStatusFilter, setEvidenceStatusFilter] = useState("");
    const [evidenceCategoryFilter, setEvidenceCategoryFilter] = useState("");
    const [showSurveyView, setShowSurveyView] = useState(false);
    const [auditTypeView, setAuditTypeView] = useState("All");
    const [auditSeverityView, setAuditSeverityView] = useState("All");
    const [auditStatusView, setAuditStatusView] = useState("All");
    const [viewMode, setViewMode] = useState("grid"); // "table" | "grid"
    const showToggle = true;


    const filteredAudits = audits?.filter((a) => {
        const q = auditQuery.toLowerCase();

        // 🔍 SEARCH
        const matchesQuery =
            !q ||
            [
                a.title,
                a.scope,
                a.owner_name,
                a.owner,
                a.standard,
                a.audit_id && `AUD-${a.audit_id}`,
            ]
                .filter(Boolean)
                .some((v) => String(v).toLowerCase().includes(q));

        // 🧪 TYPE
        const matchesType =
            auditTypeView === "All" || a.type === auditTypeView;

        // 🚦 STATUS
        const matchesStatus =
            auditStatusView === "All" || a.status === auditStatusView;

        // ⚠️ SEVERITY / RATING (if you use it)
        const matchesSeverity =
            auditSeverityView === "All" || a.severity === auditSeverityView;

        return (
            matchesQuery &&
            matchesType &&
            matchesStatus &&
            matchesSeverity
        );
    });

    const auditsForGantt = filteredAudits || [];

    const toMs = (d) => (d ? new Date(d).getTime() : NaN);

    const minStart = Math.min(...auditsForGantt.map(a => toMs(a.start_date)).filter(Number.isFinite));
    const maxEnd = Math.max(...auditsForGantt.map(a => toMs(a.end_date)).filter(Number.isFinite));

    // small padding so bars don’t stick to edges
    const PAD_MS = 24 * 60 * 60 * 1000 * 3;
    const ganttMin = Number.isFinite(minStart) ? (minStart - PAD_MS) : Date.now();
    const ganttMax = Number.isFinite(maxEnd) ? (maxEnd + PAD_MS) : (Date.now() + 7 * 24 * 60 * 60 * 1000);

    const totalMs = Math.max(1, ganttMax - ganttMin);

    const clampPct = (x) => Math.max(0, Math.min(100, x));

    const leftPct = (date) => clampPct(((toMs(date) - ganttMin) / totalMs) * 100);
    const widthPct = (start, end) => clampPct(((toMs(end) - toMs(start)) / totalMs) * 100);

    const getAuditStatus = (a) => {
        const p = Math.max(0, Math.min(100, Number(a.progress ?? 0)));
        if (a.status === "cancelled") return "cancelled";
        if (p >= 100) return "completed";
        if (p > 0) return "in_progress";
        return "planned";
    };

    const STATUS = {
        in_progress: { chip: "bg-blue-50 text-blue-700 border-blue-200", dot: "bg-blue-500", bar: "bg-blue-600" },
        completed: { chip: "bg-emerald-50 text-emerald-700 border-emerald-200", dot: "bg-emerald-500", bar: "bg-emerald-600" },
        planned: { chip: "bg-gray-50 text-gray-700 border-gray-200", dot: "bg-gray-400", bar: "bg-gray-500" },
        cancelled: { chip: "bg-rose-50 text-rose-700 border-rose-200", dot: "bg-rose-500", bar: "bg-rose-600" },
    };

    const monthTicks = (() => {
        const ticks = [];
        const d = new Date(ganttMin);
        d.setDate(1);
        d.setHours(0, 0, 0, 0);

        // step to next month boundary
        while (d.getTime() < ganttMax) {
            ticks.push(new Date(d));
            d.setMonth(d.getMonth() + 1);
        }
        return ticks;
    })();



    useEffect(() => {
        if (getAllSurveysTemplateFN) {
            getAllSurveysTemplateFN()
        }
    }, [getAllSurveysTemplateFN]);

    useEffect(() => {
        if (getAllAuditTemplatesFN) {
            getAllAuditTemplatesFN()
        }
    }, [getAllAuditTemplatesFN]);

    useEffect(() => {
        if (getAllSurveysFN) {
            getAllSurveysFN()
        }
    }, [getAllSurveysFN]);

    const scrollToTop = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const handleAnswerChange = (questionId, value) => {
        ////console.log(questionId)
        setAnswers(prev => ({ ...prev, [questionId]: value }));
        // Clear validation error when user starts answering
        if (validationError) setValidationError(null);
        // Clear files if answer is not "evet"
        if (value !== "evet") {
            setFiles(prev => {
                const newFiles = { ...prev };
                delete newFiles[questionId];
                return newFiles;
            });
        }
    };



    const [selectedQuestion, setselectedQuestion] = useState(null);

    const handleOpenQuestion = (questionId) => {
        ////console.log(questionId)
        setselectedQuestion(questionId)
    };

    const handleCloseQuestion = async () => {
        setselectedQuestion(null);
        await loadSurvey();
    };

    const handleQuestionFindingsNeeded = async (questionId) => {
        if (!questionId || !selectedSurvey) return;
        try {
            const targetId = String(questionId);
            const targetQuestion = (allQuestionsFlat || []).find(
                (q) => String(q.question_id ?? q.id) === targetId
            );
            if (!targetQuestion) return;

            const questionText = (targetQuestion.text || targetQuestion.question_text || '').slice(0, 50).toLowerCase();
            const alreadyExists = questionText && (Array.isArray(resultFindings) ? resultFindings : []).some(
                (f) => (f.title || '').toLowerCase().includes(questionText)
            );
            if (alreadyExists) {
                console.log("Finding already exists for this question, skipping AI generation");
                return;
            }

            const singleClause = [{
                clause: targetQuestion.clause || '',
                title: String(targetQuestion.clause || ''),
                questions: [targetQuestion],
            }];
            const answers = { [targetId]: 'hayir' };

            console.log("singleClause ", singleClause)
            console.log("answers ", answers)
            const aiFindings = await callOpenAIAPISurveyFindings(singleClause, answers);
            console.log("aiFindings ", aiFindings)
            await addFindingsSurveyAIBatchFN(aiFindings, selectedSurvey);
            await getFindingsBySurveyFN(selectedSurvey);
        } catch (err) {
            console.error("AI findings generation failed for question:", err);
        }
    };



    const handleFilesChange = (questionId, newFiles) => {
        setFiles(prev => ({ ...prev, [questionId]: newFiles }));
    };


    const allClauses = useMemo(() => {
        ////console.log("questions ", questions)
        const qs = Array.isArray(questions) ? questions : [];
        if (qs.length === 0) return [];

        const clauseMap = {};

        qs.forEach((q) => {
            if (!q?.clause) return;

            const key = String(q.clause);

            if (!clauseMap[key]) {
                clauseMap[key] = {
                    clause: key,
                    title: `${key}`,
                    questions: [],
                };
            }

            clauseMap[key].questions.push(q);
        });

        return Object.values(clauseMap)
            .map((c) => ({
                ...c,
                questions: c.questions
                    .slice()
                    .sort((a, b) => (Number(a.order ?? 0) - Number(b.order ?? 0))),
            }))
            .sort((a, b) => String(a.clause).localeCompare(String(b.clause), "en", { numeric: true }));
    }, [questions]);

    const allQuestionsFlat = (allClauses || []).flatMap((clause) =>
        (clause.questions || []).map((q) => ({
            ...q,
            clause_id: clause.id,
            clause_title: clause.title,
            clause_order: clause.order, // if exists
        }))
    );



    const validateSurvey = () => {
        // Check organization info
        if (!orgName.trim()) {
            return "Lütfen organizasyon adını giriniz.";
        }
        if (!fillerName.trim()) {
            return "Lütfen anketi dolduran kişinin adını giriniz.";
        }


        // Check all questions are answered (use allQuestionsFlat.answer)
        const unansweredQuestions = (allQuestionsFlat || []).filter((q) => {
            const v = q?.answer;
            return v == null || String(v).trim() === "";
        });

        if (unansweredQuestions.length > 0) {
            return `Lütfen tüm soruları cevaplayınız. ${unansweredQuestions.length} soru cevaplanmamış.`;
        }



        ////console.log("allQuestions ", allQuestionsFlat)


        return null; // No errors
    };

    const handleGoToReview = () => {
        const error = validateSurvey();
        if (error) {
            setValidationError(error);
            scrollToTop();
            return;
        }
        setValidationError(null);
        setCurrentView('review');
        // Use setTimeout to ensure state update happens before scroll
        setTimeout(() => scrollToTop(), 0);
    };

    const [isSavingDraft, setIsSavingDraft] = useState(false);
    const [draftSaved, setDraftSaved] = useState(false);

    const handleSaveDraft = async (clausesOverride) => {
    try {
        setIsSavingDraft(true);
        //console.log("draftClauses before save", draftClauses);
        const clausesToSave = clausesOverride ?? draftClauses;
        const payload = {
            survey_id: selectedSurvey,
            clauses: clausesToSave.map((clause, clauseIndex) => {
                const shouldSendClauseTitle =
                    !!clause.title && (clause._isOverlay || !!clause._tmpClauseId);

                return {
                    clause: clause.clause,
                    clause_order: clauseIndex + 1,
                    clause_title: clause.title,
                    questions: (clause.questions || []).map((q, qIndex) => ({
                        question_id: q.question_id ?? null,
                        question_text: q.question_text,
                        question_type: q.question_type,
                        required: 1,
                        question_order: qIndex + 1,
                    })),
                };
            }),
            deletedQuestionIds: deletedQuestionIds,
        };
        //console.log("Draft payload JSON:", JSON.stringify(payload, null, 2));

        //console.log("Draft payload:", payload);

        await saveSurveyDraftFN(payload);

        setDeletedQuestionIds([]);
        setDraftClauses([]);

        setDraftSaved(true);
        setTimeout(() => setDraftSaved(false), 2000);

        await loadSurvey();
    } catch (err) {
        console.error(err);
    } finally {
        setIsSavingDraft(false);
    }
};

    const handleViewDeployment = (d) => {
        ////////console.log(d)
        setselectedSurvey(d.survey_id);
        setSelectedAuditName(d.title || null);
        setSelectedAuditDeptId(d.department_id || null);
        setSelectedAuditCompId(d.compliance_id || null);
    };


    const handleExportDeployment = (d) => {
        ////////console.log(d)
    };

    const handleBackToSurvey = () => {
        setCurrentView('survey');
        setTimeout(() => scrollToTop(), 0);
    };


    const handleAuditOpen = (d) => {
        ////////console.log(d)
        setselectedSurvey(d.assigned_survey);
        setSelectedAuditName(d.title || null);
        setSelectedAuditDeptId(d.department_id || null);
        setSelectedAuditCompId(d.compliance_id || null);
        setActiveTab("survey");
    };

    const handleFinalSubmit = async () => {
        setSubmitting(true);
        try {
            const surveyData = {
                organizationName: orgName,
                fillerName: fillerName,
                answers: answers,
                survey_id: selectedSurvey
            };

            const result = await submitSurveyFN(surveyData);
            getAllAuditsFN();

            if (result.success) {
                await getFindingsBySurveyFN(selectedSurvey);
                setCurrentView('success');
                scrollToTop();
            }
        } catch (error) {
            console.error("Error submitting survey:", error);

            if (error.response?.data?.alreadySubmitted) {
                setAlreadySubmitted(true);
                setSubmittedSurvey(error.response.data.survey);
            } else {
                setValidationError("Anket gönderilirken bir hata oluştu. Lütfen tekrar deneyin.");
            }
        } finally {
            setSubmitting(false);
        }
    };



    const STATUS_COLORS = {
        in_progress: "bg-blue-500",
        completed: "bg-emerald-500",
        planned: "bg-gray-400",
        cancelled: "bg-rose-500"
    };

    const minDate = Math.min(...audits.map(a => new Date(a.start_date)));
    const maxDate = Math.max(...audits.map(a => new Date(a.end_date)));



   


    // Calculate stats for review
    // Total questions
    const getTotalQuestions = () => {
        return (allQuestionsFlat || []).length;
    };

    // Answered count (non-null / non-empty)
    const getAnsweredCount = () => {
        return (allQuestionsFlat || []).filter((q) => {
            const v = q?.answer;
            return v != null && String(v).trim() !== "";
        }).length;
    };

    // Evet count
    const getEvetCount = () => {
        return (allQuestionsFlat || []).filter(
            (q) => String(q?.answer).toLowerCase() === "evet"
        ).length;
    };

    // Hayır count
    const getHayirCount = () => {
        return (allQuestionsFlat || []).filter(
            (q) => String(q?.answer).toLowerCase() === "hayir"
        ).length;
    };


    // DEBUG: Fill all questions with Hayır
    const fillAllHayir = () => {
        const allQuestionIds = (allClauses || []).flatMap(clause =>
            (clause.questions || []).map(q => q.question_id ?? q.id)
        ).filter(Boolean);

        const newAnswers = {};
        allQuestionIds.forEach((id) => {
            newAnswers[id] = "hayir";
        });

        ////console.log("allClauses ", allClauses)
        ////console.log("allQuestionIds ", allQuestionIds)
        ////console.log("newAnswers ", newAnswers)
        setAnswers(newAnswers);
        setOrgName("Test Organization");
        setFillerName("Test User");
        if (validationError) setValidationError(null);
    };


    const [openClauses, setOpenClauses] = useState({});
    // Get all uploaded files across all questions
    const getAllUploadedFiles = () => {
        const allFiles = [];
        //////console.log("files ", files)
        Object.entries(files).forEach(([questionId, questionFiles]) => {
            if (questionFiles && questionFiles.length > 0) {
                // Find the question text
                let questionText = "";
                let clauseTitle = "";
                for (const clause of allClauses) {
                    const question = clause.questions.find(q => q.id === questionId);
                    if (question) {
                        questionText = question.text;
                        clauseTitle = clause.title;
                        break;
                    }
                }
                questionFiles.forEach((file, idx) => {
                    allFiles.push({
                        ...file,
                        questionId,
                        questionText,
                        clauseTitle,
                        index: idx
                    });
                });
            }
        });
        return allFiles;
    };

    const totalUploadedFiles = getAllUploadedFiles().length;

    // SOA filtering
    const filteredSOAControls = soaControls.filter(control => {
        const matchesSearch = soaSearch === '' ||
            control.controlId.toLowerCase().includes(soaSearch.toLowerCase()) ||
            control.controlName.toLowerCase().includes(soaSearch.toLowerCase());

        const matchesApplicability = soaApplicabilityFilter === 'all' ||
            (soaApplicabilityFilter === 'yes' && control.applicable) ||
            (soaApplicabilityFilter === 'no' && !control.applicable);

        const matchesStatus = soaStatusFilter === 'all' || control.implementationStatus === soaStatusFilter;

        return matchesSearch && matchesApplicability && matchesStatus;
    });

    // SOA stats
    const soaStats = {
        total: soaControls.length,
        applicable: soaControls.filter(c => c.applicable).length,
        implemented: soaControls.filter(c => c.implementationStatus === 'implemented').length,
    };

    // Open edit modal
    const openSoaEditModal = (control) => {
        setSoaEditModal(control.id);
        setSoaEditData({
            ...control,
            soaId: control.soaId || control.id,
            riskIds: control.riskIds || []
        });
        setNewRiskId('');
    };

    // Close edit modal
    const closeSoaEditModal = () => {
        setSoaEditModal(null);
        setSoaEditData(null);
        setNewRiskId('');
    };

    // Save SOA control changes
    const saveSoaControl = async () => {
        if (!soaEditData) return;

        setSoaSaving(true);
        try {
            // Extract risk IDs as numbers
            const riskIdNumbers = (soaEditData.riskIds || []).map(riskId => {
                const num = parseInt(riskId.replace('RISK-', ''));
                return isNaN(num) ? null : num;
            }).filter(id => id !== null);

            // Call API to update
            await updateSOAControlFN(soaEditData.soaId || soaEditData.id, {
                applicable: soaEditData.applicable,
                justification: soaEditData.justification,
                implementation_status: soaEditData.implementationStatus,
                risk_ids: riskIdNumbers
            });

            // Update local state
            setSoaControls(prev => prev.map(c =>
                c.id === soaEditData.id ? soaEditData : c
            ));
            closeSoaEditModal();
        } catch (error) {
            console.error("Error saving SOA control:", error);
            alert("Kontrol kaydedilirken bir hata oluştu.");
        } finally {
            setSoaSaving(false);
        }
    };

    // Add risk ID to edit data
    const addRiskIdToEdit = () => {
        if (newRiskId.trim() && soaEditData) {
            const riskIdUpper = newRiskId.trim().toUpperCase();
            if (!soaEditData.riskIds.includes(riskIdUpper)) {
                setSoaEditData(prev => ({
                    ...prev,
                    riskIds: [...prev.riskIds, riskIdUpper]
                }));
            }
            setNewRiskId('');
        }
    };

    // Remove risk ID from edit data
    const removeRiskIdFromEdit = (riskId) => {
        if (soaEditData) {
            setSoaEditData(prev => ({
                ...prev,
                riskIds: prev.riskIds.filter(id => id !== riskId)
            }));
        }
    };



    // useEffect(() => {
    //     if (!selectedTemplateId && templatesRaw?.length) {
    //         setSelectedTemplateId(templatesRaw[0].template_id);
    //     }
    // }, [templatesRaw, selectedTemplateId]);






    const templatesWithStats = useMemo(() => {
        const safeParse = (v) => {
            try { return typeof v === "string" ? JSON.parse(v) : v; }
            catch { return null; }
        };

        const estimateTime = (qCount) => {
            // simple heuristic: ~0.8–1.15 minutes per question
            const min = Math.max(5, Math.round(qCount * 0.8));
            const max = Math.max(min + 5, Math.round(qCount * 1.15));
            return `${min}-${max} minutes`;
        };

        return (templatesRaw || []).map((t) => {
            const tj = safeParse(t.template_json);
            const clauses = tj?.clauses || [];
            const questionCount = clauses.reduce(
                (sum, c) => sum + (c?.questions?.length || 0),
                0
            );

            return {
                ...t,
                clausesCount: clauses.length,
                questionCount,
                timeEstimate: estimateTime(questionCount),
                statusLabel: t.unlocked ? "Active" : "Draft",
                statusKey: t.unlocked ? "active" : "draft",
            };
        });
    }, [templatesRaw]);


    const filteredTemplates = useMemo(() => {
        const q = templateQuery.trim().toLowerCase();

        return (templatesWithStats || []).filter((t) => {
            if (q) {
                const hay = `${t.name ?? ""} ${t.description ?? ""}`.toLowerCase();
                if (!hay.includes(q)) return false;
            }

            if (statusFilter !== "all" && t.statusKey !== statusFilter) return false;

            // keep your current typeFilter behavior for now (name-based)
            if (typeFilter !== "all") {
                const name = (t.name || "").toLowerCase();
                if (!name.includes(typeFilter)) return false;
            }

            return true;
        });
    }, [templatesWithStats, templateQuery, statusFilter, typeFilter]);








    const handleDeploy = async (t) => {
        ////////console.log("Deploy clicked for:", t);

        try {
            const payload = {
                template_id: t.template_id ?? t.id,
                name: t.name
            };

            const res = await deploySurveyTemplateFN(payload);
            ////////console.log("Deploy success:", res);
            ////console.log("Gertitng FIles for 2", selectedSurvey)
            getSurveyFilesFN(selectedSurvey)
            // optional:    
            // toast.success("Template deployed");
            // navigate(`/surveys/${res.surveyId}`);
        } catch (err) {
            console.error("Deploy failed", err);
        }
    };





    useEffect(() => {
        if (getAllAuditsFN) {
            getAllAuditsFN()
        }
    }, [getAllAuditsFN]);

    useEffect(() => {
        if (getAllSurveysFN) {
            getAllSurveysFN()
        }
    }, [getAllSurveysFN]);

    useEffect(() => {
        if (getAllSurveysTemplateFN) {
            getAllSurveysTemplateFN()
        }
    }, [getAllSurveysTemplateFN]);

    useEffect(() => {
        if (getUsersFN) {
            getUsersFN()
        }
    }, [getUsersFN]);




    const listUsers = Array.isArray(users)
        ? users.map(u => {
            const fullName = [u.first_name, u.last_name].filter(Boolean).join(" ");
            return {
                value: u.user_id,
                label: fullName || u.email || `User ${u.user_id}`,
                avatar: u.avatar,
                email: u.email,
                role: u.role,
            };
        })
        : [];











    const toDate = (d) => (d ? new Date(d) : null);

    const formatDate = (d) => {
        if (!d) return "—";
        const dt = new Date(d);
        if (Number.isNaN(dt.getTime())) return "—";
        return dt.toLocaleDateString();
    };

    const getAuditState = (a) => {
        const p = Math.max(0, Math.min(100, Number(a.progress ?? 0)));
        const now = new Date();
        const start = toDate(a.start_date);
        const end = toDate(a.end_date);

        const isDone = p >= 100;

        // overdue = has end date, past end, not done
        const isOverdue = !!end && now > end && !isDone;

        // planned = start exists and is in the future, OR progress is 0 and start not reached yet
        const isPlanned = !!start && now < start && p === 0;

        // in progress = started and not done and not overdue
        const isInProgress = !isDone && !isOverdue && (
            (p > 0 && p < 100) ||
            (start && now >= start) // once start date hits, treat as in progress unless done/overdue
        );

        if (isDone) return { key: "done", label: t("auditPlanning.badges.completed") };
        if (isOverdue) return { key: "overdue", label: t("auditPlanning.badges.overdue") };
        if (isPlanned) return { key: "planned", label: t("auditPlanning.badges.planned") };
        if (isInProgress) return { key: "in_progress", label: t("auditPlanning.badges.inProgress") };

        // fallback
        return { key: "planned", label: t("auditPlanning.badges.planned") };
    };

    const getStatePillClasses = (stateKey) => {
        // feel free to tweak shades; these are close to the screenshot vibe
        if (stateKey === "done") return "bg-emerald-50 text-emerald-700 border-emerald-200";
        if (stateKey === "overdue") return "bg-rose-50 text-rose-700 border-rose-200";
        if (stateKey === "planned") return "bg-gray-50 text-gray-700 border-gray-200";
        return "bg-blue-50 text-blue-700 border-blue-200"; // in_progress
    };

    const getProgressBarColor = (p, stateKey) => {
        if (stateKey === "overdue") return "bg-rose-500";
        if (p >= 100) return "bg-emerald-500";
        if (p >= 60) return "bg-blue-500";
        if (p > 0) return "bg-amber-500";
        return "bg-gray-300";
    };




    const AuditRow = ({ a, onClick, deleteAuditFN, setEdit }) => {

        const [menuOpen, setMenuOpen] = React.useState(false);
        const menuRef = React.useRef(null);

        React.useEffect(() => {
            const onDoc = (e) => {
                if (!menuRef.current) return;
                if (!menuRef.current.contains(e.target)) setMenuOpen(false);
            };
            document.addEventListener("mousedown", onDoc);
            return () => document.removeEventListener("mousedown", onDoc);
        }, []);

        ////////console.log("a ", a)
        const p = Math.max(0, Math.min(100, Number(a.audit_score ?? 0)));
        const state = getAuditState(a);
        const pillCls = getStatePillClasses(state.key);
        const barCls = getProgressBarColor(p, state.key);

        const leftIcon =
            state.key === "done" ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> :
                state.key === "overdue" ? <AlertTriangle className="w-4 h-4 text-rose-600" /> :
                    state.key === "planned" ? <Calendar className="w-4 h-4 text-gray-600" /> :
                        <Clock className="w-4 h-4 text-blue-600" />;


        const onEdit = async (id) => {
            setEdit(id)
        }


        const onDelete = async (id) => {
            await deleteAuditFN(id);
            setselectedSurvey(null);
            setSelectedAuditName(null);
            setSelectedTemplateId(null)
        }

        return (
            <div
                onClick={onClick}
                className="group bg-white rounded-xl border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md transition cursor-pointer px-5 py-4"
            >
                <div className="flex items-center justify-between gap-4">
                    {/* LEFT: icon + main */}
                    <div className="flex items-center gap-4 min-w-0 flex-1">
                        <div>{leftIcon}</div>

                        <div className="min-w-0 flex-1">
                            {/* top line */}
                            <div className="flex items-center gap-3 min-w-0">
                                <span className="text-xs text-gray-500 whitespace-nowrap">
                                    {a.audit_id ? `AUD-${String(a.audit_id).padStart(3, "0")}` : "AUD-—"}
                                </span>

                                <h3 className="font-semibold text-gray-900 truncate">
                                    {a.title || t("auditPlanning.untitledAudit")}
                                </h3>

                                {/* optional pill e.g. "Internal" / "Compliance" (use whatever field you have) */}
                                {a.type && (
                                    <span className="text-xs px-2 py-0.5 rounded-full border border-blue-200 bg-blue-50 text-blue-700 whitespace-nowrap">
                                        {a.type}
                                    </span>
                                )}
                            </div>

                            {/* description */}
                            <p className="text-sm text-gray-500 truncate mt-1">
                                {a.description || <span className="text-gray-400">{t("auditPlanning.noDescription")}</span>}
                            </p>

                            {/* progress bar */}
                            <div className="mt-3">
                                <div className="h-2 w-[70%] rounded-full bg-gray-200 overflow-hidden">
                                    <div className={`h-full ${barCls}`} style={{ width: `${p}%` }} />
                                </div>
                                <div className="mt-1 text-xs text-gray-500">{p}%</div>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT: meta + status + actions */}
                    <div className="flex items-center gap-4 shrink-0">
                        {/* department (dot + label) */}
                        <div className="hidden md:flex items-center gap-2 text-sm text-gray-700">
                            <span className="w-2 h-2 rounded-full bg-blue-500" />
                            <span className="whitespace-nowrap">
                                {a.depName || "—"}
                            </span>

                        </div>

                        {/* owners */}
                        <div className="hidden lg:flex items-center gap-2">
                            {Array.isArray(a.auditors) && a.auditors.length > 0 ? (
                                a.auditors.map((u, idx) => {
                                    const label = `${u.first_name || ""} ${u.last_name || ""}`.trim() || "User";
                                    return (
                                        <Avatar
                                            key={u.user_id || idx}
                                            name={label}
                                            src={u.avatar || ""}
                                            size={28}
                                        />
                                    );
                                })
                            ) : (
                                <span className="text-sm text-gray-400">—</span>
                            )}
                        </div>


                        {/* date range */}
                        <div className="hidden lg:flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
                            <CalendarDays className="w-4 h-4 text-gray-400" />
                            <span>{formatDate(a.start_date)}</span>
                            <span className="text-gray-400">→</span>
                            <span>{formatDate(a.end_date)}</span>
                        </div>

                        {/* status pill derived from dates+progress */}
                        <span className={`text-xs px-2.5 py-1 rounded-full border whitespace-nowrap ${pillCls}`}>
                            {state.label}
                        </span>

                        {/* survey status (optional) */}
                        {a.survey_status && (
                            <span className="hidden xl:inline text-xs px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700 whitespace-nowrap">
                                {a.survey_status}
                            </span>
                        )}

                        {/* comment count placeholder (like screenshot) */}
                        {typeof a.comment_count !== "undefined" && (
                            <span className="flex items-center gap-1 text-xs px-2 py-1 rounded-full border border-gray-200 bg-white text-gray-700 whitespace-nowrap">
                                <MessageSquare className="w-3.5 h-3.5 text-gray-500" />
                                {a.comment_count}
                            </span>
                        )}

                        {/* kebab */}
                        <div className="relative" ref={menuRef}>
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setMenuOpen((s) => !s);
                                }}
                                className="p-2 rounded-lg hover:bg-gray-100 text-gray-500"
                                aria-label={t("auditPlanning.auditActions")}
                                title={t("auditPlanning.actions")}
                            >
                                <MoreVertical className="w-4 h-4" />
                            </button>

                            {menuOpen && (
                                <div
                                    className="absolute right-0 mt-2 w-36 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden z-50"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <button
                                        type="button"
                                        className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
                                        onClick={() => {
                                            setMenuOpen(false);
                                            onEdit?.(a);
                                        }}
                                    >
                                        {t("auditPlanning.edit")}
                                    </button>

                                    <button
                                        type="button"
                                        className="w-full text-left px-3 py-2 text-sm text-rose-700 hover:bg-rose-50"
                                        onClick={() => {
                                            setMenuOpen(false);
                                            onDelete?.(a.audit_id);
                                        }}
                                    >
                                        {t("auditPlanning.delete")}
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        );
    };


    const AuditCard = ({ a, onClick, deleteAuditFN, setEdit }) => {
        const [menuOpen, setMenuOpen] = React.useState(false);
        const menuRef = React.useRef(null);

        React.useEffect(() => {
            const onDoc = (e) => {
                if (!menuRef.current) return;
                if (!menuRef.current.contains(e.target)) setMenuOpen(false);
            };
            document.addEventListener("mousedown", onDoc);
            return () => document.removeEventListener("mousedown", onDoc);
        }, []);

        const p = Math.max(0, Math.min(100, Number(a.audit_score ?? 0)));
        const state = getAuditState(a);
        const pillCls = getStatePillClasses(state.key);
        const barCls = getProgressBarColor(p, state.key);

        const leftIcon =
            state.key === "done" ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> :
                state.key === "overdue" ? <AlertTriangle className="w-4 h-4 text-rose-600" /> :
                    state.key === "planned" ? <Calendar className="w-4 h-4 text-gray-600" /> :
                        <Clock className="w-4 h-4 text-blue-600" />;

        const onEdit = async () => {
            setEdit(a);
        };

        const onDelete = async () => {
            await deleteAuditFN(a.audit_id);
            setselectedSurvey(null);
            setSelectedAuditName(null);
            setSelectedTemplateId(null);
        };

        return (
            <div
                onClick={onClick}
                className="group bg-white rounded-2xl border border-gray-200 hover:border-gray-300 shadow-sm hover:shadow-md transition cursor-pointer p-5 flex flex-col"
            >
                {/* TOP: icon + audit code + title + type + kebab */}
                <div className="flex items-start justify-between gap-3">
                    <div className="flex items-start gap-3 min-w-0">
                        <div className="mt-0.5">{leftIcon}</div>

                        <div className="min-w-0">
                            <div className="flex items-center gap-2 min-w-0">
                                <span className="text-xs text-gray-500 whitespace-nowrap">
                                    {a.audit_id ? `AUD-${String(a.audit_id).padStart(3, "0")}` : "AUD-—"}
                                </span>

                                <h3 className="font-semibold text-gray-900 truncate">
                                    {a.title || t("auditPlanning.untitledAudit")}
                                </h3>

                                {a.type && (
                                    <span className="text-xs px-2 py-0.5 rounded-full border border-blue-200 bg-blue-50 text-blue-700 whitespace-nowrap">
                                        {a.type}
                                    </span>
                                )}
                            </div>

                            <p className="text-sm text-gray-500 line-clamp-2 mt-1">
                                {a.description || <span className="text-gray-400">{t("auditPlanning.noDescription")}</span>}
                            </p>
                        </div>
                    </div>

                    {/* kebab */}
                    <div className="relative" ref={menuRef}>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                setMenuOpen((s) => !s);
                            }}
                            className="p-2 rounded-lg hover:bg-gray-100 text-gray-500"
                            aria-label={t("auditPlanning.auditActions")}
                            title={t("auditPlanning.actions")}
                        >
                            <MoreVertical className="w-4 h-4" />
                        </button>

                        {menuOpen && (
                            <div
                                className="absolute right-0 mt-2 w-36 rounded-xl border border-gray-200 bg-white shadow-lg overflow-hidden z-50"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <button
                                    type="button"
                                    className="w-full text-left px-3 py-2 text-sm hover:bg-gray-50"
                                    onClick={() => {
                                        setMenuOpen(false);
                                        onEdit();
                                    }}
                                >
                                    {t("auditPlanning.edit")}
                                </button>

                                <button
                                    type="button"
                                    className="w-full text-left px-3 py-2 text-sm text-rose-700 hover:bg-rose-50"
                                    onClick={() => {
                                        setMenuOpen(false);
                                        onDelete();
                                    }}
                                >
                                    {t("auditPlanning.delete")}
                                </button>
                            </div>
                        )}
                    </div>
                </div>

                {/* PROGRESS (full width in grid) */}
                <div className="mt-4">
                    <div className="h-2 w-full rounded-full bg-gray-200 overflow-hidden">
                        <div className={`h-full ${barCls}`} style={{ width: `${p}%` }} />
                    </div>
                    <div className="mt-1 text-xs text-gray-500">{p}%</div>
                </div>

                {/* META */}
                <div className="mt-4 flex flex-wrap items-center gap-3">
                    {/* department */}
                    <div className="flex items-center gap-2 text-sm text-gray-700">
                        <span className="w-2 h-2 rounded-full bg-blue-500" />
                        <span className="whitespace-nowrap">{a.depName || "—"}</span>
                    </div>

                    {/* owners */}
                    <div className="flex items-center gap-2">
                        {Array.isArray(a.auditors) && a.auditors.length > 0 ? (
                            a.auditors.map((u, idx) => {
                                const label = `${u.first_name || ""} ${u.last_name || ""}`.trim() || "User";
                                return (
                                    <Avatar
                                        key={u.user_id || idx}
                                        name={label}
                                        src={u.avatar || ""}
                                        size={28}
                                    />
                                );
                            })
                        ) : (
                            <span className="text-sm text-gray-400">—</span>
                        )}
                    </div>

                    {/* date range */}
                    <div className="ml-auto flex items-center gap-2 text-sm text-gray-700 whitespace-nowrap">
                        <CalendarDays className="w-4 h-4 text-gray-400" />
                        <span>{formatDate(a.start_date)}</span>
                        <span className="text-gray-400">→</span>
                        <span>{formatDate(a.end_date)}</span>
                    </div>
                </div>

                {/* BOTTOM: status + optional badges */}
                <div className="mt-4 flex items-center gap-2 flex-wrap">
                    <span className={`text-xs px-2.5 py-1 rounded-full border whitespace-nowrap ${pillCls}`}>
                        {state.label}
                    </span>

                    {a.survey_status && (
                        <span className="text-xs px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700 whitespace-nowrap">
                            {a.survey_status}
                        </span>
                    )}

                    {typeof a.comment_count !== "undefined" && (
                        <span className="flex items-center gap-1 text-xs px-2 py-1 rounded-full border border-gray-200 bg-white text-gray-700 whitespace-nowrap">
                            <MessageSquare className="w-3.5 h-3.5 text-gray-500" />
                            {a.comment_count}
                        </span>
                    )}
                </div>
            </div>
        );
    };


    const [isCreateAuditOpen, setIsCreateAuditOpen] = useState(false);
    const [isSubmittingAudit, setIsSubmittingAudit] = useState(false);

    const [auditForm, setAuditForm] = useState({
        title: "",
        description: "",
        department_id: "",
        survey_id: "",
        progress: 0,        // percentage
        start_date: "",     // "YYYY-MM-DD"
        end_date: "",       // "YYYY-MM-DD"
    });

    const resetAuditForm = () => {
        setAuditForm({
            title: "",
            description: "",
            department_id: "",
            survey_id: "",
            progress: 0,
            start_date: "",
            end_date: "",
        });
    };

    const closeCreateAudit = (nextOpen) => {
        // onOpenChange gives boolean
        if (!nextOpen) {
            setIsCreateAuditOpen(false);
            resetAuditForm();
        }
    };


    const [edit, setEdit] = useState(null);

    const handleCreateAudit = async () => {
        try {
            setIsSubmittingAudit(true);

            // minimal validation
            if (!auditForm.title?.trim()) return;
            if (!auditForm.department_id) return;
            if (!auditForm.survey_id) return;

            // TODO: replace with your createAudit action/api
            // await dispatch(createAudit(auditForm))

            setIsCreateAuditOpen(false);
            resetAuditForm();
            // refresh audits list if needed
            // dispatch(getAllAudits())
        } finally {
            setIsSubmittingAudit(false);
        }
    };




    return token ? (
        <div className="w-full h-screen flex flex-col overflow-x-hidden bg-[#F8F8F8]">
            {/* Top bar */}
            <div className="flex-shrink-0">
                <TopBar />
            </div>

            {/* Main area: app sidebar + audit sidebar + content */}
            <div className="flex flex-1 overflow-hidden">
                {/* App global sidebar */}
                <div className="flex-shrink-0 h-full">
                    <Sidebar className="h-full" />
                </div>

                {/* Audit left sidebar */}
                {auditSidebarOpen && (
                <div className="w-[260px] min-w-[260px] flex-shrink-0 bg-[#FAFAFA] border-r border-[#E5E7EB] flex flex-col h-full overflow-y-auto">
                    <div className="flex items-center w-full h-[64px] border-b border-[#E5E7EB] px-4">
                        <span className="text-[18px] font-semibold text-[#2C2C2C] truncate flex-grow">Audit Management</span>
                    </div>
                    <nav className="flex-1 px-2 py-2 space-y-1">
                        {[
                            { key: 'audits',   label: 'Audits',   Icon: IoHomeOutline },
                            { key: 'findings', label: 'Findings', Icon: IoWarning },
                            { key: 'actions',  label: 'Actions',  Icon: IoCheckmarkCircle },
                            { key: 'reports',  label: 'Reports',  Icon: IoDocumentText },
                        ].map(({ key, label, Icon }) => {
                            const active = mainTab === key;
                            return (
                                <button
                                    key={key}
                                    onClick={() => {
                                        setMainTab(key);
                                        if (key === 'audits') {
                                            setActiveTab('audits');
                                            setselectedSurvey(null);
                                            setSelectedAuditName(null);
                                        }
                                    }}
                                    className={`w-full h-[40px] rounded-[10px] transition flex items-center px-3 gap-3 justify-start text-[13px] ${active ? 'bg-[#F3F4F6] text-[#2C2C2C] font-medium' : 'text-[#4B5563] hover:bg-[#F3F4F6]'}`}
                                >
                                    <Icon size={16} />
                                    {label}
                                </button>
                            );
                        })}
                    </nav>
                </div>
                )}

                {/* Content column: topbar + scrollable content */}
                <div className="flex-1 flex flex-col overflow-hidden">

                    {/* TOP BAR — always visible */}
                    <div className="flex-shrink-0 flex items-center bg-white border-b border-[#E5E7EB] px-3 h-[64px] gap-2">
                        {/* Sidebar toggle — icon changes based on state */}
                        <button
                            onClick={() => setAuditSidebarOpen((v) => !v)}
                            className="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                            title={auditSidebarOpen ? 'Collapse sidebar' : 'Expand sidebar'}
                        >
                            {auditSidebarOpen ? (
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" />
                                    <line x1="9" y1="3" x2="9" y2="21" />
                                </svg>
                            ) : (
                                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" />
                                    <line x1="9" y1="3" x2="9" y2="21" />
                                    <path d="M13 9l3 3-3 3" />
                                </svg>
                            )}
                        </button>

                        {/* Divider */}
                        <div className="w-px h-5 bg-gray-200 flex-shrink-0" />

                        {/* Breadcrumb */}
                        {mainTab === 'audits' && selectedSurvey != null ? (
                            <>
                                {/* Audits — clickable, goes back */}
                                <button
                                    onClick={() => { setselectedSurvey(null); setSelectedAuditName(null); setActiveTab('audits'); }}
                                    className="text-[15px] font-semibold text-gray-400 hover:text-gray-700 transition-colors flex-shrink-0"
                                >
                                    Audits
                                </button>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="text-gray-300 flex-shrink-0">
                                    <path d="M9 18l6-6-6-6" />
                                </svg>
                                {/* Audit name */}
                                <span className="text-[15px] font-semibold text-gray-700 truncate max-w-[200px] flex-shrink-0">
                                    {selectedAuditName || 'Audit'}
                                </span>
                                {/* Divider before sub-tabs */}
                                <div className="w-px h-5 bg-gray-200 flex-shrink-0 ml-1" />
                                {/* Sub-tabs */}
                                {[
                                    { key: 'survey',  label: 'Survey',    Icon: IoClipboardOutline,  badge: (alreadySubmitted || currentView === 'success') ? '✓' : null },
                                    { key: 'files',   label: 'Evidence',  Icon: IoFolderOpenOutline,  badge: totalUploadedFiles > 0 ? totalUploadedFiles : null },
                                    ...(!isCustomFramework ? [{ key: 'soa', label: 'SOA Table', Icon: IoGridOutline, badge: null }] : []),
                                    { key: 'results', label: 'Findings',  Icon: IoWarning,            badge: null },
                                    { key: 'actions', label: 'Actions',   Icon: IoCheckmarkCircle,    badge: null },
                                    { key: 'reports', label: 'Report',    Icon: IoDocumentText,       badge: null },
                                ].map(({ key, label, Icon, badge }) => (
                                    <button
                                        key={key}
                                        onClick={() => setActiveTab(key)}
                                        className={`flex items-center gap-1.5 px-3 h-full text-[15px] font-medium border-b-2 transition-colors ${activeTab === key ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                                    >
                                        <Icon size={15} />
                                        {label}
                                        {badge !== null && (
                                            <span className={`text-xs ${typeof badge === 'number' ? 'bg-blue-100 text-blue-600 px-1.5 py-0.5 rounded-full' : 'text-green-500'}`}>
                                                {badge}
                                            </span>
                                        )}
                                    </button>
                                ))}
                            </>
                        ) : (
                            <span className="text-[15px] font-semibold text-gray-700 flex-shrink-0 capitalize">
                                {{ audits: 'Audits', findings: 'Findings', actions: 'Actions', reports: 'Reports' }[mainTab]}
                            </span>
                        )}
                    </div>

                {/* MAIN SCROLL AREA */}
                <div className="flex-1 overflow-y-scroll" ref={scrollContainerRef}>
                    <div className="w-full max-w-[1450px] mx-auto px-4 pb-6 pt-6 bg-[#F8F8F8]">

                        {/* LOADING STATE */}
                        {loading ? (
                            <div className="flex items-center justify-center py-20">
                                <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                            </div>
                        ) : (
                            <>
                                {/* Header */}
                                {mainTab === 'audits' && !selectedSurvey && (
                                <div className="mb-6">
                                    <h1 className="text-2xl md:text-3xl font-bold text-[#0E0E0E] mb-3">
                                        {t("auditPlanning.pageTitle")}
                                    </h1>
                                    <p className="text-gray-600 leading-relaxed">
                                        {t("auditPlanning.pageSubtitle")}
                                    </p>
                                </div>
                                )}


                                {/* TAB CONTENT */}
                                {mainTab === 'findings' ? (
                                    allSurveyFindings === null ? (
                                        <div className="flex items-center justify-center py-20">
                                            <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                                        </div>
                                    ) : (() => {
                                        const normalizeStatus = (s) => (s === 'Problem' ? 'In Progress' : s || 'Open');
                                        const afFiltered = allSurveyFindings.filter((f) => {
                                            const s = normalizeStatus(f.status);
                                            if (allFindingsStatus !== 'All' && s !== allFindingsStatus) return false;
                                            if (!allFindingsQuery.trim()) return true;
                                            const q = allFindingsQuery.toLowerCase();
                                            return (
                                                (f.title || '').toLowerCase().includes(q) ||
                                                (f.finding_text || '').toLowerCase().includes(q) ||
                                                (f.audit_name || '').toLowerCase().includes(q) ||
                                                (f.owner_name || '').toLowerCase().includes(q)
                                            );
                                        });
                                        const afTotal = afFiltered.length;
                                        const afTotalPages = Math.max(1, Math.ceil(afTotal / ALL_FINDINGS_PAGE_SIZE));
                                        const afStart = (allFindingsPage - 1) * ALL_FINDINGS_PAGE_SIZE;
                                        const afRows = afFiltered.slice(afStart, afStart + ALL_FINDINGS_PAGE_SIZE);
                                        const afCounts = allSurveyFindings.reduce((acc, f) => {
                                            const s = (f.status || '').toLowerCase();
                                            if (s === 'closed') acc.closed++;
                                            else if (s === 'problem') acc.inProgress++;
                                            else acc.open++;
                                            acc.total++;
                                            return acc;
                                        }, { total: 0, open: 0, inProgress: 0, closed: 0 });
                                        const afPriorityChip = (p) => {
                                            const map = { Critical: 'bg-red-100 text-red-700 border-red-200', High: 'bg-orange-100 text-orange-700 border-orange-200', Medium: 'bg-yellow-100 text-yellow-800 border-yellow-200', Low: 'bg-green-100 text-green-700 border-green-200' };
                                            const cls = map[p] || 'bg-gray-100 text-gray-700 border-gray-200';
                                            return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{p || '—'}</span>;
                                        };
                                        const afStatusChip = (s) => {
                                            const lk = (s || '').toLowerCase();
                                            const map = { open: 'bg-blue-100 text-blue-700 border-blue-200', 'in progress': 'bg-purple-100 text-purple-700 border-purple-200', closed: 'bg-gray-200 text-gray-700 border-gray-300', problem: 'bg-rose-100 text-rose-700 border-rose-200' };
                                            const cls = map[lk] || 'bg-gray-100 text-gray-700 border-gray-200';
                                            return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{s || 'Open'}</span>;
                                        };
                                        return (
                                            <div className="space-y-4">
                                                {/* Stat cards */}
                                                <div className="grid grid-cols-4 gap-3">
                                                    {[
                                                        { label: 'Total Findings', value: afCounts.total, icon: <FiAlertTriangle className="w-4 h-4 text-gray-400" /> },
                                                        { label: 'Open', value: afCounts.open, icon: <FiClock className="w-4 h-4 text-blue-500" /> },
                                                        { label: 'In Progress', value: afCounts.inProgress, icon: <FiXCircle className="w-4 h-4 text-red-500" /> },
                                                        { label: 'Closed', value: afCounts.closed, icon: <FiCheckCircle className="w-4 h-4 text-green-500" /> },
                                                    ].map(({ label, value, icon }) => (
                                                        <div key={label} className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                                                            <div className="flex items-center justify-between"><span className="text-xs text-gray-500">{label}</span>{icon}</div>
                                                            <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {/* Filter bar */}
                                                <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                                                    <div className="flex flex-wrap items-center gap-2">
                                                        <div className="relative flex-1 min-w-[260px]">
                                                            <svg className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                            <input value={allFindingsQuery} onChange={(e) => { setAllFindingsQuery(e.target.value); setAllFindingsPage(1); }} placeholder="Search by title, audit, owner…" className="w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2 border-none focus:outline-none focus:ring-0" />
                                                        </div>
                                                        <div className="relative">
                                                            <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M3 5h18l-7 8v4l-4 2v-6L3 5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                            <select value={allFindingsStatus} onChange={(e) => { setAllFindingsStatus(e.target.value); setAllFindingsPage(1); }} className="appearance-none bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2 border-none focus:outline-none focus:ring-0">
                                                                <option value="All">All</option>
                                                                <option value="Open">Open</option>
                                                                <option value="In Progress">In Progress</option>
                                                                <option value="Closed">Closed</option>
                                                            </select>
                                                            <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" /></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Table */}
                                                <div className="shadow-xl rounded-2xl bg-white border border-gray-300 w-full">
                                                    <div className="p-4">
                                                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                                                            <div className="grid grid-cols-[140px_1.8fr_1.2fr_0.9fr_0.9fr_1.1fr_1.5fr] gap-4 px-4 py-3 bg-white text-xs font-semibold text-gray-700 border-b border-gray-200">
                                                                <div>Finding ID</div><div>Title</div><div>Audit</div><div>Priority</div><div>Status</div><div>Date</div><div>Assigned To</div>
                                                            </div>
                                                            <div className="divide-y divide-gray-200">
                                                                {afRows.length > 0 ? afRows.map((f) => {
                                                                    const year = (f.finding_date || '').slice(0, 4) || new Date().getFullYear();
                                                                    const fid = `FIN-${year}-${String(f.finding_id ?? f.id ?? 0).padStart(3, '0')}`;
                                                                    return (
                                                                        <div key={f.finding_id ?? f.id} onClick={() => handleViewFinding?.(f)} className="grid grid-cols-[140px_1.8fr_1.2fr_0.9fr_0.9fr_1.1fr_1.5fr] gap-4 items-center px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                            <div className="text-sm font-medium text-gray-700">{fid}</div>
                                                                            <div className="text-sm text-gray-800 truncate min-w-0">{f.title || f.finding_text || '—'}</div>
                                                                            <div className="text-sm text-gray-700 truncate min-w-0">{f.audit_name || '—'}</div>
                                                                            <div className="min-w-0">{afPriorityChip(f.priority)}</div>
                                                                            <div className="min-w-0">{afStatusChip(normalizeStatus(f.status))}</div>
                                                                            <div className="text-sm text-gray-700 min-w-0">{f.finding_date ? new Date(f.finding_date).toLocaleDateString() : '—'}</div>
                                                                            <div className="text-sm text-gray-700 truncate min-w-0">{f.owner_name || '—'}</div>
                                                                        </div>
                                                                    );
                                                                }) : (
                                                                    <div className="py-16 text-center text-sm text-gray-400">No findings found</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* Pagination */}
                                                        <div className="flex items-center justify-between gap-2 px-1 pt-3 text-xs text-gray-500">
                                                            <span>Showing <b className="text-gray-700">{afTotal ? afStart + 1 : 0}</b>–<b className="text-gray-700">{Math.min(afStart + ALL_FINDINGS_PAGE_SIZE, afTotal)}</b> of <b className="text-gray-700">{afTotal}</b> findings</span>
                                                            <div className="flex items-center gap-1">
                                                                <button onClick={() => setAllFindingsPage(p => Math.max(1, p - 1))} disabled={allFindingsPage === 1} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">‹</button>
                                                                {Array.from({ length: afTotalPages }, (_, i) => i + 1).map(p => (
                                                                    <button key={p} onClick={() => setAllFindingsPage(p)} className={`h-8 w-8 rounded-md border text-xs font-medium flex items-center justify-center ${allFindingsPage === p ? 'bg-[#0E0E0E] text-white border-[#0E0E0E]' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}`}>{p}</button>
                                                                ))}
                                                                <button onClick={() => setAllFindingsPage(p => Math.min(afTotalPages, p + 1))} disabled={allFindingsPage === afTotalPages} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">›</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()
                                ) : mainTab === 'actions' ? (() => {
                                    if (allSurveyActions === null) return (
                                        <div className="flex items-center justify-center py-20">
                                            <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                                        </div>
                                    );
                                    const aaIsCompleted = (label) => label === 'Completed';
                                    const aaIsOverdue = (t) => { try { return new Date(t.end) < new Date() && !aaIsCompleted(t.progressLabel); } catch { return false; } };
                                    const aaIsBehind = (t) => { try { const end = new Date(t.end); const now = new Date(); const pct = Number((t.real_progress ?? t.progress) || 0); return pct < 50 && now > end && !aaIsCompleted(t.progressLabel); } catch { return false; } };
                                    const aaStatusMeta = { 'Not started': 'bg-gray-100 text-gray-700 border-gray-200', 'In progress': 'bg-blue-100 text-blue-700 border-blue-200', 'Completed': 'bg-emerald-100 text-emerald-700 border-emerald-200', 'Problem': 'bg-rose-100 text-rose-700 border-rose-200' };
                                    const aaChipCls = (label) => { const cls = label && aaStatusMeta[label]; return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${cls || 'bg-gray-100 text-gray-700 border-gray-200'}`; };
                                    const aaPriorityChip = (p) => { const base = 'text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-medium'; const map = { Critical: `${base} bg-red-50 border-red-200 text-red-700 font-semibold`, High: `${base} bg-red-50 border-red-200 text-red-700 font-semibold`, Medium: `${base} bg-orange-50 border-orange-200 text-orange-600 font-semibold`, Low: `${base} bg-yellow-50 border-yellow-200 text-yellow-600 font-medium` }; return map[p] ? <span className={map[p]}>{p}</span> : null; };
                                    const aaCounts = allSurveyActions.reduce((acc, a) => { const pl = (a.progressLabel || a.status || '').toLowerCase().trim(); acc.total += 1; if (pl === 'completed') acc.completed++; else if (pl === 'in progress') acc.inProgress++; else if (pl === 'problem') acc.problem++; else acc.open++; return acc; }, { total: 0, open: 0, inProgress: 0, problem: 0, completed: 0 });
                                    const aaFiltered = allSurveyActions.filter((a) => { const pl = a.progressLabel || a.status || 'Not started'; if (aaActionsStatus !== 'All' && pl !== aaActionsStatus) return false; if (!aaActionsQuery.trim()) return true; const q = aaActionsQuery.toLowerCase(); return (a.name || '').toLowerCase().includes(q) || (a.project || a.audit_name || '').toLowerCase().includes(q); });
                                    const aaTotalPages = Math.max(1, Math.ceil(aaFiltered.length / ALL_ACTIONS_PAGE_SIZE));
                                    const aaStart = (aaActionsPage - 1) * ALL_ACTIONS_PAGE_SIZE;
                                    const aaPaged = aaFiltered.slice(aaStart, aaStart + ALL_ACTIONS_PAGE_SIZE);
                                    const aaYear = new Date().getFullYear();
                                    return (
                                        <div className="space-y-4">
                                            {/* Stat cards */}
                                            <div className="grid grid-cols-4 gap-3">
                                                {[
                                                    { label: 'Open Actions', value: aaCounts.open, icon: <FiClock className="w-4 h-4 text-blue-500" /> },
                                                    { label: 'In Progress', value: aaCounts.inProgress, icon: <FiRefreshCw className="w-4 h-4 text-amber-500" /> },
                                                    { label: 'Problem', value: aaCounts.problem, icon: <FiXCircle className="w-4 h-4 text-rose-500" /> },
                                                    { label: 'Completed', value: aaCounts.completed, icon: <FiCheckCircle className="w-4 h-4 text-green-500" /> },
                                                ].map(({ label, value, icon }) => (
                                                    <div key={label} className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                                                        <div className="flex items-center justify-between"><span className="text-xs text-gray-500">{label}</span>{icon}</div>
                                                        <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Filter bar */}
                                            <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <div className="relative flex-1 min-w-[260px]">
                                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                        <input value={aaActionsQuery} onChange={(e) => { setAaActionsQuery(e.target.value); setAaActionsPage(1); }} placeholder="Search actions…" className="w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2 border-none focus:outline-none focus:ring-0" />
                                                    </div>
                                                    <div className="relative">
                                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M3 5h18l-7 8v4l-4 2v-6L3 5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                        <select value={aaActionsStatus} onChange={(e) => { setAaActionsStatus(e.target.value); setAaActionsPage(1); }} className="appearance-none bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2 border-none focus:outline-none focus:ring-0">
                                                            <option value="All">All</option>
                                                            <option value="Not started">Not started</option>
                                                            <option value="In progress">In progress</option>
                                                            <option value="Problem">Problem</option>
                                                            <option value="Completed">Completed</option>
                                                        </select>
                                                        <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" /></svg>
                                                    </div>
                                                    <div className="flex items-center gap-1 ml-auto">
                                                        <button type="button" onClick={() => setAaView('table')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition ${aaView === 'table' ? 'bg-[#0F0F19] text-white' : 'bg-[#F3F4F6] text-gray-700 hover:bg-gray-200'}`}>
                                                            <RiTableFill className="w-3.5 h-3.5" /> Table
                                                        </button>
                                                        <button type="button" onClick={() => setAaView('kanban')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition ${aaView === 'kanban' ? 'bg-[#0F0F19] text-white' : 'bg-[#F3F4F6] text-gray-700 hover:bg-gray-200'}`}>
                                                            <KanbanSquare className="w-3.5 h-3.5" /> Kanban
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Kanban view */}
                                            {aaView === 'kanban' && (
                                                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-4 py-6">
                                                    <KanBanComponent overrideActions={allSurveyActions} />
                                                </div>
                                            )}
                                            {/* Table view */}
                                            {aaView === 'table' && <div className="shadow-xl rounded-2xl bg-white border border-gray-300 w-full">
                                                <div className="p-4">
                                                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                                                        <div className="grid grid-cols-[140px_1fr_120px_160px_130px_130px] gap-4 px-4 py-3 bg-white text-xs font-semibold text-gray-700 border-b border-gray-200">
                                                            <div>Action ID</div><div>Title</div><div>Priority</div><div>Status</div><div>Due</div><div>Progress</div>
                                                        </div>
                                                        <div className="divide-y divide-gray-200">
                                                            {aaPaged.length > 0 ? aaPaged.map((t) => {
                                                                const rawId = t.iid ?? t.action_id ?? t.id ?? 0;
                                                                const aid = `CNT-${aaYear}-${String(rawId).padStart(3, '0')}`;
                                                                const overdue = aaIsOverdue(t);
                                                                const behind = aaIsBehind(t);
                                                                const title = t.name || t.title || t.action_title || '—';
                                                                const openId = t.iid ?? t.action_id ?? rawId;
                                                                const pct = Math.max(0, Math.min(100, Math.round(Number(t.real_progress ?? t.progress ?? 0))));
                                                                return (
                                                                    <div key={rawId} onClick={() => { setActionId(openId); setIsActionOpen(true); }} className="grid grid-cols-[140px_1fr_120px_160px_130px_130px] gap-4 items-center px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                        <div className="text-sm font-medium text-gray-700">{aid}</div>
                                                                        <div className="min-w-0">
                                                                            <div className="flex items-center gap-2">
                                                                                <span className="text-sm text-gray-800 truncate">{title}</span>
                                                                                {behind && <span className="text-[10px] inline-flex items-center px-1.5 py-0.5 rounded bg-rose-50 text-rose-700 border border-rose-200">behind</span>}
                                                                                {overdue && <span className="text-[10px] inline-flex items-center px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">overdue</span>}
                                                                            </div>
                                                                            {t.action_description && <p className="text-xs text-gray-500 truncate mt-0.5">{t.action_description}</p>}
                                                                        </div>
                                                                        <div>{aaPriorityChip(t.priority)}</div>
                                                                        <div><span className={aaChipCls(t.progressLabel || t.status)}>{t.progressLabel || t.status || 'Not started'}</span></div>
                                                                        <div className="text-sm text-gray-700">{t.end ? new Date(t.end).toLocaleDateString() : '—'}</div>
                                                                        <div>
                                                                            <div className="text-sm font-medium text-gray-800">{pct}%</div>
                                                                            <div className="w-full h-1.5 bg-gray-200 rounded overflow-hidden mt-1">
                                                                                <div className={`h-1.5 ${aaIsCompleted(t.progressLabel) ? 'bg-emerald-500' : behind ? 'bg-rose-500' : 'bg-blue-500'}`} style={{ width: `${pct}%` }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }) : (
                                                                <div className="py-16 text-center text-sm text-gray-400">No actions found</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Pagination */}
                                                    <div className="flex items-center justify-between gap-2 px-1 pt-3 text-xs text-gray-500">
                                                        <span>Showing <b className="text-gray-700">{aaFiltered.length ? aaStart + 1 : 0}</b>–<b className="text-gray-700">{Math.min(aaStart + ALL_ACTIONS_PAGE_SIZE, aaFiltered.length)}</b> of <b className="text-gray-700">{aaFiltered.length}</b> actions</span>
                                                        <div className="flex items-center gap-1">
                                                            <button onClick={() => setAaActionsPage(p => Math.max(1, p - 1))} disabled={aaActionsPage === 1} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">‹</button>
                                                            {Array.from({ length: aaTotalPages }, (_, i) => i + 1).map(p => (
                                                                <button key={p} onClick={() => setAaActionsPage(p)} className={`h-8 w-8 rounded-md border text-xs font-medium flex items-center justify-center ${aaActionsPage === p ? 'bg-[#0E0E0E] text-white border-[#0E0E0E]' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}`}>{p}</button>
                                                            ))}
                                                            <button onClick={() => setAaActionsPage(p => Math.min(aaTotalPages, p + 1))} disabled={aaActionsPage === aaTotalPages} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">›</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    );
                                })() : mainTab === 'reports' ? (() => {
                                    const submitted = (completedSurveys || []).filter(s => s.status === 'submitted');
                                    const rd = reportSurveyData;
                                    const reportQs = Array.isArray(rd?.questions) ? rd.questions : [];
                                    const reportClauseMap = {};
                                    reportQs.forEach((q) => {
                                        if (!q?.clause) return;
                                        const key = String(q.clause);
                                        if (!reportClauseMap[key]) reportClauseMap[key] = { clause: key, questions: [] };
                                        reportClauseMap[key].questions.push(q);
                                    });
                                    const reportClauses = Object.values(reportClauseMap).sort((a, b) => String(a.clause).localeCompare(String(b.clause), 'en', { numeric: true }));
                                    const rTotal = reportQs.length;
                                    const rCompliant = reportQs.filter(q => q.question_review_status === 'Accepted').length;
                                    const rNonCompliant = reportQs.filter(q => q.question_review_status === 'Rejected').length;
                                    const rPct = rTotal > 0 ? Math.round((rCompliant / rTotal) * 100) : 0;
                                    const rRingColor = rPct >= 70 ? '#22c55e' : rPct >= 40 ? '#f59e0b' : '#ef4444';

                                    return (
                                        <div className="flex gap-4 h-full">
                                            {/* Survey list */}
                                            <div className="w-72 flex-shrink-0 space-y-2">
                                                <p className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">Submitted Surveys</p>
                                                {submitted.length === 0 && (
                                                    <p className="text-sm text-gray-400">No submitted surveys yet.</p>
                                                )}
                                                {submitted.map((s) => (
                                                    <button
                                                        key={s.survey_id}
                                                        onClick={() => loadReport(s)}
                                                        className={`w-full text-left px-4 py-3 rounded-xl border transition-all ${selectedReportSurvey?.survey_id === s.survey_id ? 'border-blue-300 bg-blue-50 shadow-sm' : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm'}`}
                                                    >
                                                        <p className="text-sm font-medium text-gray-800 truncate">{s.audit_name || '—'}</p>
                                                        <p className="text-xs text-gray-400 mt-0.5">{s.filler_name || s.email || ''}{s.submitted_at ? ` · ${s.submitted_at.slice(0, 10)}` : ''}</p>
                                                    </button>
                                                ))}
                                            </div>

                                            {/* Report panel */}
                                            <div className="flex-1 min-w-0">
                                                {!selectedReportSurvey && (
                                                    <div className="flex flex-col items-center justify-center h-64 text-center">
                                                        <IoDocumentText size={36} className="text-gray-300 mb-3" />
                                                        <p className="text-sm text-gray-400">Select a survey to view its report</p>
                                                    </div>
                                                )}
                                                {selectedReportSurvey && reportLoading && (
                                                    <div className="flex items-center justify-center py-20">
                                                        <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                                                    </div>
                                                )}
                                                {selectedReportSurvey && !reportLoading && rd && (
                                                    <div className="space-y-6">
                                                        <div>
                                                            <h2 className="text-base font-semibold text-gray-800">{selectedReportSurvey.audit_name || '—'}</h2>
                                                            <p className="text-xs text-gray-500 mt-0.5">{selectedReportSurvey.filler_name || selectedReportSurvey.email || ''}{selectedReportSurvey.submitted_at ? ` · Submitted ${selectedReportSurvey.submitted_at.slice(0, 10)}` : ''}</p>
                                                        </div>

                                                        {/* Compliance summary */}
                                                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                                                            <div className="flex items-center justify-between mb-4">
                                                                <div>
                                                                    <h3 className="text-sm font-semibold text-gray-800">Compliance Summary</h3>
                                                                    <p className="text-xs text-gray-500">Auditor decision breakdown per question</p>
                                                                </div>
                                                                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                                                    {rCompliant + rNonCompliant}/{rTotal} Reviewed
                                                                </span>
                                                            </div>
                                                            <div className="flex items-center gap-8">
                                                                <div className="relative w-28 h-28 flex-shrink-0">
                                                                    <svg className="w-28 h-28 transform -rotate-90">
                                                                        <circle cx="56" cy="56" r="48" stroke="#e5e7eb" strokeWidth="10" fill="none" />
                                                                        <circle cx="56" cy="56" r="48" stroke={rRingColor} strokeWidth="10" fill="none"
                                                                            strokeDasharray={`${(rPct / 100) * 301.59} 301.59`} strokeLinecap="round" />
                                                                    </svg>
                                                                    <div className="absolute inset-0 flex items-center justify-center">
                                                                        <span className="text-xl font-bold text-gray-800">{rPct}%</span>
                                                                    </div>
                                                                </div>
                                                                <div className="flex-1 grid grid-cols-2 gap-3">
                                                                    <div className="bg-emerald-50 rounded-lg p-3 text-center">
                                                                        <p className="text-2xl font-bold text-emerald-700">{rCompliant}</p>
                                                                        <p className="text-xs text-emerald-600 font-medium mt-1">Compliant</p>
                                                                    </div>
                                                                    <div className="bg-red-50 rounded-lg p-3 text-center">
                                                                        <p className="text-2xl font-bold text-red-700">{rNonCompliant}</p>
                                                                        <p className="text-xs text-red-600 font-medium mt-1">Non-Compliant</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Clause breakdown */}
                                                        {reportClauses.length > 0 && (
                                                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                                            <div className="p-4 border-b border-gray-200">
                                                                <h3 className="text-sm font-semibold text-gray-800">Clause Breakdown</h3>
                                                            </div>
                                                            <div className="divide-y divide-gray-100">
                                                                {reportClauses.map((clause, idx) => {
                                                                    const cqs = clause.questions || [];
                                                                    const cTotal = cqs.length;
                                                                    const cCompliant = cqs.filter(q => q.question_review_status === 'Accepted').length;
                                                                    const cNonCompliant = cqs.filter(q => q.question_review_status === 'Rejected').length;
                                                                    const cPct = cTotal > 0 ? Math.round((cCompliant / cTotal) * 100) : 0;
                                                                    const barColor = cPct >= 70 ? 'bg-green-500' : cPct >= 40 ? 'bg-amber-500' : 'bg-red-400';
                                                                    return (
                                                                        <div key={clause.clause || idx} className="p-4 hover:bg-gray-50">
                                                                            <div className="flex items-center justify-between mb-1.5">
                                                                                <span className="text-sm font-medium text-gray-800">{clause.title || clause.clause}</span>
                                                                                <span className="text-sm font-semibold text-gray-600">{cPct}%</span>
                                                                            </div>
                                                                            <div className="w-full bg-gray-200 rounded-full h-1.5 mb-1.5">
                                                                                <div className={`h-1.5 rounded-full ${barColor}`} style={{ width: `${cPct}%` }} />
                                                                            </div>
                                                                            <div className="flex items-center gap-4 text-xs text-gray-500">
                                                                                <span>{cTotal} questions</span>
                                                                                <span className="text-emerald-600">{cCompliant} compliant</span>
                                                                                <span className="text-red-600">{cNonCompliant} non-compliant</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>
                                                        </div>
                                                        )}

                                                        {/* Question table */}
                                                        {reportQs.length > 0 && (
                                                        <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                                            <div className="p-4 border-b border-gray-200">
                                                                <h3 className="text-sm font-semibold text-gray-800">Question Review Table</h3>
                                                            </div>
                                                            <table className="w-full text-sm">
                                                                <thead>
                                                                    <tr className="bg-gray-50 text-xs font-semibold text-gray-500 border-b border-gray-200">
                                                                        <th className="px-4 py-3 text-left w-[40%]">Question</th>
                                                                        <th className="px-4 py-3 text-left w-[12%]">Answer</th>
                                                                        <th className="px-4 py-3 text-left w-[13%]">Decision</th>
                                                                        <th className="px-4 py-3 text-left w-[35%]">Fail Reason</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody className="divide-y divide-gray-100">
                                                                    {reportQs.map((q, qi) => {
                                                                        const decision = q.question_review_status;
                                                                        const decColor = decision === 'Accepted' ? 'bg-green-100 text-green-700' : decision === 'Rejected' ? 'bg-red-100 text-red-700' : 'bg-gray-100 text-gray-500';
                                                                        return (
                                                                            <tr key={q.question_id ?? qi} className="hover:bg-gray-50">
                                                                                <td className="px-4 py-3 text-gray-800">{q.question || q.text || '—'}</td>
                                                                                <td className="px-4 py-3 text-gray-600">{q.answer ?? '—'}</td>
                                                                                <td className="px-4 py-3"><span className={`text-xs font-medium px-2 py-0.5 rounded-full ${decColor}`}>{decision || 'Pending'}</span></td>
                                                                                <td className="px-4 py-3 text-gray-500 text-xs">{q.fail_reason || q.review_note || '—'}</td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        )}

                                                        {rTotal === 0 && (
                                                            <div className="text-center py-12 text-sm text-gray-400">No question data available for this survey.</div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })() : (
                                <>

                                {/* SOA TABLOSU TAB */}
                                {activeTab === 'audits' && (
                                    <>
                                        <div className="bg-white border border-gray-200 rounded-xl p-4 mt-2 mb-4 shadow-sm">
                                            <div className="flex flex-wrap items-center gap-2">

                                                {/* SEARCH */}
                                                <div className="relative flex-1 min-w-[260px]">
                                                    <input
                                                        value={auditQuery}
                                                        onChange={(e) => setAuditQuery(e.target.value)}
                                                        placeholder={t("auditPlanning.searchPlaceholder")}
                                                        className="
          w-full bg-gray-50 rounded-md text-xs pl-8 pr-3 py-2
          outline-none border-none
          focus:outline-none focus:ring-0 focus:border-none
          active:outline-none active:ring-0 active:border-none
        "
                                                    />
                                                    <svg
                                                        className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500"
                                                        viewBox="0 0 24 24" fill="none"
                                                    >
                                                        <path
                                                            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>

                                                {/* TYPE FILTER */}
                                                <div className="relative">
                                                    <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
                                                        <path
                                                            d="M3 5h18l-7 8v4l-4 2v-6L3 5z"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                        />
                                                    </svg>
                                                    <select
                                                        value={auditTypeView}
                                                        onChange={(e) => setAuditTypeView(e.target.value)}
                                                        className="
          appearance-none
          bg-gray-50 rounded-md text-xs pl-8 pr-6 py-2
          outline-none border-none
          focus:outline-none focus:ring-0 focus:border-none
        "
                                                    >
                                                        {[
                                                            { value: "All", label: t("auditPlanning.filters.all") },
                                                            { value: "Internal", label: t("auditPlanning.filters.internal") },
                                                            { value: "External", label: t("auditPlanning.filters.external") },
                                                            { value: "Vendor", label: t("auditPlanning.filters.vendor") },
                                                        ].map((option) => (
                                                            <option key={option.value} value={option.value}>{option.label}</option>
                                                        ))}
                                                    </select>
                                                    <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                    </svg>
                                                </div>

                                                {/* ✅ REMOVE: SEVERITY / RISK RATING FILTER */}

                                                {/* STATUS FILTER */}
                                                <div className="relative">
                                                    <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" viewBox="0 0 24 24">
                                                        <path d="M5 12h14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                                                    </svg>
                                                    <select
                                                        value={auditStatusView}
                                                        onChange={(e) => setAuditStatusView(e.target.value)}
                                                        className="
          appearance-none
          bg-gray-50 rounded-md text-xs pl-8 pr-6 py-2
          outline-none border-none
          focus:outline-none focus:ring-0 focus:border-none
        "
                                                    >
                                                        {[
                                                            { value: "All", label: t("auditPlanning.filters.all") },
                                                            { value: "Planned", label: t("auditPlanning.badges.planned") },
                                                            { value: "In Progress", label: t("auditPlanning.badges.inProgress") },
                                                            { value: "Completed", label: t("auditPlanning.badges.completed") },
                                                            { value: "Canceled", label: t("auditPlanning.badges.canceled") },
                                                        ].map((option) => (
                                                            <option key={option.value} value={option.value}>{option.label}</option>
                                                        ))}
                                                    </select>
                                                    <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                        <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                    </svg>
                                                </div>

                                                {/* ✅ RIGHT SIDE: Create + Toggle */}
                                                <div className="flex items-center gap-2 ml-auto">
                                                    <button
                                                        type="button"
                                                        onClick={() => setIsCreateAuditOpen(true)}
                                                        className="
          h-9 px-3.5 rounded-lg text-sm font-medium
          bg-[#0E0E0E] text-white
          hover:bg-black/90 active:scale-[0.99]
          transition
        "
                                                    >
                                                        {t("auditPlanning.buttons.createAudit")}
                                                    </button>

                                                    {/* GRID / TABLE TOGGLE — unchanged */}
                                                    {showToggle && viewMode !== undefined && setViewMode && (
                                                        <div className="flex items-center gap-0 border border-gray-300 rounded-lg overflow-hidden">

                                                            {/* TABLE */}
                                                            <button
                                                                onClick={() => setViewMode("table")}
                                                                className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition
        ${viewMode === "table"
                                                                        ? "bg-[#0E0E0E] text-white"
                                                                        : "bg-white text-gray-600 hover:bg-gray-50"
                                                                    }`}
                                                            >
                                                                {viewMode === "table"
                                                                    ? <RiTableFill size={16} />
                                                                    : <RiTableLine size={16} />
                                                                }
                                                            </button>

                                                            {/* GRID */}
                                                            <button
                                                                onClick={() => setViewMode("grid")}
                                                                className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition border-l border-gray-300
        ${viewMode === "grid"
                                                                        ? "bg-[#0E0E0E] text-white"
                                                                        : "bg-white text-gray-600 hover:bg-gray-50"
                                                                    }`}
                                                            >
                                                                {viewMode === "grid"
                                                                    ? <RiGridFill size={16} />
                                                                    : <RiGridLine size={16} />
                                                                }
                                                            </button>

                                                            <button
                                                                onClick={() => setViewMode("gantt")}
                                                                className={`flex items-center justify-center gap-2 px-3.5 py-1.5 text-sm font-medium transition border-l border-gray-300
        ${viewMode === "gantt"
                                                                        ? "bg-[#0E0E0E] text-white"
                                                                        : "bg-white text-gray-600 hover:bg-gray-50"
                                                                    }`}
                                                            >
                                                                <GanttChart className="w-4 h-4" />
                                                            </button>


                                                        </div>
                                                    )}

                                                </div>

                                            </div>
                                        </div>

                                        {/* AUDITS (under search bar) */}
                                        <div className="shadow-xl bg-white rounded-2xl border border-gray-200 mt-4 mb-6">

                                            {/* Header */}
                                            <div className="px-6 py-4">
                                                {viewMode === "gantt" ? (
                                                    <>
                                                        <h3 className="text-gray-900 font-medium">{t("auditPlanning.gantt.title")}</h3>
                                                        <p className="text-sm text-gray-500">{t("auditPlanning.gantt.subtitle")}</p>
                                                    </>
                                                ) : (
                                                    <>
                                                        <h3 className="text-gray-900 font-medium">{t("auditPlanning.listTitle")}</h3>
                                                        <p className="text-sm text-gray-500">
                                                            {t("auditPlanning.auditsFound", { count: filteredAudits?.length ?? 0 })}
                                                        </p>
                                                    </>
                                                )}
                                            </div>

                                            {/* Content */}
                                            <div className="px-4 pt-4 pb-4">

                                                {(filteredAudits?.length ?? 0) === 0 ? (
                                                    <div className="bg-white rounded-xl border border-gray-200 px-4 py-6 text-sm text-gray-500">
                                                        {t("auditPlanning.noAuditsFound")}
                                                    </div>

                                                ) : viewMode === "grid" ? (

                                                    /* ================= GRID MODE ================= */
                                                    <div className="grid gap-4 [grid-template-columns:repeat(auto-fit,minmax(360px,1fr))]">
                                                        {filteredAudits.map((a) => (
                                                            <AuditCard
                                                                key={a.audit_id || a.id}
                                                                a={a}
                                                                deleteAuditFN={deleteAuditFN}
                                                                setEdit={setEdit}
                                                                onClick={() => handleAuditOpen(a)}
                                                            />
                                                        ))}
                                                    </div>

                                                ) : viewMode === "table" ? (

                                                    /* ================= TABLE / LIST MODE ================= */
                                                    <div className="space-y-3">
                                                        {filteredAudits.map((a) => (
                                                            <AuditRow
                                                                key={a.audit_id || a.id}
                                                                a={a}
                                                                deleteAuditFN={deleteAuditFN}
                                                                onClick={() => handleAuditOpen(a)}
                                                                setEdit={setEdit}
                                                            />
                                                        ))}
                                                    </div>

                                                ) : viewMode === "gantt" ? (

                                                    /* ================= GANTT MODE ================= */
                                                    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6">
                                                        {/* Month ruler */}
                                                        <div className="grid grid-cols-[260px_1fr]">
                                                            <div />
                                                            <div className="relative h-10 border-b border-gray-200">
                                                                {monthTicks.map((m, idx) => (
                                                                    <div
                                                                        key={idx}
                                                                        className="absolute top-0 h-full"
                                                                        style={{ left: `${leftPct(m)}%` }}
                                                                    >
                                                                        <div className="text-xs text-gray-500 -translate-x-1/2">
                                                                            {m.toLocaleString("en-US", { month: "short", year: "numeric" })}
                                                                        </div>
                                                                        <div className="absolute top-6 left-0 w-px h-4 bg-gray-200" />
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>

                                                        {/* Rows */}
                                                        <div className="mt-2">
                                                            {auditsForGantt.map((audit) => {
                                                                const st = getAuditStatus(audit);
                                                                const s = STATUS[st];
                                                                ////console.log("audit ", audit)
                                                                const p = Math.max(0, Math.min(100, Number(audit.audit_score ?? 0)));

                                                                return (
                                                                    <div
                                                                        key={audit.audit_id || audit.id}
                                                                        className="grid grid-cols-[260px_1fr] py-5 border-b border-gray-100"
                                                                    >
                                                                        {/* LEFT */}
                                                                        <div className="pr-4">
                                                                            <p className="font-medium text-gray-900">{audit.title}</p>

                                                                            <div className="flex items-center gap-2 mt-2 text-xs">
                                                                                <span className={`inline-flex items-center px-2.5 py-1 rounded-full border ${s.chip}`}>
                                                                                    {st.replace("_", " ")}
                                                                                </span>

                                                                                <span className="inline-flex items-center gap-2 text-gray-600">
                                                                                    <span className={`w-2 h-2 rounded-full ${s.dot}`} />
                                                                                    {audit.depName || "—"}
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                        {/* TIMELINE */}
                                                                        <div className="relative">
                                                                            {/* faint lane line */}
                                                                            <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-px bg-gray-100" />

                                                                            {/* bar track */}
                                                                            <div
                                                                                className="absolute top-1/2 -translate-y-1/2 h-8"
                                                                                style={{
                                                                                    left: `${leftPct(audit.start_date)}%`,
                                                                                    width: `${widthPct(audit.start_date, audit.end_date)}%`,
                                                                                    minWidth: 10,
                                                                                }}
                                                                            >
                                                                                <div className="relative w-full h-full rounded-lg border border-gray-200 bg-white overflow-hidden shadow-sm">
                                                                                    {/* progress fill */}
                                                                                    <div className={`h-full ${s.bar}`} style={{ width: `${p}%` }} />

                                                                                    {/* label */}
                                                                                    <div className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-white">
                                                                                        AUD-{audit.audit_id} · {p}%
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>

                                                        {/* Legend */}
                                                        <div className="flex items-center gap-6 text-xs text-gray-600 mt-5">
                                                            <span className="text-gray-500">{t("auditPlanning.gantt.statusPrefix")}</span>
                                                            <span className="inline-flex items-center gap-2"><span className="w-4 h-4 rounded bg-blue-600" /> {t("auditPlanning.badges.inProgress")}</span>
                                                            <span className="inline-flex items-center gap-2"><span className="w-4 h-4 rounded bg-emerald-600" /> {t("auditPlanning.badges.completed")}</span>
                                                            <span className="inline-flex items-center gap-2"><span className="w-4 h-4 rounded bg-gray-500" /> {t("auditPlanning.badges.planned")}</span>
                                                            <span className="inline-flex items-center gap-2"><span className="w-4 h-4 rounded bg-rose-600" /> {t("auditPlanning.gantt.legendCancelled")}</span>
                                                        </div>
                                                    </div>

                                                ) : null}

                                            </div>

                                            {/* Footer placeholder */}
                                            <div className="border-t border-gray-200 mt-4" />
                                        </div>




                                    </>
                                )}





                                {/* FILES TAB */}
                                {activeTab === 'files' && (() => {
                                    const parseTags = (raw) => {
                                        if (!raw) return [];
                                        if (Array.isArray(raw)) return raw;
                                        try { return JSON.parse(raw); } catch { return []; }
                                    };
                                    const isExpiringSoon = (dateStr) => {
                                        if (!dateStr) return false;
                                        const diff = (new Date(dateStr) - new Date()) / (1000 * 60 * 60 * 24);
                                        return diff > 0 && diff <= 30;
                                    };
                                    const getDisplayStatus = (ev) => {
                                        if (ev.status === 'Expired') return 'Expired';
                                        if (ev.status === 'Active' && isExpiringSoon(ev.expiry_date)) return 'Expiring';
                                        if (ev.status === 'Active') return 'Valid';
                                        return ev.status || 'Unknown';
                                    };
                                    const typeColors = {
                                        Certification: 'bg-blue-100 text-blue-700',
                                        Contract: 'bg-purple-100 text-purple-700',
                                        'Test Report': 'bg-orange-100 text-orange-700',
                                        'Policy Document': 'bg-green-100 text-green-700',
                                    };
                                    const statusDot = { Valid: 'bg-green-500', Expiring: 'bg-orange-500', Expired: 'bg-red-500' };
                                    const statusText = { Valid: 'text-green-700', Expiring: 'text-orange-700', Expired: 'text-red-700' };
                                    const statusBg = { Valid: 'bg-green-50 border-green-200', Expiring: 'bg-orange-50 border-orange-200', Expired: 'bg-red-50 border-red-200' };

                                    const totalCount = auditEvidenceList.length;
                                    const validCount = auditEvidenceList.filter(ev => getDisplayStatus(ev) === 'Valid').length;
                                    const expiringCount = auditEvidenceList.filter(ev => getDisplayStatus(ev) === 'Expiring').length;
                                    const expiredCount = auditEvidenceList.filter(ev => getDisplayStatus(ev) === 'Expired').length;

                                    const allCategories = [...new Set(auditEvidenceList.map(ev => ev.category).filter(Boolean))];

                                    const filtered = auditEvidenceList.filter(ev => {
                                        const q = evidenceSearch.trim().toLowerCase();
                                        const tags = parseTags(ev.tags);
                                        const matchesSearch = !q || (
                                            (ev.evidence_title || '').toLowerCase().includes(q) ||
                                            (ev.vendor || '').toLowerCase().includes(q) ||
                                            (ev.type || '').toLowerCase().includes(q) ||
                                            tags.some(t => t.toLowerCase().includes(q))
                                        );
                                        const displayStatus = getDisplayStatus(ev);
                                        const matchesStatus = !evidenceStatusFilter || displayStatus === evidenceStatusFilter;
                                        const matchesCategory = !evidenceCategoryFilter || ev.category === evidenceCategoryFilter;
                                        return matchesSearch && matchesStatus && matchesCategory;
                                    });

                                    return (
                                        <div className="space-y-5">
                                            {/* Header */}
                                            <div>
                                                <h2 className="text-xl font-semibold text-gray-900">Evidence Repository</h2>
                                                <p className="text-sm text-gray-500 mt-0.5">Store and manage compliance evidence and certifications</p>
                                            </div>

                                            {/* Stat cards */}
                                            <div className="grid grid-cols-4 gap-4">
                                                {[
                                                    { label: 'Total Evidence', value: totalCount, icon: <IoAttachOutline size={22} className="text-gray-500" />, valueClass: 'text-gray-900' },
                                                    { label: 'Valid', value: validCount, icon: <IoCheckmarkCircle size={22} className="text-green-500" />, valueClass: 'text-green-600' },
                                                    { label: 'Expiring Soon', value: expiringCount, icon: <IoTimeOutline size={22} className="text-orange-500" />, valueClass: 'text-orange-500' },
                                                    { label: 'Expired', value: expiredCount, icon: <IoCloseCircleOutline size={22} className="text-red-500" />, valueClass: 'text-red-500' },
                                                ].map(card => (
                                                    <div key={card.label} className="bg-white rounded-xl border border-gray-200 shadow-sm p-5">
                                                        <div className="mb-3">{card.icon}</div>
                                                        <p className="text-sm text-gray-500 mb-1">{card.label}</p>
                                                        <p className={`text-3xl font-bold ${card.valueClass}`}>{card.value}</p>
                                                    </div>
                                                ))}
                                            </div>

                                            {/* Search + filters */}
                                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-4 py-3 flex items-center gap-3">
                                                <div className="relative flex-1">
                                                    <IoSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                                                    <input
                                                        type="text"
                                                        placeholder="Search by title, vendor, type, tags..."
                                                        value={evidenceSearch}
                                                        onChange={e => setEvidenceSearch(e.target.value)}
                                                        className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                    />
                                                </div>
                                                <select
                                                    value={evidenceStatusFilter}
                                                    onChange={e => setEvidenceStatusFilter(e.target.value)}
                                                    className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                >
                                                    <option value="">All Statuses</option>
                                                    <option value="Valid">Valid</option>
                                                    <option value="Expiring">Expiring Soon</option>
                                                    <option value="Expired">Expired</option>
                                                </select>
                                                <select
                                                    value={evidenceCategoryFilter}
                                                    onChange={e => setEvidenceCategoryFilter(e.target.value)}
                                                    className="text-sm border border-gray-200 rounded-lg px-3 py-2 bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                >
                                                    <option value="">All Categories</option>
                                                    {allCategories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
                                                </select>
                                            </div>

                                            {/* Table */}
                                            <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                                                <table className="w-full text-sm">
                                                    <thead>
                                                        <tr className="border-b border-gray-200 bg-gray-50 text-xs font-semibold text-gray-600">
                                                            <th className="text-left px-5" style={{ padding: '9px 20px', height: 'auto' }}>Evidence Title</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Vendor</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Type</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Category</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Uploaded By</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Expiry Date</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Status</th>
                                                            <th className="text-left" style={{ padding: '9px 16px', height: 'auto' }}>Tags</th>
                                                            <th style={{ padding: '9px 16px', height: 'auto' }} />
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-100">
                                                        {filtered.length === 0 ? (
                                                            <tr>
                                                                <td colSpan={9} className="px-5 py-14 text-center">
                                                                    <HiOutlineDocumentText className="mx-auto text-gray-300 mb-3" size={40} />
                                                                    <p className="text-sm text-gray-500">
                                                                        {auditEvidenceList.length === 0 ? 'No evidence added yet' : 'No evidence matches your filters'}
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        ) : filtered.map((ev, idx) => {
                                                            const tags = parseTags(ev.tags);
                                                            const displayStatus = getDisplayStatus(ev);
                                                            const ext = (ev.file_name || '').split('.').pop().toUpperCase();
                                                            const evId = `EV${String(ev.evidence_id || idx + 1).padStart(3, '0')}`;
                                                            const isExpiring = displayStatus === 'Expiring';
                                                            const isExpired = displayStatus === 'Expired';
                                                            const uploaderName = ev.uploaded_by_name || ev.uploader_name || null;
                                                            const uploaderInitial = uploaderName ? uploaderName.charAt(0).toUpperCase() : null;
                                                            const avatarColors = ['bg-blue-500','bg-purple-500','bg-green-500','bg-orange-500','bg-pink-500'];
                                                            const avatarColor = avatarColors[(ev.evidence_id || idx) % avatarColors.length];
                                                            return (
                                                                <tr key={ev.evidence_id} className="hover:bg-gray-50 transition-colors">
                                                                    {/* Evidence Title */}
                                                                    <td className="px-5 py-3">
                                                                        <div className="flex items-center gap-3">
                                                                            <div className="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center flex-shrink-0">
                                                                                <HiOutlineDocumentText size={16} className="text-blue-600" />
                                                                            </div>
                                                                            <div className="min-w-0">
                                                                                <p className="font-medium text-gray-900 truncate" title={ev.evidence_title}>{ev.evidence_title || '—'}</p>
                                                                                <p className="text-xs text-gray-400 mt-0.5">{evId}{ext ? ` · ${ext}` : ''}</p>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                    {/* Vendor */}
                                                                    <td className="px-4 py-3 text-gray-700">{ev.vendor || '—'}</td>
                                                                    {/* Type */}
                                                                    <td className="px-4 py-3">
                                                                        {ev.type ? (
                                                                            <span className={`text-xs font-medium px-2.5 py-1 rounded-full ${typeColors[ev.type] || 'bg-gray-100 text-gray-600'}`}>{ev.type}</span>
                                                                        ) : <span className="text-gray-400">—</span>}
                                                                    </td>
                                                                    {/* Category */}
                                                                    <td className="px-4 py-3 text-gray-700">{ev.category || '—'}</td>
                                                                    {/* Uploaded By */}
                                                                    <td className="px-4 py-3">
                                                                        {uploaderName ? (
                                                                            <div className="flex items-center gap-2">
                                                                                <div className={`w-7 h-7 rounded-full ${avatarColor} flex items-center justify-center text-white text-xs font-semibold flex-shrink-0`}>
                                                                                    {uploaderInitial}
                                                                                </div>
                                                                                <span className="text-gray-700 text-sm">{uploaderName}</span>
                                                                            </div>
                                                                        ) : <span className="text-gray-400">—</span>}
                                                                    </td>
                                                                    {/* Expiry Date */}
                                                                    <td className={`px-4 py-3 text-sm font-medium ${isExpiring ? 'text-orange-600' : isExpired ? 'text-red-600' : 'text-gray-700'}`}>
                                                                        {ev.expiry_date ? ev.expiry_date.slice(0, 10) : '—'}
                                                                    </td>
                                                                    {/* Status */}
                                                                    <td className="px-4 py-3">
                                                                        <span className={`inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1 rounded-full border ${statusBg[displayStatus] || 'bg-gray-50 border-gray-200'} ${statusText[displayStatus] || 'text-gray-600'}`}>
                                                                            <span className={`w-1.5 h-1.5 rounded-full ${statusDot[displayStatus] || 'bg-gray-400'}`} />
                                                                            {displayStatus}
                                                                        </span>
                                                                    </td>
                                                                    {/* Tags */}
                                                                    <td className="px-4 py-3">
                                                                        {tags.length > 0 ? (
                                                                            <div className="flex items-center flex-wrap gap-1">
                                                                                {tags.slice(0, 2).map((tag, i) => (
                                                                                    <span key={i} className="inline-flex items-center gap-1 text-xs text-gray-500">
                                                                                        <IoPricetagOutline size={11} className="text-gray-400" />
                                                                                        {tag}
                                                                                    </span>
                                                                                ))}
                                                                                {tags.length > 2 && <span className="text-xs text-gray-400">+{tags.length - 2}</span>}
                                                                            </div>
                                                                        ) : <span className="text-gray-400">—</span>}
                                                                    </td>
                                                                    {/* Actions */}
                                                                    <td className="px-4 py-3 text-right whitespace-nowrap">
                                                                        <div className="flex items-center justify-end gap-2">
                                                                            {ev.s3_path && (
                                                                                <button
                                                                                    type="button"
                                                                                    onClick={() => setFilePreview({ url: ev.s3_path, name: ev.file_name || ev.evidence_title || 'File' })}
                                                                                    className="text-xs font-medium text-blue-600 hover:text-blue-800 px-2.5 py-1 rounded-lg border border-blue-200 bg-blue-50 hover:bg-blue-100 transition-colors"
                                                                                >
                                                                                    View
                                                                                </button>
                                                                            )}
                                                                            <button
                                                                                type="button"
                                                                                onClick={async () => {
                                                                                    try {
                                                                                        await deleteEvidenceFN(ev.evidence_id);
                                                                                        const data = await getEvidenceFN({ survey_id: selectedSurvey });
                                                                                        setAuditEvidenceList(Array.isArray(data) ? data : []);
                                                                                    } catch (e) { console.error(e); }
                                                                                }}
                                                                                className="text-xs font-medium text-red-600 hover:text-red-800 px-2.5 py-1 rounded-lg border border-red-200 bg-red-50 hover:bg-red-100 transition-colors"
                                                                            >
                                                                                Delete
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* File preview modal */}
                                {filePreview && (
                                    <div
                                        className="fixed inset-0 z-[99999] flex items-center justify-center"
                                        style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
                                        onClick={(e) => { if (e.target === e.currentTarget) setFilePreview(null); }}
                                    >
                                        <div className="bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden" style={{ width: '85vw', height: '88vh' }}>
                                            <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200 flex-shrink-0">
                                                <div className="flex items-center gap-2 min-w-0">
                                                    <HiOutlineDocumentText size={18} className="text-gray-500 flex-shrink-0" />
                                                    <span className="text-sm font-medium text-gray-800 truncate">{filePreview.name}</span>
                                                </div>
                                                <div className="flex items-center gap-3 flex-shrink-0 ml-4">
                                                    <a href={filePreview.url} target="_blank" rel="noopener noreferrer"
                                                        className="text-xs text-blue-600 hover:underline font-medium">
                                                        Yeni sekmede aç
                                                    </a>
                                                    <button type="button" onClick={() => setFilePreview(null)} className="text-gray-400 hover:text-gray-600">
                                                        <IoClose size={20} />
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="flex-1 overflow-hidden bg-gray-100">
                                                {(() => {
                                                    const ext = (filePreview.name || '').split('.').pop().toLowerCase();
                                                    if (['png', 'jpg', 'jpeg', 'gif', 'webp', 'svg'].includes(ext)) {
                                                        return (
                                                            <div className="w-full h-full flex items-center justify-center p-4">
                                                                <img src={filePreview.url} alt={filePreview.name}
                                                                    className="max-w-full max-h-full object-contain rounded shadow" />
                                                            </div>
                                                        );
                                                    }
                                                    if (ext === 'pdf') {
                                                        return <iframe src={filePreview.url} title={filePreview.name} className="w-full h-full border-0" />;
                                                    }
                                                    if (['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(ext)) {
                                                        const viewerUrl = `https://docs.google.com/gview?url=${encodeURIComponent(filePreview.url)}&embedded=true`;
                                                        return <iframe src={viewerUrl} title={filePreview.name} className="w-full h-full border-0" />;
                                                    }
                                                    return (
                                                        <div className="w-full h-full flex flex-col items-center justify-center gap-3 text-gray-500">
                                                            <HiOutlineDocumentText size={48} className="text-gray-300" />
                                                            <p className="text-sm">Bu dosya türü önizlenemiyor.</p>
                                                            <a href={filePreview.url} target="_blank" rel="noopener noreferrer"
                                                                className="text-blue-600 hover:underline text-sm font-medium">
                                                                Dosyayı indir / aç
                                                            </a>
                                                        </div>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* SOA TABLOSU TAB */}
                                {activeTab === 'soa' && (
                                    <>
                                        {/* Header with icon */}
                                        <div className="flex items-start gap-4 mb-6">
                                            <div className="w-14 h-14 bg-blue-50 rounded-lg flex items-center justify-center flex-shrink-0">
                                                <IoDocumentText className="text-blue-600" size={28} />
                                            </div>
                                            <div>
                                                <h2 className="text-xl font-bold text-gray-900">ISO 27001:2022 Statement of Applicability (SOA) Tablosu</h2>
                                                <p className="text-sm text-gray-600 mt-1">
                                                    Bu tablo, ISO 27001:2022 Ek A'da yer alan 93 güvenlik kontrolünü içermektedir. Her kontrol için uygulanabilirlik durumunu belirlemeli, uygulama durumunu işaretlemeli ve gerekçesini yazmalısınız.
                                                </p>
                                            </div>
                                        </div>

                                        {/* Info boxes */}
                                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                                            <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-blue-500 rounded-full"></span>
                                                    <span className="font-medium text-blue-800">Uygulanabilirlik</span>
                                                </div>
                                                <p className="text-sm text-blue-700">Her kontrolün organizasyonunuz için uygulanabilir olup olmadığını belirleyin</p>
                                            </div>
                                            <div className="bg-green-50 border border-green-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-green-500 rounded-full"></span>
                                                    <span className="font-medium text-green-800">Uygulama Durumu</span>
                                                </div>
                                                <p className="text-sm text-green-700">Uygulanabilir kontrollerin mevcut uygulama durumunu işaretleyin</p>
                                            </div>
                                            <div className="bg-amber-50 border border-amber-100 rounded-lg p-4">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                                                    <span className="font-medium text-amber-800">Gerekçe</span>
                                                </div>
                                                <p className="text-sm text-amber-700">Kararınızın gerekçesini ve detaylarını açıklayın</p>
                                            </div>
                                        </div>

                                        {/* Stats */}
                                        <div className="flex items-center gap-6 mb-6 text-sm">
                                            <div>
                                                <span className="text-gray-500">Toplam Kontrol:</span>
                                                <span className="ml-2 font-semibold text-gray-900">{soaStats.total}</span>
                                            </div>
                                            <div>
                                                <span className="text-gray-500">Uygulanabilir:</span>
                                                <span className="ml-2 font-semibold text-blue-600">{soaStats.applicable}</span>
                                            </div>
                                            <div>
                                                <span className="text-gray-500">Uygulandı:</span>
                                                <span className="ml-2 font-semibold text-green-600">{soaStats.implemented}</span>
                                            </div>
                                        </div>

                                        {/* Search and filters */}
                                        <div className="flex flex-wrap items-center gap-4 mb-4">
                                            <div className="relative flex-1 min-w-[200px]">
                                                <IoSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                                                <input
                                                    type="text"
                                                    value={soaSearch}
                                                    onChange={(e) => setSoaSearch(e.target.value)}
                                                    placeholder="Kontrol ara..."
                                                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                                                />
                                            </div>
                                            <select
                                                value={soaApplicabilityFilter}
                                                onChange={(e) => setSoaApplicabilityFilter(e.target.value)}
                                                className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                                            >
                                                <option value="all">Tüm Uygulanabilirlik</option>
                                                <option value="yes">Evet</option>
                                                <option value="no">Hayır</option>
                                            </select>
                                            <select
                                                value={soaStatusFilter}
                                                onChange={(e) => setSoaStatusFilter(e.target.value)}
                                                className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm bg-white"
                                            >
                                                <option value="all">Tüm Uygulama Durumu</option>
                                                {implementationStatusOptions.map(opt => (
                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                ))}
                                            </select>
                                        </div>

                                        {/* Table */}
                                        {soaLoading ? (
                                            <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
                                                <img src={LOADER} alt="Loading..." className="w-12 h-12 mx-auto" />
                                                <p className="text-gray-500 mt-4">SOA kontrolleri yükleniyor...</p>
                                            </div>
                                        ) : (
                                            <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                                                <div className="overflow-x-auto">
                                                    <table className="w-full">
                                                        <thead className="bg-gray-50 border-b border-gray-200">
                                                            <tr>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-12">#</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-24">Kontrol ID</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Kontrol Adı</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Kategori</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Risk ID'leri</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-28">Uygulanabilir</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-36">Uygulama Durumu</th>
                                                                <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider w-32">Gerekçe</th>
                                                                <th className="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase tracking-wider w-20">İşlemler</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-gray-100">
                                                            {filteredSOAControls.map((control, index) => (
                                                                <tr key={control.id} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-3 text-sm text-gray-500">{index + 1}</td>
                                                                    <td className="px-4 py-3 text-sm font-medium text-gray-900">{control.controlId}</td>
                                                                    <td className="px-4 py-3 text-sm text-gray-700">{control.controlName}</td>
                                                                    <td className="px-4 py-3">
                                                                        <span className={`inline-flex px-2 py-1 text-xs font-medium rounded border ${getCategoryBadgeClass(control.category)}`}>
                                                                            {control.category}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3">
                                                                        <div className="flex flex-wrap gap-1">
                                                                            {control.riskIds && control.riskIds.length > 0 ? (
                                                                                <>
                                                                                    {control.riskIds.slice(0, 2).map(riskId => (
                                                                                        <span key={riskId} className="inline-flex px-2 py-0.5 text-xs font-medium rounded bg-blue-50 text-blue-600 border border-blue-200">
                                                                                            {riskId}
                                                                                        </span>
                                                                                    ))}
                                                                                    {control.riskIds.length > 2 && (
                                                                                        <span className="inline-flex px-2 py-0.5 text-xs font-medium rounded bg-gray-100 text-gray-600">
                                                                                            +{control.riskIds.length - 2}
                                                                                        </span>
                                                                                    )}
                                                                                </>
                                                                            ) : (
                                                                                <span className="text-xs text-gray-400 italic">Risk atanmadı</span>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded ${control.applicable ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'}`}>
                                                                            {control.applicable ? 'Evet' : 'Hayır'}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <span className={`inline-flex px-3 py-1 text-xs font-medium rounded ${getImplementationStatusDisplay(control.implementationStatus).color}`}>
                                                                            {getImplementationStatusDisplay(control.implementationStatus).label}
                                                                        </span>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-sm text-gray-500">
                                                                        {control.justification ? (
                                                                            <span className="line-clamp-1">{control.justification}</span>
                                                                        ) : (
                                                                            <span className="text-gray-400 italic">Gerekçe belirtilmedi</span>
                                                                        )}
                                                                    </td>
                                                                    <td className="px-4 py-3 text-center">
                                                                        <button
                                                                            onClick={() => openSoaEditModal(control)}
                                                                            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                                                                        >
                                                                            <FiEdit2 size={16} />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}

                                        {/* Edit Modal */}
                                        {soaEditModal && soaEditData && (
                                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                                                <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                                                    {/* Modal Header */}
                                                    <div className="flex items-center justify-between p-6 border-b border-gray-200">
                                                        <div>
                                                            <h3 className="text-lg font-semibold text-gray-900">Kontrolü Düzenle</h3>
                                                            <p className="text-sm text-gray-500 mt-0.5">{soaEditData.controlId} - {soaEditData.controlName}</p>
                                                        </div>
                                                        <button
                                                            onClick={closeSoaEditModal}
                                                            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg transition-colors"
                                                        >
                                                            <IoClose size={24} />
                                                        </button>
                                                    </div>

                                                    {/* Modal Body */}
                                                    <div className="p-6 space-y-6">
                                                        {/* Description */}
                                                        <div className="bg-blue-50 border border-blue-100 rounded-lg p-4">
                                                            <h4 className="text-sm font-medium text-blue-800 mb-2">Kontrol Açıklaması</h4>
                                                            <p className="text-sm text-blue-700">{soaEditData.description}</p>
                                                        </div>

                                                        {/* Category */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Kategori</label>
                                                            <span className={`inline-flex px-3 py-1.5 text-sm font-medium rounded border ${getCategoryBadgeClass(soaEditData.category)}`}>
                                                                {soaEditData.category}
                                                            </span>
                                                        </div>

                                                        {/* Applicable */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Kuruluş İçin Uygulanabilir</label>
                                                            <select
                                                                value={soaEditData.applicable ? 'yes' : 'no'}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, applicable: e.target.value === 'yes' }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            >
                                                                <option value="yes">Evet - Bu kontrol uygulanabilir</option>
                                                                <option value="no">Hayır - Bu kontrol uygulanabilir değil</option>
                                                            </select>
                                                        </div>

                                                        {/* Implementation Status */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Uygulama Durumu</label>
                                                            <select
                                                                value={soaEditData.implementationStatus}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, implementationStatus: e.target.value }))}
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                                            >
                                                                {implementationStatusOptions.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                        {/* Justification */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">Gerekçe / Yorumlar</label>
                                                            <textarea
                                                                value={soaEditData.justification}
                                                                onChange={(e) => setSoaEditData(prev => ({ ...prev, justification: e.target.value }))}
                                                                rows={4}
                                                                placeholder="Uygulanabilirlik durumu ve uygulama detayları için gerekçe belirtin..."
                                                                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                                                            />
                                                        </div>

                                                        {/* Risk IDs */}
                                                        <div>
                                                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                                                Risk Kimlikleri <span className="text-gray-400 font-normal">(Bu kontrolün hangi riskler için uygulandığını belirtin)</span>
                                                            </label>
                                                            <div className="flex gap-2">
                                                                <select
                                                                    value={newRiskId}
                                                                    onChange={(e) => setNewRiskId(e.target.value)}
                                                                    className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                                                                >
                                                                    <option value="">Risk seçin...</option>
                                                                    {allRisks.filter(risk =>
                                                                        !soaEditData.riskIds?.includes(`RISK-${String(risk.ID).padStart(3, '0')}`)
                                                                    ).map(risk => (
                                                                        <option key={risk.ID} value={`RISK-${String(risk.ID).padStart(3, '0')}`}>
                                                                            RISK-{String(risk.ID).padStart(3, '0')} - {risk.Title || 'İsimsiz Risk'}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                <button
                                                                    onClick={addRiskIdToEdit}
                                                                    disabled={!newRiskId}
                                                                    className="px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-300 disabled:cursor-not-allowed"
                                                                >
                                                                    Ekle
                                                                </button>
                                                            </div>
                                                            {allRisks.length === 0 && (
                                                                <p className="text-sm text-gray-400 mt-2 italic">Henüz risk tanımlanmamış</p>
                                                            )}
                                                            {soaEditData.riskIds && soaEditData.riskIds.length > 0 && (
                                                                <div className="flex flex-wrap gap-2 mt-3">
                                                                    {soaEditData.riskIds.map(riskId => {
                                                                        // Try to find the risk name
                                                                        const riskNum = parseInt(riskId.replace('RISK-', ''));
                                                                        const matchedRisk = allRisks.find(r => r.ID === riskNum);
                                                                        const riskName = matchedRisk?.Title || '';
                                                                        return (
                                                                            <span key={riskId} className="inline-flex items-center gap-1 px-3 py-1 text-sm font-medium rounded-full bg-blue-50 text-blue-600 border border-blue-200">
                                                                                {riskId}{riskName && ` - ${riskName.substring(0, 30)}${riskName.length > 30 ? '...' : ''}`}
                                                                                <button
                                                                                    onClick={() => removeRiskIdFromEdit(riskId)}
                                                                                    className="text-blue-400 hover:text-blue-700"
                                                                                >
                                                                                    <IoClose size={16} />
                                                                                </button>
                                                                            </span>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* Modal Footer */}
                                                    <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
                                                        <button
                                                            onClick={closeSoaEditModal}
                                                            disabled={soaSaving}
                                                            className="px-6 py-2.5 text-gray-700 font-medium rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors disabled:opacity-50"
                                                        >
                                                            İptal
                                                        </button>
                                                        <button
                                                            onClick={saveSoaControl}
                                                            disabled={soaSaving}
                                                            className="px-6 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 disabled:opacity-50"
                                                        >
                                                            {soaSaving ? (
                                                                <>
                                                                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                                    </svg>
                                                                    Kaydediliyor...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <IoSaveOutline size={18} />
                                                                    Değişiklikleri Kaydet
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}

                                {/* FINDINGS TAB */}
                                {activeTab === 'results' && (() => {
                                        const sfAll = Array.isArray(resultFindings) ? resultFindings : [];
                                        const sfNorm = (s) => s === 'Problem' ? 'In Progress' : s || 'Open';
                                        const sfCounts = sfAll.reduce((acc, f) => { const s = sfNorm(f.status).toLowerCase(); acc.total++; if (s === 'closed') acc.closed++; else if (s === 'in progress') acc.inProgress++; else acc.open++; return acc; }, { total: 0, open: 0, inProgress: 0, closed: 0 });
                                        const sfFiltered = sfAll.filter((f) => {
                                            const s = sfNorm(f.status);
                                            if (sfStatus !== 'All' && s !== sfStatus) return false;
                                            if (!findingsSearch.trim()) return true;
                                            const q = findingsSearch.toLowerCase();
                                            return (f.title || '').toLowerCase().includes(q) || (f.control_title || f.category || '').toLowerCase().includes(q) || (f.owner_name || '').toLowerCase().includes(q) || (f.priority || '').toLowerCase().includes(q);
                                        });
                                        const sfTotalPages = Math.max(1, Math.ceil(sfFiltered.length / SF_PAGE_SIZE));
                                        const sfStart = (sfPage - 1) * SF_PAGE_SIZE;
                                        const sfRows = sfFiltered.slice(sfStart, sfStart + SF_PAGE_SIZE);
                                        const sfPriorityChip = (p) => { const map = { Critical: 'bg-red-100 text-red-700 border-red-200', High: 'bg-orange-100 text-orange-700 border-orange-200', Medium: 'bg-yellow-100 text-yellow-800 border-yellow-200', Low: 'bg-green-100 text-green-700 border-green-200' }; const cls = map[p] || 'bg-gray-100 text-gray-700 border-gray-200'; return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{p || '—'}</span>; };
                                        const sfStatusChip = (s) => { const map = { open: 'bg-blue-100 text-blue-700 border-blue-200', 'in progress': 'bg-purple-100 text-purple-700 border-purple-200', closed: 'bg-gray-200 text-gray-700 border-gray-300' }; const cls = map[(s || '').toLowerCase()] || 'bg-gray-100 text-gray-700 border-gray-200'; return <span className={`inline-flex items-center text-[11px] px-2 py-0.5 rounded border ${cls}`}>{s || 'Open'}</span>; };
                                        return (
                                            <div className="space-y-4">
                                                {/* Stat cards */}
                                                <div className="grid grid-cols-4 gap-3">
                                                    {[
                                                        { label: 'Total Findings', value: sfCounts.total, icon: <FiAlertTriangle className="w-4 h-4 text-gray-400" /> },
                                                        { label: 'Open', value: sfCounts.open, icon: <FiClock className="w-4 h-4 text-blue-500" /> },
                                                        { label: 'In Progress', value: sfCounts.inProgress, icon: <FiXCircle className="w-4 h-4 text-red-500" /> },
                                                        { label: 'Closed', value: sfCounts.closed, icon: <FiCheckCircle className="w-4 h-4 text-green-500" /> },
                                                    ].map(({ label, value, icon }) => (
                                                        <div key={label} className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                                                            <div className="flex items-center justify-between"><span className="text-xs text-gray-500">{label}</span>{icon}</div>
                                                            <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                                {/* Filter bar */}
                                                <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                                                    <div className="flex flex-wrap items-center gap-2">
                                                        <div className="relative flex-1 min-w-[260px]">
                                                            <svg className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                            <input value={findingsSearch} onChange={(e) => { setFindingsSearch(e.target.value); setSfPage(1); }} placeholder="Search by title, category, owner…" className="w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2 border-none focus:outline-none focus:ring-0" />
                                                        </div>
                                                        <div className="relative">
                                                            <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M3 5h18l-7 8v4l-4 2v-6L3 5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                            <select value={sfStatus} onChange={(e) => { setSfStatus(e.target.value); setSfPage(1); }} className="appearance-none bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2 border-none focus:outline-none focus:ring-0">
                                                                <option value="All">All</option>
                                                                <option value="Open">Open</option>
                                                                <option value="In Progress">In Progress</option>
                                                                <option value="Closed">Closed</option>
                                                            </select>
                                                            <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" /></svg>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* Table */}
                                                <div className="shadow-xl rounded-2xl bg-white border border-gray-300 w-full">
                                                    <div className="p-4">
                                                        <div className="border border-gray-200 rounded-xl overflow-hidden">
                                                            <div className="grid grid-cols-[140px_1.8fr_1.2fr_0.9fr_0.9fr_1.1fr_1.5fr_1.2fr_1.2fr] gap-4 px-4 py-3 bg-white text-xs font-semibold text-gray-700 border-b border-gray-200">
                                                                <div>Finding ID</div><div>Title</div><div>Category</div><div>Priority</div><div>Status</div><div>Date</div><div>Assigned To</div><div>Approval</div><div>Action</div>
                                                            </div>
                                                            <div className="divide-y divide-gray-200">
                                                                {sfRows.length > 0 ? sfRows.map((f) => {
                                                                    const year = (f.finding_date || '').slice(0, 4) || new Date().getFullYear();
                                                                    const fid = `AUD-${year}-${String(f.id ?? 0).padStart(3, '0')}`;
                                                                    const status = sfNorm(f.status);
                                                                    const approvalStatus = f.approval_status || 'Pending';
                                                                    const approvalCls = { Approved: 'bg-green-100 text-green-700', Rejected: 'bg-red-100 text-red-700', Pending: 'bg-yellow-100 text-yellow-700' }[approvalStatus] || 'bg-yellow-100 text-yellow-700';
                                                                    return (
                                                                        <div key={f.id} onClick={() => handleViewFinding?.(f)} className="grid grid-cols-[140px_1.8fr_1.2fr_0.9fr_0.9fr_1.1fr_1.5fr_1.2fr_1.2fr] gap-4 items-center px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                            <div className="text-sm font-medium text-gray-700">{fid}</div>
                                                                            <div className="text-sm text-gray-800 truncate min-w-0">{f.title || '—'}</div>
                                                                            <div className="text-sm text-gray-700 truncate min-w-0">{f.control_title || f.category || '—'}</div>
                                                                            <div className="min-w-0">{sfPriorityChip(f.priority)}</div>
                                                                            <div className="min-w-0">{sfStatusChip(status)}</div>
                                                                            <div className="text-sm text-gray-700 min-w-0">{f.finding_date ? new Date(f.finding_date).toLocaleDateString() : '—'}</div>
                                                                            <div className="text-sm text-gray-700 truncate min-w-0">{f.owner_name || '—'}</div>
                                                                            <div className="min-w-0"><span className={`text-xs font-medium px-2.5 py-1 rounded-full ${approvalCls}`}>{approvalStatus}</span></div>
                                                                            <div className="min-w-0" onClick={(e) => e.stopPropagation()}>
                                                                                {f.action_id ? (
                                                                                    <button onClick={() => handleViewAction(f)} className="text-xs px-2.5 py-1 rounded-md bg-blue-50 text-blue-700 border border-blue-200 hover:bg-blue-100 transition-colors font-medium">View Action</button>
                                                                                ) : (
                                                                                    <button onClick={() => handleCreateAction(f)} className="text-xs px-2.5 py-1 rounded-md bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors font-medium">Create Action</button>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }) : (
                                                                    <div className="py-16 text-center text-sm text-gray-400">
                                                                        {findingsSearch.trim() || sfStatus !== 'All' ? 'No findings match your filters' : 'No findings yet'}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {/* Pagination */}
                                                        <div className="flex items-center justify-between gap-2 px-1 pt-3 text-xs text-gray-500">
                                                            <span>Showing <b className="text-gray-700">{sfFiltered.length ? sfStart + 1 : 0}</b>–<b className="text-gray-700">{Math.min(sfStart + SF_PAGE_SIZE, sfFiltered.length)}</b> of <b className="text-gray-700">{sfFiltered.length}</b> findings</span>
                                                            <div className="flex items-center gap-1">
                                                                <button onClick={() => setSfPage(p => Math.max(1, p - 1))} disabled={sfPage === 1} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">‹</button>
                                                                {Array.from({ length: sfTotalPages }, (_, i) => i + 1).map(p => (
                                                                    <button key={p} onClick={() => setSfPage(p)} className={`h-8 w-8 rounded-md border text-xs font-medium flex items-center justify-center ${sfPage === p ? 'bg-[#0E0E0E] text-white border-[#0E0E0E]' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}`}>{p}</button>
                                                                ))}
                                                                <button onClick={() => setSfPage(p => Math.min(sfTotalPages, p + 1))} disabled={sfPage === sfTotalPages} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">›</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()
                                }
                                {/* ACTIONS TAB */}
                                {activeTab === 'actions' && (() => {
                                    if (surveyActions === null) return (
                                        <div className="flex items-center justify-center py-20">
                                            <img src={LOADER} alt="Loading..." className="w-12 h-12" />
                                        </div>
                                    );
                                    const saIsCompleted = (label) => label === 'Completed';
                                    const saIsOverdue = (t) => { try { return new Date(t.end) < new Date() && !saIsCompleted(t.progressLabel); } catch { return false; } };
                                    const saIsBehind = (t) => { try { const pct = Number((t.real_progress ?? t.progress) || 0); return pct < 50 && new Date(t.end) < new Date() && !saIsCompleted(t.progressLabel); } catch { return false; } };
                                    const saStatusMeta = { 'Not started': 'bg-gray-100 text-gray-700 border-gray-200', 'In progress': 'bg-blue-100 text-blue-700 border-blue-200', 'Completed': 'bg-emerald-100 text-emerald-700 border-emerald-200', 'Problem': 'bg-rose-100 text-rose-700 border-rose-200' };
                                    const saChipCls = (label) => { const cls = label && saStatusMeta[label]; return `inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs border ${cls || 'bg-gray-100 text-gray-700 border-gray-200'}`; };
                                    const saPriorityChip = (p) => { const base = 'text-[10px] inline-flex items-center gap-1 px-1.5 py-0.5 rounded border font-medium'; const map = { Critical: `${base} bg-red-50 border-red-200 text-red-700 font-semibold`, High: `${base} bg-red-50 border-red-200 text-red-700 font-semibold`, Medium: `${base} bg-orange-50 border-orange-200 text-orange-600 font-semibold`, Low: `${base} bg-yellow-50 border-yellow-200 text-yellow-600 font-medium` }; return map[p] ? <span className={map[p]}>{p}</span> : null; };
                                    const saCounts = surveyActions.reduce((acc, a) => { const pl = (a.progressLabel || a.status || '').toLowerCase().trim(); acc.total++; if (pl === 'completed') acc.completed++; else if (pl === 'in progress') acc.inProgress++; else if (pl === 'problem') acc.problem++; else acc.open++; return acc; }, { total: 0, open: 0, inProgress: 0, problem: 0, completed: 0 });
                                    const saFiltered = surveyActions.filter((a) => { const pl = a.progressLabel || a.status || 'Not started'; if (saStatus !== 'All' && pl !== saStatus) return false; if (!saQuery.trim()) return true; const q = saQuery.toLowerCase(); return (a.name || a.title || a.action_title || '').toLowerCase().includes(q); });
                                    const saTotalPages = Math.max(1, Math.ceil(saFiltered.length / SF_PAGE_SIZE));
                                    const saStart = (saPage - 1) * SF_PAGE_SIZE;
                                    const saPaged = saFiltered.slice(saStart, saStart + SF_PAGE_SIZE);
                                    const saYear = new Date().getFullYear();
                                    return (
                                        <div className="space-y-4">
                                            {/* Stat cards */}
                                            <div className="grid grid-cols-4 gap-3">
                                                {[
                                                    { label: 'Open Actions', value: saCounts.open, icon: <FiClock className="w-4 h-4 text-blue-500" /> },
                                                    { label: 'In Progress', value: saCounts.inProgress, icon: <FiRefreshCw className="w-4 h-4 text-amber-500" /> },
                                                    { label: 'Problem', value: saCounts.problem, icon: <FiXCircle className="w-4 h-4 text-rose-500" /> },
                                                    { label: 'Completed', value: saCounts.completed, icon: <FiCheckCircle className="w-4 h-4 text-green-500" /> },
                                                ].map(({ label, value, icon }) => (
                                                    <div key={label} className="rounded-xl border border-gray-200 bg-white p-4 flex flex-col justify-between">
                                                        <div className="flex items-center justify-between"><span className="text-xs text-gray-500">{label}</span>{icon}</div>
                                                        <div className="mt-1 text-2xl font-normal text-[#0E0E0E]">{value}</div>
                                                    </div>
                                                ))}
                                            </div>
                                            {/* Filter bar */}
                                            <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
                                                <div className="flex flex-wrap items-center gap-2">
                                                    <div className="relative flex-1 min-w-[260px]">
                                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                        <input value={saQuery} onChange={(e) => { setSaQuery(e.target.value); setSaPage(1); }} placeholder="Search actions…" className="w-full bg-[#F3F4F6] rounded-md text-xs pl-8 pr-3 py-2 border-none focus:outline-none focus:ring-0" />
                                                    </div>
                                                    <div className="relative">
                                                        <svg className="absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" viewBox="0 0 24 24" fill="none"><path d="M3 5h18l-7 8v4l-4 2v-6L3 5z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                        <select value={saStatus} onChange={(e) => { setSaStatus(e.target.value); setSaPage(1); }} className="appearance-none bg-[#F3F4F6] rounded-md text-xs pl-8 pr-6 py-2 border-none focus:outline-none focus:ring-0">
                                                            <option value="All">All</option>
                                                            <option value="Not started">Not started</option>
                                                            <option value="In progress">In progress</option>
                                                            <option value="Problem">Problem</option>
                                                            <option value="Completed">Completed</option>
                                                        </select>
                                                        <svg className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-500" viewBox="0 0 20 20" fill="currentColor"><path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" /></svg>
                                                    </div>
                                                    <div className="flex items-center gap-1 ml-auto">
                                                        <button type="button" onClick={() => setSaView('table')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition ${saView === 'table' ? 'bg-[#0F0F19] text-white' : 'bg-[#F3F4F6] text-gray-700 hover:bg-gray-200'}`}>
                                                            <RiTableFill className="w-3.5 h-3.5" /> Table
                                                        </button>
                                                        <button type="button" onClick={() => setSaView('kanban')} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition ${saView === 'kanban' ? 'bg-[#0F0F19] text-white' : 'bg-[#F3F4F6] text-gray-700 hover:bg-gray-200'}`}>
                                                            <KanbanSquare className="w-3.5 h-3.5" /> Kanban
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Kanban */}
                                            {saView === 'kanban' && (
                                                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm px-4 py-6">
                                                    <KanBanComponent overrideActions={surveyActions} />
                                                </div>
                                            )}
                                            {/* Table */}
                                            {saView === 'table' && <div className="shadow-xl rounded-2xl bg-white border border-gray-300 w-full">
                                                <div className="p-4">
                                                    <div className="border border-gray-200 rounded-xl overflow-hidden">
                                                        <div className="grid grid-cols-[140px_1fr_120px_160px_130px_130px] gap-4 px-4 py-3 bg-white text-xs font-semibold text-gray-700 border-b border-gray-200">
                                                            <div>Action ID</div><div>Title</div><div>Priority</div><div>Status</div><div>Due</div><div>Progress</div>
                                                        </div>
                                                        <div className="divide-y divide-gray-200">
                                                            {saPaged.length > 0 ? saPaged.map((t) => {
                                                                const rawId = t.iid ?? t.action_id ?? t.id ?? 0;
                                                                const aid = `CNT-${saYear}-${String(rawId).padStart(3, '0')}`;
                                                                const overdue = saIsOverdue(t);
                                                                const behind = saIsBehind(t);
                                                                const title = t.name || t.title || t.action_title || '—';
                                                                const openId = t.iid ?? t.action_id ?? rawId;
                                                                const pct = Math.max(0, Math.min(100, Math.round(Number((t.real_progress ?? t.progress) ?? 0))));
                                                                return (
                                                                    <div key={rawId} onClick={() => { setActionId(openId); setIsActionOpen(true); }} className="grid grid-cols-[140px_1fr_120px_160px_130px_130px] gap-4 items-center px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors">
                                                                        <div className="text-sm font-medium text-gray-700">{aid}</div>
                                                                        <div className="min-w-0">
                                                                            <div className="flex items-center gap-2">
                                                                                <span className="text-sm text-gray-800 truncate">{title}</span>
                                                                                {behind && <span className="text-[10px] inline-flex items-center px-1.5 py-0.5 rounded bg-rose-50 text-rose-700 border border-rose-200">behind</span>}
                                                                                {overdue && <span className="text-[10px] inline-flex items-center px-1.5 py-0.5 rounded bg-amber-50 text-amber-700 border border-amber-200">overdue</span>}
                                                                            </div>
                                                                            {t.action_description && <p className="text-xs text-gray-500 truncate mt-0.5">{t.action_description}</p>}
                                                                        </div>
                                                                        <div>{saPriorityChip(t.priority)}</div>
                                                                        <div><span className={saChipCls(t.progressLabel || t.status)}>{t.progressLabel || t.status || 'Not started'}</span></div>
                                                                        <div className="text-sm text-gray-700">{t.end ? new Date(t.end).toLocaleDateString() : '—'}</div>
                                                                        <div>
                                                                            <div className="text-sm font-medium text-gray-800">{pct}%</div>
                                                                            <div className="w-full h-1.5 bg-gray-200 rounded overflow-hidden mt-1">
                                                                                <div className={`h-1.5 ${saIsCompleted(t.progressLabel) ? 'bg-emerald-500' : behind ? 'bg-rose-500' : 'bg-blue-500'}`} style={{ width: `${pct}%` }} />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            }) : (
                                                                <div className="py-16 text-center text-sm text-gray-400">No actions found</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    {/* Pagination */}
                                                    <div className="flex items-center justify-between gap-2 px-1 pt-3 text-xs text-gray-500">
                                                        <span>Showing <b className="text-gray-700">{saFiltered.length ? saStart + 1 : 0}</b>–<b className="text-gray-700">{Math.min(saStart + SF_PAGE_SIZE, saFiltered.length)}</b> of <b className="text-gray-700">{saFiltered.length}</b> actions</span>
                                                        <div className="flex items-center gap-1">
                                                            <button onClick={() => setSaPage(p => Math.max(1, p - 1))} disabled={saPage === 1} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">‹</button>
                                                            {Array.from({ length: saTotalPages }, (_, i) => i + 1).map(p => (
                                                                <button key={p} onClick={() => setSaPage(p)} className={`h-8 w-8 rounded-md border text-xs font-medium flex items-center justify-center ${saPage === p ? 'bg-[#0E0E0E] text-white border-[#0E0E0E]' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}`}>{p}</button>
                                                            ))}
                                                            <button onClick={() => setSaPage(p => Math.min(saTotalPages, p + 1))} disabled={saPage === saTotalPages} className="h-8 w-8 rounded-md border border-gray-300 bg-white text-gray-700 disabled:opacity-50 hover:bg-gray-50 flex items-center justify-center">›</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        </div>
                                    );
                                })()}

                                {/* REPORT TAB */}
                                {activeTab === 'reports' && (() => {
                                    const qs = allQuestionsFlat || [];
                                    const total = qs.length;
                                    const compliant = qs.filter(q => q.question_review_status === 'Accepted').length;
                                    const nonCompliant = qs.filter(q => q.question_review_status === 'Rejected').length;
                                    const compliancePct = total > 0 ? Math.round((compliant / total) * 100) : 0;
                                    const ringColor = compliancePct >= 70 ? '#22c55e' : compliancePct >= 40 ? '#f59e0b' : '#ef4444';

                                    if (!(alreadySubmitted || currentView === 'success')) {
                                        return (
                                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-12 text-center">
                                                <IoDocumentText className="mx-auto text-gray-300" size={48} />
                                                <p className="text-gray-500 mt-4">Report not ready yet</p>
                                                <p className="text-sm text-gray-400 mt-1">The report will be available after the survey is submitted</p>
                                            </div>
                                        );
                                    }

                                    return (
                                        <div className="space-y-6">
                                            {/* Survey Charts */}
                                            <div className="mb-6">
                                                <SurveyCharts allClauses={allClauses} />
                                            </div>

                                            {/* Compliance Summary Card */}
                                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                                                <div className="flex items-center justify-between mb-4">
                                                    <div>
                                                        <h2 className="text-lg font-semibold text-gray-800">Compliance Summary</h2>
                                                        <p className="text-sm text-gray-500">Auditor decision breakdown per question</p>
                                                    </div>
                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                                                        {compliant + nonCompliant}/{total} Reviewed
                                                    </span>
                                                </div>
                                                <div className="flex items-center gap-8">
                                                    <div className="relative w-32 h-32 flex-shrink-0">
                                                        <svg className="w-32 h-32 transform -rotate-90">
                                                            <circle cx="64" cy="64" r="56" stroke="#e5e7eb" strokeWidth="12" fill="none" />
                                                            <circle
                                                                cx="64" cy="64" r="56"
                                                                stroke={ringColor}
                                                                strokeWidth="12"
                                                                fill="none"
                                                                strokeDasharray={`${(compliancePct / 100) * 351.86} 351.86`}
                                                                strokeLinecap="round"
                                                            />
                                                        </svg>
                                                        <div className="absolute inset-0 flex items-center justify-center">
                                                            <span className="text-2xl font-bold text-gray-800">{compliancePct}%</span>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1 grid grid-cols-2 gap-4">
                                                        <div className="bg-emerald-50 rounded-lg p-4 text-center">
                                                            <p className="text-3xl font-bold text-emerald-700">{compliant}</p>
                                                            <p className="text-sm text-emerald-600 font-medium mt-1">Compliant (Pass)</p>
                                                        </div>
                                                        <div className="bg-red-50 rounded-lg p-4 text-center">
                                                            <p className="text-3xl font-bold text-red-700">{nonCompliant}</p>
                                                            <p className="text-sm text-red-600 font-medium mt-1">Non-Compliant (Fail)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Per-clause breakdown */}
                                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                                                <div className="p-6 border-b border-gray-200">
                                                    <h3 className="text-md font-semibold text-gray-800">Clause Breakdown</h3>
                                                </div>
                                                <div className="divide-y divide-gray-100">
                                                    {(allClauses || []).map((clause, idx) => {
                                                        const cqs = clause.questions || [];
                                                        const cTotal = cqs.length;
                                                        const cCompliant = cqs.filter(q => q.question_review_status === 'Accepted').length;
                                                        const cNonCompliant = cqs.filter(q => q.question_review_status === 'Rejected').length;
                                                        const cPct = cTotal > 0 ? Math.round((cCompliant / cTotal) * 100) : 0;
                                                        const clauseName = clause.title || clause.clause_title || clause.name || `Clause ${clause.clause || idx + 1}`;
                                                        const barColor = cPct >= 70 ? 'bg-green-500' : cPct >= 40 ? 'bg-amber-500' : 'bg-red-400';
                                                        return (
                                                            <div key={clause.clause || idx} className="p-4 hover:bg-gray-50">
                                                                <div className="flex items-center justify-between mb-2">
                                                                    <span className="text-sm font-medium text-gray-800">{clauseName}</span>
                                                                    <span className="text-sm font-semibold text-gray-600">{cPct}%</span>
                                                                </div>
                                                                <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                                                                    <div className={`h-2 rounded-full ${barColor}`} style={{ width: `${cPct}%` }} />
                                                                </div>
                                                                <div className="flex items-center gap-4 text-xs text-gray-500">
                                                                    <span>{cTotal} questions</span>
                                                                    <span className="text-emerald-600">{cCompliant} compliant</span>
                                                                    <span className="text-red-600">{cNonCompliant} non-compliant</span>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>

                                            {/* Full question review table */}
                                            <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
                                                <div className="p-6 border-b border-gray-200">
                                                    <h3 className="text-md font-semibold text-gray-800">Question Review Table</h3>
                                                </div>
                                                <table className="w-full text-sm">
                                                    <colgroup>
                                                        <col style={{ width: '40%' }} />
                                                        <col style={{ width: '12%' }} />
                                                        <col style={{ width: '13%' }} />
                                                        <col style={{ width: '35%' }} />
                                                    </colgroup>
                                                    <thead>
                                                        <tr className="bg-gray-50 text-xs font-semibold text-gray-500 border-b border-gray-200">
                                                            <th className="px-4 py-3 text-left">Question</th>
                                                            <th className="px-4 py-3 text-left">Answer</th>
                                                            <th className="px-4 py-3 text-left">Decision</th>
                                                            <th className="px-4 py-3 text-left">Fail Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-gray-100">
                                                        {qs.map((q, qi) => {
                                                            const status = q.question_review_status;
                                                            if (!status || status === 'Pending') return null;
                                                            const isPass = status === 'Accepted';
                                                            const statusCls = isPass ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700';
                                                            const label = isPass ? 'Pass' : 'Fail';
                                                            return (
                                                                <tr key={q.question_id ?? q.id ?? qi} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-3 text-gray-800 align-top">{q.question_text || q.text || '—'}</td>
                                                                    <td className="px-4 py-3 text-gray-700 align-top capitalize">{q.answer || <span className="text-gray-400">—</span>}</td>
                                                                    <td className="px-4 py-3 align-top">
                                                                        <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${statusCls}`}>{label}</span>
                                                                    </td>
                                                                    <td className="px-4 py-3 text-gray-500 align-top text-xs">
                                                                        {!isPass ? (q.rejection_reason || q.fail_reason || <span className="text-gray-300">—</span>) : <span className="text-gray-300">—</span>}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })()}

                                {/* Templates TAB */}
                                {activeTab === 'templates' && (
                                    <div className="w-full min-h-screen bg-white p-6">
                                        {/* Header */}
                                        <div className="mb-5">
                                            <h1 className="text-base font-semibold text-gray-900">Survey Templates</h1>
                                            <p className="text-sm text-gray-500">Manage and organize your survey templates</p>
                                        </div>

                                        {/* Toolbar */}
                                        <div className="bg-white border border-gray-200 rounded-2xl p-4 shadow-sm">
                                            <div className="flex flex-wrap items-center gap-3">
                                                {/* Search */}
                                                <div className="relative flex-1 min-w-[320px]">
                                                    <input
                                                        value={templateQuery}
                                                        onChange={(e) => setTemplateQuery(e.target.value)}
                                                        placeholder="Search templates..."
                                                        className="
              w-full h-10 bg-gray-50 rounded-xl
              text-sm text-gray-900 placeholder:text-gray-400
              pl-10 pr-3
              outline-none border-none
              focus:outline-none focus:ring-0
            "
                                                    />
                                                    <svg
                                                        className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                        viewBox="0 0 24 24"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M21 21l-4.35-4.35M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z"
                                                            stroke="currentColor"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                </div>

                                                {/* Filters */}
                                                <div className="flex items-center gap-3">
                                                    {/* Status */}
                                                    <div className="relative">
                                                        <select
                                                            value={statusFilter}
                                                            onChange={(e) => setStatusFilter(e.target.value)}
                                                            className="
                h-10 min-w-[160px]
                bg-gray-50 rounded-xl text-sm
                px-4 pr-10
                outline-none border-none
                appearance-none
              "
                                                        >
                                                            <option value="all">All Status</option>
                                                            <option value="active">Active</option>
                                                            <option value="draft">Draft</option>
                                                            <option value="archived">Archived</option>
                                                        </select>
                                                        <svg
                                                            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                        </svg>
                                                    </div>

                                                    {/* Type */}
                                                    <div className="relative">
                                                        <select
                                                            value={typeFilter}
                                                            onChange={(e) => setTypeFilter(e.target.value)}
                                                            className="
                h-10 min-w-[160px]
                bg-gray-50 rounded-xl text-sm
                px-4 pr-10
                outline-none border-none
                appearance-none
              "
                                                        >
                                                            <option value="all">All Types</option>
                                                            <option value="it">IT</option>
                                                            <option value="operational">Operational</option>
                                                            <option value="compliance">Compliance</option>
                                                        </select>
                                                        <svg
                                                            className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500"
                                                            viewBox="0 0 20 20"
                                                            fill="currentColor"
                                                        >
                                                            <path d="M5.23 7.21a.75.75 0 011.06.02L10 10.94l3.71-3.71a.75.75 0 111.06 1.06l-4.24 4.24a.75.75 0 01-1.06 0L5.21 8.29a.75.75 0 01.02-1.08z" />
                                                        </svg>
                                                    </div>

                                                    {/* Grid / Table toggle */}
                                                    <div className="flex items-center border border-gray-200 rounded-xl overflow-hidden bg-white">
                                                        <button
                                                            type="button"
                                                            onClick={() => setViewMode("grid")}
                                                            className={`h-10 px-4 text-sm font-medium flex items-center gap-2 transition
    ${viewMode === "grid"
                                                                    ? "bg-gray-900 text-white"
                                                                    : "bg-white text-gray-600 hover:bg-gray-50"}`}
                                                        >
                                                            <svg
                                                                className="w-4 h-4"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                strokeWidth={1.75}
                                                            >
                                                                <rect x="3" y="3" width="7" height="7" rx="1.5" />
                                                                <rect x="14" y="3" width="7" height="7" rx="1.5" />
                                                                <rect x="3" y="14" width="7" height="7" rx="1.5" />
                                                                <rect x="14" y="14" width="7" height="7" rx="1.5" />
                                                            </svg>
                                                            <span className="hidden sm:inline">Grid</span>
                                                        </button>

                                                        <button
                                                            type="button"
                                                            onClick={() => setViewMode("table")}
                                                            className={`h-10 px-4 text-sm font-medium flex items-center gap-2 transition border-l border-gray-200
                ${viewMode === "table" ? "bg-gray-900 text-white" : "bg-white text-gray-600 hover:bg-gray-50"}`}
                                                        >
                                                            <span className="inline-flex items-center justify-center w-4 h-4">
                                                                ≡
                                                            </span>
                                                            Table
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div className="mt-5">
                                            {viewMode === "grid" ? (
                                                <div className="grid gap-5 [grid-template-columns:repeat(auto-fit,minmax(340px,1fr))]">
                                                    {filteredTemplates.map((t) => {
                                                        const status = t.unlocked ? "Active" : "Draft";

                                                        return (
                                                            <div
                                                                key={t.template_id}
                                                                className="bg-gray-900 border border-gray-800 rounded-2xl shadow-sm p-6 flex flex-col hover:bg-gray-800 transition-colors"
                                                            >
                                                                {/* Header */}
                                                                <div className="flex items-start justify-between gap-3">
                                                                    <div className="min-w-0">
                                                                        <h3 className="text-sm font-semibold text-white mb-1 truncate">
                                                                            {t.name}
                                                                        </h3>

                                                                        <div className="flex items-center gap-2">
                                                                            <span
                                                                                className={`text-xs px-2 py-0.5 rounded-full border ${t.unlocked
                                                                                    ? "bg-green-950/40 text-green-300 border-green-800"
                                                                                    : "bg-gray-800 text-gray-300 border-gray-700"
                                                                                    }`}
                                                                            >
                                                                                {status}
                                                                            </span>

                                                                            <span className="text-xs px-2 py-0.5 rounded-full border bg-blue-950/40 text-blue-300 border-blue-800">
                                                                                Template
                                                                            </span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Icon badge */}
                                                                    <div className="h-9 w-9 rounded-xl border border-gray-700 bg-gray-800 flex items-center justify-center text-gray-200">
                                                                        📄
                                                                    </div>
                                                                </div>

                                                                {/* Description */}
                                                                <p className="text-sm text-gray-300 leading-5 mt-3 line-clamp-3">
                                                                    {t.description || "No description provided."}
                                                                </p>

                                                                {/* Chips */}
                                                                <div className="mt-4 flex flex-wrap gap-2">
                                                                    <span className="text-xs px-2 py-1 rounded-full bg-gray-800 border border-gray-700 text-gray-200">
                                                                        {t.questionCount} questions
                                                                    </span>
                                                                    <span className="text-xs px-2 py-1 rounded-full bg-gray-800 border border-gray-700 text-gray-200">
                                                                        {t.timeEstimate}
                                                                    </span>
                                                                    <span className="text-xs px-2 py-1 rounded-full bg-gray-800 border border-gray-700 text-gray-200">
                                                                        {t.clausesCount} clauses
                                                                    </span>
                                                                </div>

                                                                {/* Footer actions */}
                                                                <div className="mt-5 flex items-center justify-between gap-3">
                                                                    <button className="h-9 px-3 text-sm text-gray-300 hover:text-white">
                                                                        Details →
                                                                    </button>

                                                                    <button
                                                                        onClick={() => handleDeploy(t)}
                                                                        className="h-10 px-4 text-sm rounded-xl bg-white text-gray-900 hover:bg-gray-100"
                                                                    >
                                                                        Deploy Template
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden">
                                                    <table className="w-full text-sm">
                                                        <thead className="bg-gray-50 text-gray-600">
                                                            <tr>
                                                                <th className="text-left font-medium px-4 py-3">Name</th>
                                                                <th className="text-left font-medium px-4 py-3">Status</th>
                                                                <th className="text-left font-medium px-4 py-3">Questions</th>
                                                                <th className="text-left font-medium px-4 py-3">Clauses</th>
                                                                <th className="text-left font-medium px-4 py-3">Time</th>
                                                                <th className="text-left font-medium px-4 py-3">Updated</th>
                                                                <th className="text-right font-medium px-4 py-3">Actions</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody className="divide-y divide-gray-100">
                                                            {filteredTemplates.map((t) => (
                                                                <tr key={t.template_id} className="hover:bg-gray-50">
                                                                    <td className="px-4 py-2.5">
                                                                        <div className="font-medium text-gray-900">{t.name}</div>
                                                                        {t.description && (
                                                                            <div className="text-xs text-gray-500 line-clamp-1">
                                                                                {t.description}
                                                                            </div>
                                                                        )}
                                                                    </td>

                                                                    <td className="px-4 py-2.5">
                                                                        <span
                                                                            className={`text-xs px-2 py-0.5 rounded-full border ${t.unlocked
                                                                                ? "bg-green-50 text-green-700 border-green-200"
                                                                                : "bg-gray-50 text-gray-600 border-gray-200"
                                                                                }`}
                                                                        >
                                                                            {t.statusLabel || (t.unlocked ? "Active" : "Draft")}
                                                                        </span>
                                                                    </td>

                                                                    <td className="px-4 py-2.5 text-gray-700">{t.questionCount}</td>
                                                                    <td className="px-4 py-2.5 text-gray-700">{t.clausesCount}</td>
                                                                    <td className="px-4 py-2.5 text-gray-700">{t.timeEstimate}</td>

                                                                    <td className="px-4 py-2.5 text-gray-600">
                                                                        {t.updated_at ? new Date(t.updated_at).toLocaleDateString() : "—"}
                                                                    </td>

                                                                    <td className="px-4 py-2.5">
                                                                        <div className="flex items-center justify-end gap-2">
                                                                            <button className="h-8 px-2.5 rounded-lg border border-gray-300 hover:bg-gray-50 text-xs">
                                                                                Details
                                                                            </button>
                                                                            <button className="h-8 px-2.5 rounded-lg bg-gray-900 text-white hover:bg-gray-800 text-xs">
                                                                                Deploy
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                    {filteredTemplates.length === 0 && (
                                                        <div className="p-6 text-sm text-gray-500">No templates found.</div>
                                                    )}
                                                </div>
                                            )}
                                        </div>


                                    </div>
                                )}



                                {activeTab === "deployments" && (
                                    <>
                                        {/* Header */}
                                        <div className="mb-5">
                                            <h2 className="text-lg font-semibold text-gray-900">Survey Deployments</h2>
                                            <p className="text-sm text-gray-500">Track deployed surveys and response rates</p>
                                        </div>

                                        {/* List */}
                                        <div className="space-y-4">
                                            {(completedSurveys || []).map((d) => {
                                                const statusLabel =
                                                    d.status === "submitted"
                                                        ? "Completed"
                                                        : d.status === "draft"
                                                            ? "Pending"
                                                            : (d.status || "Pending");

                                                const progress = Number(d.progress_percent ?? 0);
                                                const deptCount = Number(d.departments_count ?? 1);
                                                const responses = Number(d.responses_count ?? 0);
                                                const invited = Number(d.invited_count ?? 1);

                                                return (
                                                    <div
                                                        key={d.survey_id}
                                                        className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"
                                                    >
                                                        <div className="flex">
                                                            {/* Left accent */}
                                                            <div className="w-1.5 bg-purple-500" />

                                                            {/* Content */}
                                                            <div className="flex-1 px-6 py-5">
                                                                <div className="flex items-start justify-between gap-4">
                                                                    {/* Left: title + meta */}
                                                                    <div className="min-w-0">
                                                                        <div className="flex items-center gap-3">
                                                                            <h3 className="text-sm md:text-base font-semibold text-gray-900 truncate">
                                                                                {d.template_name || d.name || d.organization_name || "Deployment"}
                                                                            </h3>

                                                                            {/* Status chip */}
                                                                            <span className="text-xs font-medium px-2.5 py-1 rounded-full border border-gray-200 bg-gray-50 text-gray-700">
                                                                                {statusLabel}
                                                                            </span>
                                                                        </div>

                                                                        {/* Meta row */}
                                                                        <div className="mt-2 flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-gray-600">
                                                                            <div className="flex items-center gap-2">
                                                                                <Users size={14} className="text-gray-400" />
                                                                                <span>{deptCount} departments</span>
                                                                            </div>

                                                                            <div className="flex items-center gap-2">
                                                                                <Calendar size={14} className="text-gray-400" />
                                                                                <span>
                                                                                    Due:{" "}
                                                                                    {d.due_date
                                                                                        ? new Date(d.due_date).toISOString().slice(0, 10)
                                                                                        : "—"}
                                                                                </span>
                                                                            </div>

                                                                            <div className="flex items-center gap-2">
                                                                                <BarChart2 size={14} className="text-gray-400" />
                                                                                <span>
                                                                                    {responses}/{invited} responses
                                                                                </span>
                                                                            </div>
                                                                        </div>

                                                                    </div>

                                                                    {/* Right: actions */}
                                                                    <div className="flex items-center gap-2 shrink-0">
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleViewDeployment(d)}
                                                                            className="h-9 px-3 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-900 hover:bg-gray-50 flex items-center gap-2"
                                                                        >
                                                                            <Eye size={16} />
                                                                            View
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={() => handleExportDeployment(d)}
                                                                            className="h-9 px-3 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-900 hover:bg-gray-50 flex items-center gap-2"
                                                                        >
                                                                            <Download size={16} />
                                                                            Export
                                                                        </button>
                                                                    </div>
                                                                </div>

                                                                {/* Progress bar */}
                                                                <div className="mt-4">
                                                                    <div className="h-2 w-full rounded-full bg-gray-200 overflow-hidden">
                                                                        <div
                                                                            className="h-2 rounded-full bg-gray-700"
                                                                            style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
                                                                        />
                                                                    </div>
                                                                    <div className="mt-2 text-xs text-gray-500">{progress}% complete</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            {/* Empty state */}
                                            {(!completedSurveys || completedSurveys.length === 0) && (
                                                <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center">
                                                    <p className="text-sm text-gray-700 font-medium">No deployments yet</p>
                                                    <p className="text-sm text-gray-500 mt-1">
                                                        Deploy a survey template to start tracking responses here.
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}


                                {/* ANKET TAB */}
                                {activeTab === 'survey' && (
                                    <>
                                        {alreadySubmitted ? (
                                            /* ALREADY SUBMITTED - Show Summary */
                                            <div className="space-y-4">
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-6">
                                                    <div className="flex items-center justify-between">
                                                        <div className="flex items-center gap-4">
                                                            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                                                                <IoCheckmarkCircle className="text-green-600" size={28} />
                                                            </div>
                                                            <div>
                                                                <h2 className="text-lg font-bold text-gray-800">Anket Başarıyla Gönderildi</h2>
                                                                {submittedSurvey && (
                                                                    <p className="text-sm text-gray-500 mt-0.5">
                                                                        {submittedSurvey.fillerName} &middot; {new Date(submittedSurvey.submittedAt).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                                    </p>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            onClick={() => setShowSurveyView(v => !v)}
                                                            className="flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white hover:bg-gray-50 transition-colors"
                                                        >
                                                            <IoDocumentText size={16} />
                                                            {showSurveyView ? "Hide Survey" : "View Survey"}
                                                        </button>
                                                    </div>
                                                </div>

                                                {showSurveyView && (
                                                    <div className="bg-white p-6 rounded-2xl border border-gray-200">
                                                        {getActiveClauses().map((clause) => {
                                                            const clauseQuestions = (clause.questions || []).filter((q) => {
                                                                const id = Number(q?.question_id);
                                                                return !(id && deletedSet.has(id));
                                                            });
                                                            const clauseKey = clause._tmpClauseId ?? clause.clause ?? clause.question_id ?? clause.id;
                                                            return (
                                                                <div key={clauseKey} className="rounded-xl border border-gray-200 overflow-hidden bg-white mt-4">
                                                                    <div className="px-4 py-3 bg-white border-b border-gray-200">
                                                                        <h3 className="text-sm font-semibold text-gray-800">{clause.title}</h3>
                                                                    </div>
                                                                    <div className="grid grid-cols-[2fr_0.8fr_110px_130px] items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500">
                                                                        <div>Question</div>
                                                                        <div>Answer</div>
                                                                        <div>Owners</div>
                                                                        <div>Status</div>
                                                                    </div>
                                                                    <div>
                                                                        {clauseQuestions.map((question) => {
                                                                            const qid = question.question_id ?? question.id;
                                                                            return (
                                                                                <QuestionRow
                                                                                    key={qid}
                                                                                    question={question}
                                                                                    answer={answers?.[qid]}
                                                                                    openQuestionFN={handleOpenQuestion}
                                                                                    isCustomFramework={false}
                                                                                    onDelete={null}
                                                                                />
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </div>
                                        ) : currentView === 'success' ? (
                                            /* SUCCESS STATE */
                                            <div className="bg-white rounded-lg border-l-4 border-green-500 shadow-sm p-8">
                                                <div className="flex items-center gap-4 mb-6">
                                                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
                                                        <IoCheckmarkCircle className="text-green-600" size={40} />
                                                    </div>
                                                    <div>
                                                        <h2 className="text-xl font-bold text-gray-800">Anket Başarıyla Gönderildi!</h2>
                                                        <p className="text-gray-600">ISO 27001:2022 Ön Değerlendirme Anketiniz başarıyla kaydedildi.</p>
                                                    </div>
                                                </div>
                                                <div className="bg-gray-50 rounded-lg p-4 space-y-2">
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Organizasyon:</span> {orgName}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Gönderen:</span> {fillerName}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Toplam Soru:</span> {getTotalQuestions()}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Evet Cevapları:</span> {getEvetCount()}
                                                    </p>
                                                    <p className="text-sm text-gray-600">
                                                        <span className="font-medium">Hayır Cevapları:</span> {getHayirCount()}
                                                    </p>
                                                </div>
                                                <div className="mt-6">
                                                    <p className="text-sm text-gray-500">
                                                        Sonuçları görmek için "Sonuçlar" sekmesine, yüklenen dosyaları görmek için "Dosyalar" sekmesine tıklayabilirsiniz.
                                                    </p>
                                                </div>
                                            </div>
                                        ) : currentView === 'review' ? (
                                            /* REVIEW VIEW */
                                            <>
                                                {/* Review Header */}
                                                <div className="mb-6">
                                                    <button
                                                        onClick={handleBackToSurvey}
                                                        className="flex items-center gap-2 text-blue-600 hover:text-blue-800 mb-4 font-medium"
                                                    >
                                                        <IoArrowBack size={20} />
                                                        Surveye Geri Dön
                                                    </button>
                                                    <h1 className="text-2xl md:text-3xl font-bold text-[#0E0E0E] mb-3">
                                                        Yanıtlarınızı Gözden Geçirin
                                                    </h1>
                                                    <p className="text-gray-600 leading-relaxed">
                                                        Lütfen aşağıdaki yanıtlarınızı kontrol ediniz. Değişiklik yapmak için "Ankete Geri Dön" butonuna tıklayabilirsiniz.
                                                    </p>
                                                </div>

                                                {/* Organization Info Review */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 p-6">
                                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Organizasyon Bilgileri</h2>
                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <div>
                                                            <span className="text-sm text-gray-500">Organizasyon Adı</span>
                                                            <p className="text-gray-800 font-medium">{orgName || "-"}</p>
                                                        </div>
                                                        <div>
                                                            <span className="text-sm text-gray-500">Anketi Dolduran</span>
                                                            <p className="text-gray-800 font-medium">{fillerName || "-"}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Summary Stats */}
                                                <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6 p-6">
                                                    <h2 className="text-lg font-semibold text-gray-800 mb-4">Özet</h2>
                                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                                        <div className="text-center p-4 bg-gray-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-gray-800">{getTotalQuestions()}</p>
                                                            <p className="text-sm text-gray-500">Toplam Soru</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-blue-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-blue-600">{getAnsweredCount()}</p>
                                                            <p className="text-sm text-gray-500">Cevaplanan</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-green-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-green-600">{getEvetCount()}</p>
                                                            <p className="text-sm text-gray-500">Evet</p>
                                                        </div>
                                                        <div className="text-center p-4 bg-red-50 rounded-lg">
                                                            <p className="text-3xl font-bold text-red-600">{getHayirCount()}</p>
                                                            <p className="text-sm text-gray-500">Hayır</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Clause Reviews */}
                                                {allClauses.map((clause) => (
                                                    <div key={clause.id} className="bg-white rounded-lg border border-gray-200 shadow-sm mb-6">
                                                        <div className="p-6 border-b border-gray-100">
                                                            <h2 className="text-lg font-semibold text-gray-800">{clause.title}</h2>
                                                            <p className="text-sm text-gray-500 mt-1">{clause.subtitle}</p>
                                                        </div>
                                                        <div className="p-6">
                                                            {clause.questions.map((question, idx) => {
                                                                ////console.log("question ", question)
                                                                const answer = question.answer
                                                                ////console.log("answers ", answer)
                                                                //////console.log("answer ", answer)
                                                                const display = getAnswerDisplay(answer);
                                                                const questionFiles = files[question.id];
                                                                return (
                                                                    <div key={question.id} className="py-3 border-b border-gray-100 last:border-b-0">
                                                                        <div className="flex items-start justify-between gap-4">
                                                                            <div className="flex-1">
                                                                                <p className="text-gray-700 text-sm">
                                                                                    <span className="font-medium text-gray-500 mr-2">{idx + 1}.</span>
                                                                                    {question.text}
                                                                                </p>
                                                                                {/* Show uploaded files */}
                                                                                {questionFiles && questionFiles.length > 0 && (
                                                                                    <div className="mt-2 flex flex-wrap gap-2">
                                                                                        {questionFiles.map((file, fileIdx) => (
                                                                                            <span key={fileIdx} className="inline-flex items-center gap-1 text-xs bg-blue-50 text-blue-700 px-2 py-1 rounded">
                                                                                                <HiOutlineDocumentText size={14} />
                                                                                                {file.name}
                                                                                            </span>
                                                                                        ))}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <span className={`px-3 py-1 rounded-full text-sm font-medium ${display.bgColor} ${display.color}`}>
                                                                                {display.text}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                ))}

                                                {/* Action Buttons */}
                                                {(() => {
                                                    const pendingCount = (allQuestionsFlat || []).filter((q) => {
                                                        const ans = String(q.answer || '').trim().toLowerCase();
                                                        const isYes = ans === 'evet' || ans === 'yes';
                                                        const isPending = !q.question_review_status || q.question_review_status === 'Pending';
                                                        return isYes && isPending;
                                                    }).length;
                                                    return (
                                                        <div className="mt-8 mb-6 flex flex-col gap-3">
                                                            {pendingCount > 0 && (
                                                                <div className="flex items-center gap-2 px-4 py-2.5 bg-yellow-50 border border-yellow-200 rounded-lg text-sm text-yellow-800">
                                                                    <IoWarning size={16} className="flex-shrink-0 text-yellow-600" />
                                                                    {pendingCount} "Yes" answer{pendingCount > 1 ? 's' : ''} still pending auditor review. All "Yes" answers must be reviewed before submitting.
                                                                </div>
                                                            )}
                                                            <div className="flex flex-col sm:flex-row gap-4">
                                                                <button
                                                                    onClick={handleBackToSurvey}
                                                                    disabled={submitting}
                                                                    className="flex-1 flex items-center justify-center gap-2 bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium py-4 px-6 rounded-lg transition-colors text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                                                                >
                                                                    <FiEdit2 size={20} />
                                                                    Edit
                                                                </button>
                                                                <button
                                                                    onClick={handleFinalSubmit}
                                                                    disabled={submitting || pendingCount > 0}
                                                                    className="flex-1 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors text-lg disabled:opacity-50 disabled:cursor-not-allowed"
                                                                >
                                                                    {submitting ? (
                                                                        <>
                                                                            <img src={LOADER} alt="Loading..." className="w-5 h-5" />
                                                                            Submitting...
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <IoCheckmarkCircle size={22} />
                                                                            Submit Survey
                                                                        </>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    );
                                                })()}
                                            </>
                                        ) : (
                                            <>
                                                {/* Validation Error */}
                                                {validationError && (
                                                    <div className="mb-6 bg-red-50 border border-red-200 rounded-lg p-4 flex items-center gap-3">
                                                        <IoWarning className="text-red-500 flex-shrink-0" size={24} />
                                                        <p className="text-red-700 font-medium">{validationError}</p>
                                                    </div>
                                                )}

                                           {selectedTemplateId && (
                                                    <div className="bg-white p-6 rounded-2xl border border-gray-200">
                                                        {/* Organization Information Section */}

                                                        {isCustomFramework && (
                                                            <div className="flex items-center justify-between mb-3">
                                                                <div className="text-sm font-semibold text-gray-800">
                                                                    Custom Audit Builder
                                                                </div>

                                                                <button
                                                                    onClick={addClause}
                                                                    className="px-3 py-2 rounded-lg text-sm font-semibold bg-gray-900 text-white hover:bg-gray-800"
                                                                >
                                                                    + Add Clause
                                                                </button>
                                                            </div>
                                                        )}


                                                        <div className="pb-6 border-t border-gray-100">
                                                                            {getActiveClauses().map((clause) => {
                                                                                //console.log("clause ", clause)
                                                                                const clauseQuestions = (clause.questions || []).filter((q) => {
                                                                                    const id = Number(q?.question_id);
                                                                                    return !(id && deletedSet.has(id));
                                                                                });
                                                                const clauseKey =
                                                                    clause._tmpClauseId ?? clause.clause ?? clause.question_id ?? clause.id;

                                                                const isDraftClause = !!clause._tmpClauseId && !clause._isOverlay;

                                                                return (
                                                                    <div key={clauseKey} className="rounded-xl border border-gray-200 overflow-hidden bg-white mt-4">

                                                                        {/* Clause Title Bar */}
                                                                        <div className="px-4 py-3 bg-white border-b border-gray-200 flex items-center justify-between gap-3">

                                                                            {/* LEFT SIDE: Clause label + editable title */}
                                                                            <div className="flex items-center gap-3">
                                                                                {isCustomFramework ? (
                                                                                    <input
                                                                                        value={clause.title || ""}
                                                                                        onChange={(e) => updateClauseTitle(clause, e.target.value)}
                                                                                        placeholder="Clause title…"
                                                                                        className="h-8 px-1 text-sm font-semibold text-gray-800 bg-transparent w-64 outline-none border-none"
                                                                                        style={{ boxShadow: "none" }}
                                                                                    />
                                                                                ) : (
                                                                                    <h3 className="text-sm font-semibold text-gray-800">
                                                                                        {clause.title}
                                                                                    </h3>
                                                                                )}
                                                                            </div>

                                                                            {/* RIGHT SIDE: Actions */}
                                                                            {isCustomFramework && (
                                                                                <div className="flex items-center gap-2">
                                                                                    <span
                                                                                        onClick={() => addQuestionToClause(clause)}
                                                                                        className="text-sm font-medium text-gray-500 hover:text-gray-900 cursor-pointer transition-colors"
                                                                                    >
                                                                                        + Add Question
                                                                                    </span>

                                                                                    {isDraftClause && (
                                                                                        <button
                                                                                            onClick={() => deleteClause(clauseKey)}
                                                                                            className="h-9 w-9 inline-flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:text-red-600 hover:border-red-200 hover:bg-red-50"
                                                                                            title="Delete clause"
                                                                                            aria-label="Delete clause"
                                                                                        >
                                                                                            <TrashIcon />
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        {/* Header */}
                                                                        <div className="grid grid-cols-[2fr_0.8fr_110px_130px] items-center gap-3 px-4 py-3 bg-gray-50 border-b border-gray-200 text-xs font-semibold text-gray-500">
                                                                            <div>Question</div>
                                                                            <div>Answer</div>
                                                                            <div>Owners</div>
                                                                            <div>Status</div>
                                                                        </div>

                                                                        {/* Rows */}
                                                                        <div>
                                                                            {clauseQuestions.map((question) => {
                                                                                const qid = question.question_id ?? question.id ?? question._tmpQuestionId;

                                                                                if (isCustomFramework && question._tmpQuestionId) {
                                                                                    return (
                                                                                        <div
                                                                                            key={qid}
                                                                                            className="px-4 py-3 border-b border-gray-100 grid grid-cols-[2fr_0.8fr_110px_130px] gap-3 items-center"
                                                                                        >
                                                                                            <div>
                                                                                                <input
                                                                                                    value={question.question_text || ""}
                                                                                                    onChange={(e) =>
                                                                                                        updateDraftQuestion(clauseKey, question._tmpQuestionId, { question_text: e.target.value })
                                                                                                    }
                                                                                                    placeholder="Question text…"
                                                                                                    className="w-full h-9 px-3 rounded-lg border border-gray-200 text-sm"
                                                                                                />
                                                                                            </div>

                                                                                            <div className="text-xs text-gray-400">(answer later)</div>

                                                                                            <div className="text-xs text-gray-400">(owner later)</div>

                                                                                            {/* Status column: type dropdown + trash */}
                                                                                            <div className="flex items-center justify-between gap-2">
                                                                                                <select
                                                                                                    value={question.question_type || "yes_no"}
                                                                                                    onChange={(e) =>
                                                                                                        updateDraftQuestion(String(clause.clause), question._tmpQuestionId)
                                                                                                    }
                                                                                                    className="h-9 px-2 rounded-lg border border-gray-200 text-sm flex-1"
                                                                                                >
                                                                                                    <option value="yes_no">yes/no</option>
                                                                                                    <option value="single_choice">single choice</option>
                                                                                                    <option value="multi_choice">multi choice</option>
                                                                                                    <option value="text">text</option>
                                                                                                    <option value="number">number</option>
                                                                                                    <option value="date">date</option>
                                                                                                </select>

                                                                                                <button
                                                                                                    onClick={() =>deleteDraftQuestion(String(clause.clause), question._tmpQuestionId)}
                                                                                                    className="h-9 w-9 inline-flex items-center justify-center rounded-lg border border-gray-200 text-gray-500 hover:text-red-600 hover:border-red-200 hover:bg-red-50"
                                                                                                    title="Delete question"
                                                                                                    aria-label="Delete question"
                                                                                                >
                                                                                                    <TrashIcon />
                                                                                                </button>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                }

                                                                                return (
                                                                                    <QuestionRow
                                                                                        key={qid}
                                                                                        question={question}
                                                                                        answer={answers?.[qid]}
                                                                                        openQuestionFN={handleOpenQuestion}
                                                                                        isCustomFramework={isCustomFramework}
                                                                                        onDelete={() => requestDeleteQuestion(qid)}
                                                                                    />
                                                                                );
                                                                            })}
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })}
                                                        </div>





                                                        {/* Submit Button */}
                                                        <div className="mt-8 mb-6">
                                                            <button
                                                                onClick={handleGoToReview}
                                                                type="button"
                                                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-4 px-6 rounded-lg transition-colors text-lg"
                                                            >
                                                                Değerlendirmeyi Tamamla ve SOA Tablosuna Geç
                                                            </button>
                                                        </div>

                                                    </div>
                                                )}

                                            </>
                                        )}
                                        {!selectedTemplateId && (
                                            <div className="bg-white p-6 rounded-2xl border border-gray-200">
                                                <div className="flex flex-col items-center text-center py-10">

                                                    {/* Icon */}
                                                    <div className="w-12 h-12 mb-4 rounded-full bg-gray-100 flex items-center justify-center">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            className="w-6 h-6 text-gray-500"
                                                            fill="none"
                                                            viewBox="0 0 24 24"
                                                            stroke="currentColor"
                                                            strokeWidth={1.5}
                                                        >
                                                            <path
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                                d="M9 12h6m-6 4h6M7 4h10a2 2 0 012 2v12a2 2 0 01-2 2H7a2 2 0 01-2-2V6a2 2 0 012-2z"
                                                            />
                                                        </svg>
                                                    </div>

                                                    <h3 className="text-lg font-medium text-gray-900 mb-2">
                                                        No survey selected
                                                    </h3>

                                                    <p className="text-sm text-gray-600 max-w-md">
                                                        To fill out a survey, you first need to start one from the Audits section.
                                                        Once an audit is created, the associated survey will appear here for completion.
                                                    </p>
                                                </div>
                                            </div>
                                        )}


                                    </>
                                )}

                                </>
                                )}

                            </>
                        )}

                    </div>
                </div>
                </div>
            </div>

            <CreateAuditDialog
                open={isCreateAuditOpen}
                onOpenChange={setIsCreateAuditOpen}
                departments={departments}
                complianceStandards={complianceStandarts}
                surveys={templatesRaw}
                onSubmit={handleCreateAudit}
                users={listUsers}
                createAuditFN={createAuditFN}
                getAllSurveysFN={getAllSurveysFN}
                getAllAuditsFN={getAllAuditsFN}
                auditTemplates={audit_templates}
            />

            <EditAuditDialog
                open={edit != null}
                onOpenChange={setIsCreateAuditOpen}
                departments={departments}
                surveys={completedSurveys}
                onSubmit={handleCreateAudit}
                users={listUsers}
                complianceStandards={complianceStandarts}
                createAuditFN={createAuditFN}
                getAllAuditsFN={getAllAuditsFN}
                id={edit}
                setEdit={setEdit}
                getAuditByIdFN={getAuditByIdFN}
                completedSurveys={completedSurveys}
                editAuditFN={editAuditFN}
                auditTemplates={audit_templates}

            />

            <Popup
                open={selectedQuestion != null}
                onClose={handleCloseQuestion}
                modal
                nested
                closeOnDocumentClick
                closeOnEscape
                contentStyle={{
                    overflow: "auto",
                    maxHeight: "80vh",
                    width: "900px",
                    marginTop: "14vh",
                }}
            >
                <div onClick={(e) => e.stopPropagation()}>
                    <QuestionOverlay question_id={selectedQuestion} closeQuestion={handleCloseQuestion} onFindingsNeeded={handleQuestionFindingsNeeded} onViewAction={handleViewAction} onViewFinding={handleViewFinding} />
                </div>
            </Popup>

            <Popup
                open={isFindingOpen}
                onClose={closeFinding}
                modal
                nested
                closeOnDocumentClick
                closeOnEscape
                contentStyle={{
                    overflow: "auto",
                    maxHeight: "80vh",
                    width: "900px",
                    marginTop: "14vh",
                }}
            >
                <div onClick={(e) => e.stopPropagation()}>
                    <FindingOverlay
                        key={findingId || "new_finding"}
                        finding_id={findingId}
                        closeFinding={(data, id, e) => {
                            e?.stopPropagation?.();
                            closeFinding(data, id);
                        }}
                    />
                </div>
            </Popup>


            <Popup
                open={isActionOpen}
                contentStyle={{
                    overflow: "auto",
                    maxHeight: "80vh",
                    width: "900px",
                    marginTop: "14vh",
                }}
            >
                <ActionOverlay
                    closeAction={closeAction}
                    risk_id={null}
                    action_id={action_id}
                />
            </Popup>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}



function Avatar({ name, src, size = 28 }) {
    const [errored, setErrored] = React.useState(false);

    const initials = (name || "")
        .split(" ")
        .map((s) => s[0])
        .filter(Boolean)
        .slice(0, 2)
        .join("")
        .toUpperCase();

    if (!src || errored) {
        return (
            <div
                className="flex items-center justify-center rounded-full border border-gray-300 bg-gray-100 text-gray-500"
                style={{ width: size, height: size }}
                title={name}
            >
                <svg
                    width={Math.floor(size * 0.6)}
                    height={Math.floor(size * 0.6)}
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                >
                    <path d="M10 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 1c-3.33 0-6 1.34-6 3v2h12v-2c0-1.66-2.67-3-6-3Z" />
                </svg>
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={name}
            title={name}
            loading="lazy"
            referrerPolicy="no-referrer"
            className="rounded-full object-cover border border-gray-300 bg-white"
            style={{ width: size, height: size }}
            onError={() => setErrored(true)}
        />
    );
}


export function AuditorsPicker({
    users = [],           
    value = [],          
    onChange = () => { },
    placeholder = "Auditors",
}) {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState("");
    const rootRef = useRef(null);

    // close on outside click
    useEffect(() => {
        function onDocClick(e) {
            if (!rootRef.current) return;
            if (!rootRef.current.contains(e.target)) setOpen(false);
        }
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    
    const userOptions = useMemo(() => {
        console.log(users)
        return (users || []).filter((u) => u.role === "Auditor").map((u) => {
            const id = String(u.value ?? u.user_id ?? u.id ?? "");
            const label =
                u.label ||
                [u.first_name, u.last_name].filter(Boolean).join(" ") ||
                u.name ||
                u.email ||
                `User ${id}`;
            const avatar = u.avatar || u.photo || u.image || "";
            return { value: id, label, avatar };
        });
    }, [users]);

    // ✅ selectedIds as strings
    const selectedIds = useMemo(
        () => new Set((value || []).map((id) => String(id))),
        [value]
    );


    const selected = useMemo(() => {
        const map = new Map(userOptions.map((u) => [u.value, u]));
        return Array.from(selectedIds)
            .map((id) => map.get(id))
            .filter(Boolean);
    }, [userOptions, selectedIds]);

   
    const filtered = useMemo(() => {
        const q = query.trim().toLowerCase();
        if (!q) return userOptions;
        return userOptions.filter(
            (u) =>
                String(u.label).toLowerCase().includes(q) ||
                String(u.value).toLowerCase().includes(q)
        );
    }, [userOptions, query]);

    // show unselected in list (selected are shown in the top section)
    const unselected = filtered.filter((u) => !selectedIds.has(u.value));


    const toggle = (user) => {
        const id = String(user.value);
        const next = new Set(Array.from(selectedIds));
        if (next.has(id)) next.delete(id);
        else next.add(id);
        onChange(Array.from(next));
    };

    const removeId = (id) => {
        const next = new Set(Array.from(selectedIds));
        next.delete(String(id));
        onChange(Array.from(next));
    };

    return (
        <div ref={rootRef} className="relative">
            <div className="flex items-center gap-2">
                <button
                    type="button"
                    className="w-9 h-9 rounded-full border flex items-center justify-center hover:bg-gray-100 text-gray-700 shrink-0"
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((s) => !s);
                    }}
                    aria-expanded={open}
                    aria-label={placeholder}
                    title={placeholder}
                >
                    <svg fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20">
                        <path d="M9 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8ZM6 6a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm-2 5a2 2 0 0 0-2 2c0 1.7.83 2.97 2.13 3.8A9.14 9.14 0 0 0 9 18c.41 0 .82-.02 1.21-.06A5.5 5.5 0 0 1 9.6 17 12 12 0 0 1 9 17a8.16 8.16 0 0 1-4.33-1.05A3.36 3.36 0 0 1 3 13a1 1 0 0 1 1-1h5.6c.18-.36.4-.7.66-1H4Zm10.5 8a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9Zm0-7c.28 0 .5.22.5.5V14h1.5a.5.5 0 0 1 0 1H15v1.5a.5.5 0 0 1-1 0V15h-1.5a.5.5 0 0 1 0-1H14v-1.5c0-.28.22-.5.5-.5Z" />
                    </svg>
                </button>

                <div
                    className="flex items-center"
                    onClick={() => setOpen((s) => !s)}
                    role="button"
                    aria-label="Toggle auditors"
                    title="Auditors"
                >
                    {selected.length === 0 ? (
                        <div className="ml-0">
                            <Avatar name="No auditor" src="" size={28} />
                        </div>
                    ) : (
                        selected.map((u, idx) => (
                            <div key={u.value} className={idx === 0 ? "relative" : "relative ml-1"}>
                                <Avatar name={u.label} src={u.avatar} size={28} />
                                <button
                                    type="button"
                                    className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-white border text-[10px] leading-none flex items-center justify-center hover:bg-gray-100"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        removeId(u.value);
                                    }}
                                    aria-label={`Remove ${u.label}`}
                                    title={`Remove ${u.label}`}
                                >
                                    ×
                                </button>
                            </div>
                        ))
                    )}
                </div>
            </div>

            {open && (
                <div className="absolute z-50 mt-2 w-60 rounded-xl border bg-white shadow-xl p-2 overflow-x-hidden">
                    <input
                        type="text"
                        placeholder="Search people…"
                        className="w-full border rounded-md px-2 py-1.5 mb-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />

                    {selected.length > 0 && (
                        <>
                            <div className="text-[11px] font-semibold text-gray-500 px-1 mb-1">
                                Selected
                            </div>
                            <ul className="max-h-40 overflow-y-auto mb-2">
                                {selected.map((u) => (
                                    <li
                                        key={`sel-${u.value}`}
                                        className="flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 cursor-pointer bg-blue-50 hover:bg-blue-100"
                                        onClick={() => toggle(u)}
                                    >
                                        <div className="flex items-center gap-2 min-w-0">
                                            <Avatar name={u.label} src={u.avatar} size={22} />
                                            <span className="text-sm truncate">{u.label}</span>
                                        </div>
                                        <span className="text-xs text-blue-600 shrink-0">×</span>
                                    </li>
                                ))}
                            </ul>
                            <div className="h-px bg-gray-200 my-2" />
                        </>
                    )}

                    <div className="text-[11px] font-semibold text-gray-500 px-1 mb-1">
                        All members
                    </div>
                    <ul className="max-h-56 overflow-y-auto">
                        {unselected.length === 0 && (
                            <li className="text-sm text-gray-500 px-2 py-2">No matches.</li>
                        )}
                        {unselected.map((u) => (
                            <li
                                key={u.value}
                                className="flex items-center justify-between gap-2 rounded-lg px-2 py-1.5 cursor-pointer hover:bg-gray-50"
                                onClick={() => toggle(u)}
                            >
                                <div className="flex items-center gap-2 min-w-0">
                                    <Avatar name={u.label} src={u.avatar} size={22} />
                                    <span className="text-sm truncate">{u.label}</span>
                                </div>
                                <span className="text-xs text-blue-600 shrink-0">+</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
const mapStateToProps = (state) => {
    console.log("Complated SUrvyes ",state.audits?.surveys,)
    return {
        token: state.auth.token,
        allRisks: state.risk.all_risks_report || [],
        audits: state.audits.audits,
        departments: state.department.departments,
        complianceStandarts: state.compliance.complianceStandards,
        users: state.admin.admin_users,
        templatesRaw: state.audits?.survey_templates,
        completedSurveys: state.audits?.surveys,
        resultFindings: state.audits?.findings,
        audit_templates: state.audits?.audit_templates
    };
};

const mapDispatchToProps = (dispatch) => ({
    checkSurveyStatusFN: () => dispatch(checkSurveyStatus()),
    submitSurveyFN: (data) => dispatch(submitSurvey(data)),
    uploadSurveyFileFN: (file, questionId, surveyId) => dispatch(uploadSurveyFile(file, questionId, surveyId)),
    deleteSurveyFileFN: (fileId) => dispatch(deleteSurveyFile(fileId)),
    getAllRisksFN: () => dispatch(getAllRisks_Report()),
    getSOAControlsFN: () => dispatch(getSOAControls()),
    updateSOAControlFN: (soa_id, data) => dispatch(updateSOAControl(soa_id, data)),
    getSurveyFilesFN: (surveyId, questionId) => dispatch(getSurveyFiles(surveyId, questionId)),
    getEvidenceFN: (params) => dispatch(getEvidence(params)),
    deleteEvidenceFN: (evidenceId) => dispatch(deleteEvidence(evidenceId)),
    getAllAuditsFN: () => dispatch(getAllAudits()),
    getAllSurveysFN: () => dispatch(getAllSurveys()),
    getAllSurveysTemplateFN: () => dispatch(getAllSurveysTemplate()),
    getUsersFN: () => dispatch(getUsers()),
    createAuditFN: (payload) => dispatch(createAudit(payload)),
    deleteAuditFN: (id) => dispatch(deleteAudit(id)),
    getAuditByIdFN: (id) => dispatch(getAuditById(id)),
    editAuditFN: (id, payload) => dispatch(editAudit(id, payload)),
    deploySurveyTemplateFN: (data) => dispatch(deploySurveyTemplate(data)),
    getSurveyByIdFN: (id) => dispatch(getSurveyById(id)),
    saveSurveyDraftFN: (data) => dispatch(saveSurveyDraft(data)),
    addFindingsSurveyAIBatchFN: (AIfins, id) => dispatch(addFindingsSurveyAIBatch(AIfins, id)),
    getFindingsBySurveyFN: (id) => dispatch(getFindingsBySurvey(id)),
    getActionsBySurveyFN: (id) => dispatch(getActionsBySurvey(id)),
    getAllSurveyFindingsFN: () => dispatch(getAllSurveyFindings()),
    getAllSurveyActionsFN: () => dispatch(getAllSurveyActions()),
    createActionFromFindingFN: (item) => dispatch(createActionFromFinding(item)),
    updateFindingFN: (data, id) => dispatch(updateFinding(data, id)),
    editActionFN: (risk_id, action_id, action) => dispatch(editAction(risk_id, action_id, action)),
    getAllAuditTemplatesFN: () => dispatch(getAllAuditTemplates()),
    createEmptySurveyQuestionFN: (payload) => dispatch(createEmptySurveyQuestion(payload)),
    deleteFindingFN: (id) => dispatch(deleteFinding(id)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Audit);
